webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Components_PerspectiveCamera__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Components_PerspectiveCamera___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Components_PerspectiveCamera__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_WebGLRenderer__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_WebGLRenderer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Components_WebGLRenderer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Scene__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Scene___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Components_Scene__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Mesh__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Mesh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Components_Mesh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Points__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Points___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Components_Points__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Raycaster__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Raycaster___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Components_Raycaster__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_Object3D__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_Object3D___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Components_Object3D__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Material_MeshPhongMaterial__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Material_MeshPhongMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Material_MeshPhongMaterial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Material_MeshBasicMaterial__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Material_MeshBasicMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Material_MeshBasicMaterial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Material_PointsMaterial__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Material_PointsMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Material_PointsMaterial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Material_MeshPictureMaterial__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Material_MeshPictureMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Material_MeshPictureMaterial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Material_MeshGrungeMaterial__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Material_MeshGrungeMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Material_MeshGrungeMaterial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Material_MeshHiderMaterial__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Material_MeshHiderMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Material_MeshHiderMaterial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Material_MeshShakeMaterial__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Material_MeshShakeMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__Material_MeshShakeMaterial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Material_MeshCanvasMaterial__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Material_MeshCanvasMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__Material_MeshCanvasMaterial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Material_MeshRevealMaterial__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Material_MeshRevealMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Material_MeshRevealMaterial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Geometry_PlaneGeometry__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Geometry_PlaneGeometry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Geometry_PlaneGeometry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Geometry_BoxGeometry__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Geometry_BoxGeometry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__Geometry_BoxGeometry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Geometry_SphereGeometry__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Geometry_SphereGeometry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__Geometry_SphereGeometry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Light_PointLight__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Light_PointLight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__Light_PointLight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Custom_ImageMesh__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Custom_ImageMesh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__Custom_ImageMesh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Custom_CanvasMesh__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Custom_CanvasMesh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__Custom_CanvasMesh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Custom_GrungeMesh__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Custom_GrungeMesh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__Custom_GrungeMesh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Custom_ShakeMesh__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Custom_ShakeMesh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__Custom_ShakeMesh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Custom_RevealMesh__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Custom_RevealMesh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__Custom_RevealMesh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Custom_VMS__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Custom_VMS___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__Custom_VMS__);































/* harmony default export */ __webpack_exports__["a"] = ({
  GrungeMesh: __WEBPACK_IMPORTED_MODULE_22__Custom_GrungeMesh___default.a,
  ImageMesh: __WEBPACK_IMPORTED_MODULE_20__Custom_ImageMesh___default.a,
  CanvasMesh: __WEBPACK_IMPORTED_MODULE_21__Custom_CanvasMesh___default.a,
  ShakeMesh: __WEBPACK_IMPORTED_MODULE_23__Custom_ShakeMesh___default.a,
  RevealMesh: __WEBPACK_IMPORTED_MODULE_24__Custom_RevealMesh___default.a,
  VMS: __WEBPACK_IMPORTED_MODULE_25__Custom_VMS___default.a,

  Object3D: __WEBPACK_IMPORTED_MODULE_6__Components_Object3D___default.a,

  Raycaster: __WEBPACK_IMPORTED_MODULE_5__Components_Raycaster___default.a,
  Points: __WEBPACK_IMPORTED_MODULE_4__Components_Points___default.a,
  SphereGeometry: __WEBPACK_IMPORTED_MODULE_18__Geometry_SphereGeometry___default.a,
  PointLight: __WEBPACK_IMPORTED_MODULE_19__Light_PointLight___default.a,
  BoxGeometry: __WEBPACK_IMPORTED_MODULE_17__Geometry_BoxGeometry___default.a,
  PlaneGeometry: __WEBPACK_IMPORTED_MODULE_16__Geometry_PlaneGeometry___default.a,

  Mesh: __WEBPACK_IMPORTED_MODULE_3__Components_Mesh___default.a,
  MeshPhongMaterial: __WEBPACK_IMPORTED_MODULE_7__Material_MeshPhongMaterial___default.a,
  MeshBasicMaterial: __WEBPACK_IMPORTED_MODULE_8__Material_MeshBasicMaterial___default.a,
  MeshPictureMaterial: __WEBPACK_IMPORTED_MODULE_10__Material_MeshPictureMaterial___default.a,
  MeshGrungeMaterial: __WEBPACK_IMPORTED_MODULE_11__Material_MeshGrungeMaterial___default.a,
  MeshCanvasMaterial: __WEBPACK_IMPORTED_MODULE_14__Material_MeshCanvasMaterial___default.a,
  MeshHiderMaterial: __WEBPACK_IMPORTED_MODULE_12__Material_MeshHiderMaterial___default.a,
  MeshShakeMaterial: __WEBPACK_IMPORTED_MODULE_13__Material_MeshShakeMaterial___default.a,
  MeshRevealMaterial: __WEBPACK_IMPORTED_MODULE_15__Material_MeshRevealMaterial___default.a,

  PointsMaterial: __WEBPACK_IMPORTED_MODULE_9__Material_PointsMaterial___default.a,
  PerspectiveCamera: __WEBPACK_IMPORTED_MODULE_0__Components_PerspectiveCamera___default.a,
  WebGLRenderer: __WEBPACK_IMPORTED_MODULE_1__Components_WebGLRenderer___default.a,
  Scene: __WEBPACK_IMPORTED_MODULE_2__Components_Scene___default.a
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js__);


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      TWEEN: __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default.a,
      tweening: false
    };
  },

  methods: {
    stopAllTween: function stopAllTween() {
      __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default.a.removeAll();
    },
    execTween: function execTween() {
      __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default.a.update();
    },
    fadeOutTween: function fadeOutTween(update, done, attachment) {
      var factor = 1000;
      var varying = {
        opacity: 1 * factor
      };

      if (!attachment) {
        attachment = {};
      }
      if (attachment.fadeIn) {
        attachment.fadeIn.stop();
      }
      attachment.fadeOut = new __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default.a.Tween(varying).to({ opacity: 0 * factor }, 1000).easing(__WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default.a.Easing.Quadratic.Out).onUpdate(function () {
        update(varying.opacity / factor);
      }).onStop(function () {
        done();
      }).onComplete(function () {
        done();
      });
      // if (attachment && attachment.fadeIn) {
      //   attachment.fadeIn.chain(attachment.fadeOut)
      // }
      attachment.fadeOut.start();
      // attachment.fadeOut = attachment.fadeOut
    },
    fadeInTween: function fadeInTween(update, done, attachment) {
      var factor = 1000;
      var varying = {
        opacity: 0 * factor
      };

      if (!attachment) {
        attachment = {};
      }
      if (attachment.fadeOut) {
        attachment.fadeOut.stop();
      }
      attachment.fadeIn = new __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default.a.Tween(varying).to({ opacity: 1 * factor }, 1000).easing(__WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default.a.Easing.Quadratic.Out).onUpdate(function () {
        update(varying.opacity / factor);
      }).onStop(function () {
        done();
      }).onComplete(function () {
        done();
      });
      // if (attachment && attachment.fadeOut) {
      //   attachment.fadeOut.chain(attachment.fadeIn)
      // }
      attachment.fadeIn.start();
    },
    waitSec: function waitSec(delay) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        setTimeout(function () {
          resolve();
        }, delay);
      });
    },
    sleep: function sleep(delay) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        setTimeout(function () {
          resolve();
        }, delay);
      });
    },
    pageFadeIn: function pageFadeIn(el, done) {
      var updater = function updater(mesh) {
        // mesh.visible = true
        // done()
        if (mesh && mesh.material) {
          if (mesh.userData.$component) {
            mesh.visible = mesh.userData.$component.visible;
          } else {
            mesh.visible = true;
          }
          mesh.material.opacity = 1.0;
          if (mesh.material.uniforms) {
            mesh.material.uniforms.opacity.value = 1.0;
          }
          done();

          // if (mesh.userData.$component) {
          //   mesh.visible = mesh.userData.$component.visible
          // } else {
          //   mesh.visible = true
          // }
          // this.fadeInTween((v) => {
          //   this.tweening = true
          //   mesh.material.opacity = v
          //   if (mesh.material.uniforms) {
          //     mesh.material.uniforms.opacity.value = v
          //   }
          // }, () => {
          //   done()
          //   if (mesh.material.uniforms) {
          //     mesh.material.uniforms.opacity.value = 1.0
          //   }
          //   if (mesh.userData.$component) {
          //     mesh.visible = mesh.userData.$component.visible
          //   } else {
          //     mesh.visible = true
          //   }
          //   this.tweening = false
          // }, this.mesh)
        } else {
          mesh.visible = true;
          done();
        }
      };
      if (this.$refs['page-content']) {
        // this.__add(this.$refs['page-content'].object3d)
        this.$refs['page-content'].object3d.children.forEach(updater);
      }

      if (this.$refs['comics-content']) {
        this.$refs['comics-content'].object3d.children.forEach(updater);
      }

      if (this.$refs['sub-page-content'] && this.$refs['sub-page-content'].object3d) {
        this.$refs['sub-page-content'].object3d.children.forEach(updater);
      }

      if (this.$refs['sub-page-content'] && this.$refs['sub-page-content'].$refs['sub-page-content'] && this.$refs['sub-page-content'].$refs['sub-page-content'].object3d) {
        this.$refs['sub-page-content'].$refs['sub-page-content'].object3d.children.forEach(updater);
      }
    },
    pageFadeOut: function pageFadeOut(el, done) {
      var updater = function updater(mesh) {
        if (mesh && mesh.material) {
          mesh.material.opacity = 0.0;
          if (mesh.material.uniforms) {
            mesh.material.uniforms.opacity.value = 0.0;
          }
          mesh.visible = false;
          done();

          // if (mesh.material.uniforms) {
          //   mesh.material.userData.__depthTest = mesh.material.depthTest
          //   mesh.material.depthTest = false
          // }
          // this.fadeOutTween((v) => {
          //   this.tweening = true
          //   mesh.material.opacity = v
          //   if (mesh.material.uniforms) {
          //     mesh.material.uniforms.opacity.value = v
          //   }
          // }, () => {
          //   done()
          //   mesh.visible = false
          //   if (mesh.material.uniforms) {
          //     mesh.material.depthTest = mesh.material.userData.__depthTest
          //     mesh.material.uniforms.opacity.value = 0.0
          //   }

          //   this.tweening = false
          //   // this.__remove(this.$refs['page-content'].object3d)
          // }, this.mesh)
        } else {
          mesh.visible = false;
          done();
        }
      };
      if (this.$refs['page-content']) {
        // this.__add(this.$refs['page-content'].object3d)
        this.$refs['page-content'].object3d.children.forEach(updater);
      }

      if (this.$refs['comics-content']) {
        this.$refs['comics-content'].object3d.children.forEach(updater);
      }

      if (this.$refs['sub-page-content'] && this.$refs['sub-page-content'].object3d) {
        this.$refs['sub-page-content'].object3d.children.forEach(updater);
      }

      if (this.$refs['sub-page-content'] && this.$refs['sub-page-content'].$refs['sub-page-content'] && this.$refs['sub-page-content'].$refs['sub-page-content'].object3d) {
        this.$refs['sub-page-content'].$refs['sub-page-content'].object3d.children.forEach(updater);
      }
    }
  }
});

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__styleContainer", function() { return __styleContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "api", function() { return api; });
/* harmony export (immutable) */ __webpack_exports__["getTemplate"] = getTemplate;
/* harmony export (immutable) */ __webpack_exports__["initLoad"] = initLoad;
/* harmony export (immutable) */ __webpack_exports__["createVisalSetting"] = createVisalSetting;
/* harmony export (immutable) */ __webpack_exports__["updateVisualSetting"] = updateVisualSetting;
/* harmony export (immutable) */ __webpack_exports__["updateVS"] = updateVS;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "llvmsMesh", function() { return llvmsMesh; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__backend_firebase__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_three__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_expr_eval__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_expr_eval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_expr_eval__);







var __styleContainer = {
  random: Math.random(),
  ready: false,
  data: []
};

var api = {
  // listStyle () {
  //   return __styleContainer.data.reduce((accu, item ,key) => {
  //     return accu
  //   }, [])
  // },
  listStyle: function listStyle() {
    return __styleContainer.data;
  },
  getStyle: function getStyle(name) {
    return __styleContainer.data.filter(function (item) {
      return item.name === name;
    })[0];
  }
};

function getTemplate(_ref) {
  var name = _ref.name,
      data = _ref.data;

  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    type: 'mesh',
    name: name,
    position: {
      x: 0.0,
      x_formula: 'x * aspect',
      y: 0.0,
      y_formula: '-y * aspect + top - (meshHeight * scaleY) * 0.5 + 50 * scaleY * 0',
      z: 0.0,
      z_formula: 'z'
    },
    scale: {
      x: 1 / 2,
      x_formula: 'aspect',
      y: 1 / 2,
      y_formula: 'aspect',
      z: 1.0,
      z_formula: '1.0'
    },
    translate: {
      x: 0.0,
      x_formula: '0.0',
      y: 0.0,
      y_formula: '0.0',
      z: 0.0,
      z_formula: '0.0'
    },
    size: {
      x: 0.0,
      x_formula: 'meshWidth',
      y: 0.0,
      y_formula: 'meshHeight',
      z: 0.0,
      z_formula: '0.0'
    },
    grunge: {
      gOpacity: 50,
      gOpacity_formula: 'gOpacity / 100',
      gColor: 0xbababa,
      gColor_formula: '0xbababa'
    }
  }, data);
}

function initLoad() {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__backend_firebase__["getStyles"]().then(function (data) {
      // console.log(data)
      __styleContainer.data = data;
      polyfill(__styleContainer.data);
      useRealtime().then(function () {
        resolve();
        __styleContainer.ready = true;
      });
    }).catch(function () {
      useRealtime().then(function () {
        resolve();
        __styleContainer.ready = true;
      });
    });
  });
}

function useRealtime() {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (__WEBPACK_IMPORTED_MODULE_3__backend_firebase__["appState"].useCMS) {
      __WEBPACK_IMPORTED_MODULE_3__backend_firebase__["readyRT"]().then(function () {
        var ref = __WEBPACK_IMPORTED_MODULE_3__backend_firebase__["api"].db.ref('/cms-data/styles');
        ref.on('value', function (snapshot) {
          var val = snapshot.val();
          __styleContainer.data = __WEBPACK_IMPORTED_MODULE_3__backend_firebase__["transform"](val);
          polyfill(__styleContainer.data);
          __styleContainer.random = Math.random();
          console.log(__styleContainer.data);
          resolve();
        });
      });
    } else {
      resolve();
    }
  });
}

function polyfill(array) {
  array.forEach(function (item, key) {
    array[key] = getTemplate({ name: item.name, data: item });
  });
}

function createVisalSetting(obj) {
  if (__WEBPACK_IMPORTED_MODULE_3__backend_firebase__["appState"].useCMS) {
    __WEBPACK_IMPORTED_MODULE_3__backend_firebase__["readyRT"]().then(function () {
      __WEBPACK_IMPORTED_MODULE_3__backend_firebase__["api"].db.ref('/cms-data/styles/' + obj.name).set(obj);
    });
  }
}

function updateVisualSetting(key, obj) {
  if (__WEBPACK_IMPORTED_MODULE_3__backend_firebase__["appState"].useCMS) {
    __WEBPACK_IMPORTED_MODULE_3__backend_firebase__["readyRT"]().then(function () {
      var updates = {};
      updates['' + key] = __WEBPACK_IMPORTED_MODULE_3__backend_firebase__["cleanKey"](obj);
      __WEBPACK_IMPORTED_MODULE_3__backend_firebase__["api"].db.ref('/cms-data/styles/').update(updates);
    });
  }
}

function updateVS(obj) {
  // if (obj.scale.x_formula) {
  //   obj.scale.x = Parser.evaluate(obj.scale.x_formula, { x: 3 }) || 1
  // }
  // if (obj.scale.y_formula) {
  //   obj.scale.y = Parser.evaluate(obj.scale.y_formula, { x: 3 }) || 1
  // }
  updateVisualSetting(obj['.key'], obj);
}

var llvmsMesh = {
  props: ['vms'],
  data: function data() {
    return {
      vmsObj: null,
      localRefresher: 0,
      __styleContainer: __styleContainer
    };
  },
  mounted: function mounted() {
    // if (this.vms) {
    //   this.mesh.visible = false
    // }
    this.mesh.userData.$component = this;
    this.__llvms__updateVMSObjRef();
  },

  computed: {
    finalPosition: function finalPosition() {
      if (this.vmsObj) {
        var rectInfo = this.__llvms__getRect({ vms: this.vmsObj });
        var params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, rectInfo, this.vmsObj.position);
        try {
          var ans = {
            x: __WEBPACK_IMPORTED_MODULE_5_expr_eval__["Parser"].evaluate(this.vmsObj.position.x_formula || '0.0', params),
            y: __WEBPACK_IMPORTED_MODULE_5_expr_eval__["Parser"].evaluate(this.vmsObj.position.y_formula || '0.0', params),
            z: __WEBPACK_IMPORTED_MODULE_5_expr_eval__["Parser"].evaluate(this.vmsObj.position.z_formula || '0.0', params)
          };
          this.$emit('final-position', { pos: ans, params: params });
          return ans;
        } catch (e) {
          return false;
        }
      } else {
        return this.position;
      }
    },
    finalScale: function finalScale() {
      if (this.vmsObj) {
        var rectInfo = this.__llvms__getRect({ vms: this.vmsObj });
        var params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, rectInfo, this.vmsObj.scale);
        try {
          return {
            x: __WEBPACK_IMPORTED_MODULE_5_expr_eval__["Parser"].evaluate(this.vmsObj.scale.x_formula || '0.5', params),
            y: __WEBPACK_IMPORTED_MODULE_5_expr_eval__["Parser"].evaluate(this.vmsObj.scale.y_formula || '0.5', params),
            z: __WEBPACK_IMPORTED_MODULE_5_expr_eval__["Parser"].evaluate(this.vmsObj.scale.z_formula || '1.0', params)
          };
        } catch (e) {
          return false;
        }
      } else {
        return this.scale;
      }
    },
    finalTranslate: function finalTranslate() {
      if (this.vmsObj) {
        var rectInfo = this.__llvms__getRect({ vms: this.vmsObj });
        var params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, rectInfo, this.vmsObj.translate);
        try {
          return {
            x: __WEBPACK_IMPORTED_MODULE_5_expr_eval__["Parser"].evaluate(this.vmsObj.translate.x_formula || '0.0', params),
            y: __WEBPACK_IMPORTED_MODULE_5_expr_eval__["Parser"].evaluate(this.vmsObj.translate.y_formula || '0.0', params),
            z: __WEBPACK_IMPORTED_MODULE_5_expr_eval__["Parser"].evaluate(this.vmsObj.translate.z_formula || '0.0', params)
          };
        } catch (e) {
          return false;
        }
      } else {
        return this.translate;
      }
    },
    finalSize: function finalSize() {
      if (this.vmsObj && this.vmsObj.size) {
        var rectInfo = this.__llvms__getRect({ vms: this.vmsObj });
        var params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, rectInfo, this.vmsObj.size);
        try {
          return {
            x: __WEBPACK_IMPORTED_MODULE_5_expr_eval__["Parser"].evaluate(this.vmsObj.size.x_formula || '0.0', params),
            y: __WEBPACK_IMPORTED_MODULE_5_expr_eval__["Parser"].evaluate(this.vmsObj.size.y_formula || '0.0', params),
            z: __WEBPACK_IMPORTED_MODULE_5_expr_eval__["Parser"].evaluate(this.vmsObj.size.z_formula || '0.0', params)
          };
        } catch (e) {
          return false;
        }
      } else {
        return {
          x: this.sWidth,
          y: this.sHeight,
          z: this.sDepth
        };
      }
    },
    finalGrunge: function finalGrunge() {
      if (this.vmsObj && this.vmsObj.grunge) {
        var rectInfo = this.__llvms__getRect({ vms: this.vmsObj });
        var params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, rectInfo, this.vmsObj.grunge);
        try {
          return {
            gOpacity: __WEBPACK_IMPORTED_MODULE_5_expr_eval__["Parser"].evaluate(this.vmsObj.grunge.gOpacity_formula || '0.0', params),
            gColor: __WEBPACK_IMPORTED_MODULE_5_expr_eval__["Parser"].evaluate(this.vmsObj.grunge.gColor_formula || '0.0', params)
          };
        } catch (e) {
          return false;
        }
      } else {
        return {
          gOpacity: this.gOpacity,
          gColor: this.color
        };
      }
    },
    readRectInfo: function readRectInfo() {
      var rectInfo = this.__llvms__getRect({ vms: this.vmsObj });
      return rectInfo;
    },
    __llvms__readyStyles: function __llvms__readyStyles() {
      if (this.__styleContainer) {
        return this.__styleContainer.ready;
      }
      return __styleContainer.ready;
    },
    __llvms__styleRemoteRefresh: function __llvms__styleRemoteRefresh() {
      if (this.__styleContainer) {
        return this.__styleContainer.random;
      }
      return __styleContainer.random;
    },
    __llvms__styles: function __llvms__styles() {
      if (this.__styleContainer) {
        return this.__styleContainer.data;
      }
      return __styleContainer.data;
    },
    __llvms__vmsLocalRefresh: function __llvms__vmsLocalRefresh() {
      if (this.vmsObj) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.vmsObj) + this.localRefresher;
      }
    },
    __llvms__vmsRemoteRefresh: function __llvms__vmsRemoteRefresh() {
      if (this.vmsObj) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.__llvms__styleRemoteRefresh);
      }
    }
  },
  watch: {
    __llvms__readyStyles: function __llvms__readyStyles() {
      // if (this.vms) {
      //   this.mesh.visible = this.visible
      // }
      this.__llvms__updateVMSObjRef();
    },
    __llvms__vmsRemoteRefresh: function __llvms__vmsRemoteRefresh() {
      this.__llvms__updateVMSObjRef();
      this.__llvms__update();
    },
    __llvms__vmsLocalRefresh: function __llvms__vmsLocalRefresh() {
      this.__llvms__update();
    }
  },
  activated: function activated() {
    this.__llvms__updateVMSObjRef();
  },

  methods: {
    loadVMS: function loadVMS() {
      this.__llvms__updateVMSObjRef();
    },
    __llvms__updateVMSObjRef: function __llvms__updateVMSObjRef() {
      if (this.vms && this.__llvms__readyStyles) {
        var vmsObj = this.vmsObj = this.mesh.userData.vms = this.__llvms__find(this.vms);
        if (!vmsObj) {
          createVisalSetting(this.__llvms__getTemplate({ name: this.vms, data: {} }));
        }
      }
    },
    __llvms__getTemplate: function __llvms__getTemplate(_ref2) {
      var name = _ref2.name;

      return getTemplate({ name: name });
    },
    __llvms__find: function __llvms__find(name) {
      return this.__llvms__styles.filter(function (item) {
        return item.name === name;
      })[0];
    },
    __llvms__getAspect: function __llvms__getAspect() {
      var aspect = this.aspect || this.$parent.aspect || this.$parent.$parent.aspect || this.$parent.$parent.$parent.aspect || this.$parent.$parent.$parent.$parent.aspect || this.$parent.$parent.$parent.$parent.$parent.aspect || this.$parent.$parent.$parent.$parent.$parent.$parent.aspect;
      return aspect;
    },
    __llvms__getCamera: function __llvms__getCamera() {
      var camera = this.camera || this.$parent.camera || this.$parent.$parent.camera || this.$parent.$parent.$parent.camera || this.$parent.$parent.$parent.$parent.camera || this.$parent.$parent.$parent.$parent.$parent.camera || this.$parent.$parent.$parent.$parent.$parent.$parent.camera;
      return camera;
    },
    __llvms__getRect: function __llvms__getRect(_ref3) {
      var vms = _ref3.vms;

      var aspect = this.__llvms__getAspect();
      var camera = this.__llvms__getCamera();

      var meshWidth = this.sWidth;
      var meshHeight = this.sHeight;

      var dist = camera.position.z - (vms.position.z || 0.0);
      var vFOV = __WEBPACK_IMPORTED_MODULE_4_three__["Math"].degToRad(camera.fov); // convert vertical fov to radians
      var screenHeight = 2 * Math.tan(vFOV / 2) * dist; // visible height
      var screenWidth = screenHeight * aspect; // visible width

      var left = -screenWidth * 0.5;
      var top = screenHeight * 0.5;
      var bottom = -top;
      var right = -left;

      var api = {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        aspect: aspect,
        screenHeight: screenHeight,
        screenWidth: screenWidth,
        meshWidth: meshWidth,
        meshHeight: meshHeight,
        scaleX: 0.5,
        scaleY: 0.5,
        scaleZ: 1.0
      };

      try {
        api.scaleX = __WEBPACK_IMPORTED_MODULE_5_expr_eval__["Parser"].evaluate(vms.scale.x_formula || '0.5', api);
        api.scaleY = __WEBPACK_IMPORTED_MODULE_5_expr_eval__["Parser"].evaluate(vms.scale.y_formula || '0.5', api);
        api.scaleZ = __WEBPACK_IMPORTED_MODULE_5_expr_eval__["Parser"].evaluate(vms.scale.z_formula || '1.0', api);
      } catch (e) {}

      return api;
    },
    __llvms__update: function __llvms__update() {
      // var rectInfo = this.__llvms__getRect({ z: this.vmsObj.position.z })
      // // var camera = this.__llvms__getCamera()

      // // console.log('update pos', this.__llvms__calc({ obj: this.vmsObj, key: 'position', prop: 'x' }))
      // if (this.vmsObj && this.mesh) {
      //   if (this.vmsObj.position) {
      //     this.mesh.position.set(
      //       Parser.evaluate(this.vmsObj.position.x_formula || '0.0', { ...rectInfo, ...this.vmsObj.position }),
      //       Parser.evaluate(this.vmsObj.position.y_formula || '0.0', { ...rectInfo, ...this.vmsObj.position }),
      //       Parser.evaluate(this.vmsObj.position.z_formula || '0.0', { ...rectInfo, ...this.vmsObj.position })
      //       // this.__llvms__calc({ obj: this.vmsObj, key: 'position', prop: 'x' }),
      //       // this.__llvms__calc({ obj: this.vmsObj, key: 'position', prop: 'y' }),
      //       // this.__llvms__calc({ obj: this.vmsObj, key: 'position', prop: 'z' })
      //     )
      //   }
      //   if (this.vmsObj.scale) {
      //     this.mesh.scale.set(
      //       Parser.evaluate(this.vmsObj.scale.x_formula || '1.0', { ...rectInfo, ...this.vmsObj.scale }),
      //       Parser.evaluate(this.vmsObj.scale.y_formula || '1.0', { ...rectInfo, ...this.vmsObj.scale }),
      //       Parser.evaluate(this.vmsObj.scale.z_formula || '1.0', { ...rectInfo, ...this.vmsObj.scale })
      //       // this.__llvms__calc({ obj: this.vmsObj, key: 'scale', prop: 'x' }),
      //       // this.__llvms__calc({ obj: this.vmsObj, key: 'scale', prop: 'y' }),
      //       // this.__llvms__calc({ obj: this.vmsObj, key: 'scale', prop: 'z' })
      //     )
      //   }

      //   // if (this.vmsObj.transform) {
      //   //   this.mesh.transform.set(
      //   //     Parser.evaluate(this.vmsObj.transform.x_formula || '1.0', { ...rectInfo, ...this.vmsObj.transform }),
      //   //     Parser.evaluate(this.vmsObj.transform.y_formula || '1.0', { ...rectInfo, ...this.vmsObj.transform }),
      //   //     Parser.evaluate(this.vmsObj.transform.z_formula || '1.0', { ...rectInfo, ...this.vmsObj.transform })
      //   //     // this.__llvms__calc({ obj: this.vmsObj, key: 'scale', prop: 'x' }),
      //   //     // this.__llvms__calc({ obj: this.vmsObj, key: 'scale', prop: 'y' }),
      //   //     // this.__llvms__calc({ obj: this.vmsObj, key: 'scale', prop: 'z' })
      //   //   )
      //   // }
      // }
    },
    __llvms__calc: function __llvms__calc(_ref4) {
      var obj = _ref4.obj,
          key = _ref4.key,
          prop = _ref4.prop;

      var mode = obj[key][prop + '_mode'];
      var aspect = this.__llvms__getAspect();

      if (!mode || mode === 'normal') {
        return parseFloat(obj[key][prop]);
      } else if (mode === 'aspect') {
        return parseFloat(obj[key][prop]) * aspect;
      }
    }
  }
};

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appState", function() { return appState; });
/* harmony export (immutable) */ __webpack_exports__["restoreStates"] = restoreStates;
/* harmony export (immutable) */ __webpack_exports__["loginToGoogle"] = loginToGoogle;
/* harmony export (immutable) */ __webpack_exports__["logout"] = logout;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "api", function() { return api; });
/* harmony export (immutable) */ __webpack_exports__["connectFirebase"] = connectFirebase;
/* harmony export (immutable) */ __webpack_exports__["readyRT"] = readyRT;
/* harmony export (immutable) */ __webpack_exports__["cleanKey"] = cleanKey;
/* harmony export (immutable) */ __webpack_exports__["getStyles"] = getStyles;
/* harmony export (immutable) */ __webpack_exports__["transform"] = transform;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);







__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuefire___default.a);

function isset(o) {
  return typeof o !== 'undefined';
}

var appState = {
  vmsLoaded: false,
  useClick: true,
  useCMS: false,
  useRT: false,
  loading: false,
  ready: false,
  user: null,
  get name() {
    if (!appState.user) {
      return '';
    }
    return appState.user.displayName;
  },
  get pic() {
    if (!appState.user) {
      return '';
    }
    return appState.user.photoURL;
  },
  get loggedIn() {
    if (appState.user && isset(appState.user.uid)) {
      return true;
    } else {
      return false;
    }
  }
};

function restoreStates() {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth().onAuthStateChanged(function (user) {
      if (user) {
        // User is signed in.
        // var displayName = user.displayName;
        // var email = user.email;
        // var emailVerified = user.emailVerified;
        // var photoURL = user.photoURL;
        // var isAnonymous = user.isAnonymous;
        // var uid = user.uid;
        // var providerData = user.providerData;
        // ...
        appState.user = user;
        resolve(appState);
      } else {
        appState.user = null;
        // router.push({
        //   path: '/'
        // })
        reject(appState);
      }
      appState.ready = true;
    });
  });
}

var googleLoginProvider;
function loginToGoogle() {
  appState.loading = true;
  googleLoginProvider = googleLoginProvider || new __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth.GoogleAuthProvider();
  __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth().signInWithPopup(googleLoginProvider).then(function (result) {
    // This gives you a Google Access Token. You can use it to access the Google API.
    // var token = result.credential.accessToken
    // The signed-in user info.
    var user = result.user;
    // ...
    appState.user = user;
    appState.loading = false;
  }).catch(function (error) {
    // Handle Errors here.
    // var errorCode = error.code

    var errorMessage = error.message;
    // The email of the user's account used.
    // var email = error.email
    // The firebase.auth.AuthCredential type that was used.
    // var credential = error.credential
    // ...

    appState.user = null;
    appState.loading = false;
    console.log(errorMessage);
  });
}

function logout() {
  appState.loading = true;
  __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth().signOut().then(function () {
    appState.user = null;
    appState.loading = false;
  }).catch(function () {
    appState.user = null;
    appState.loading = false;
  });
}

var api = {};
function connectFirebase() {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (!api.firebase) {
      api.firebase = __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.initializeApp({
        apiKey: 'AIzaSyBJaCgoUfzKM5be6DAQvB48tKmbqlqtHTE',
        authDomain: 'loklokcms.firebaseapp.com',
        databaseURL: 'https://loklokcms.firebaseio.com',
        projectId: 'loklokcms',
        storageBucket: 'loklokcms.appspot.com',
        messagingSenderId: '902996908267'
      });
      api.db = api.firebase.database();
      api.storage = __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.storage();
    }
    resolve(api);
  }).then(function () {
    return restoreStates();
  });
}

function readyRT() {
  return connectFirebase().catch(function () {
    console.log('error: readyRealTime');
  });
}

function cleanKey(obj) {
  obj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, obj);
  delete obj['.key'];
  return obj;
}

function getStyles() {
  return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('https://loklokcms.firebaseio.com/cms-data/styles.json').then(function (response) {
    return transform(response.data);
  });
}

function transform(obj) {
  var bucket = [];
  var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj);
  for (var i = 0; i < keys.length; i++) {
    bucket.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      '.key': keys[i]
    }, obj[keys[i]]));
  }
  return bucket;
}

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

// import TWEEN from '@tweenjs/tween.js'
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // TWEEN,
      scrollerTarget: false,
      scrollStack: {},
      srAFID: 0,
      scrollerState: {
        tsX: 0,
        tsY: 0,
        dX: 0,
        dY: 0,
        status: '',
        enable: {
          x: false,
          y: true
        },
        bound: {
          yMax: 0,
          yMin: 0,
          xMax: 0,
          xMin: 0
        }
      }
    };
  },

  computed: {},
  methods: {
    scrollEntry: function scrollEntry(args) {
      for (var stackKey in this.scrollStack) {
        var setMouse = this.scrollStack[stackKey];
        if (setMouse) {
          setMouse(args);
        }
      }
    },
    emitHandler: function emitHandler() {
      this.$emit('setMouse', this.scrollEntry);
    },
    tryMaximiseScroller: function tryMaximiseScroller(_ref) {
      var pos = _ref.pos,
          extra = _ref.extra,
          params = _ref.params;

      this.scrollerState.bound.yMax = -pos.y * 1.25 - params.meshHeight + (extra || 0);
    },
    setupScroller: function setupScroller(_ref2) {
      var _this = this;

      var target = _ref2.target,
          enable = _ref2.enable,
          bound = _ref2.bound;

      // if (!this.mouseStack) {
      //   this.$emit('setMouse', this.scrollEntry)
      // }

      if (bound) {
        this.scrollerState.bound = bound;
      }
      this.scrollStack.scrollMe = this.scrollMe;
      this.scrollerTarget = target;
      if (this.scrollerState.enable) {
        this.scrollerState.enable = enable;
      }

      var rAF = function rAF() {
        if (_this.scrollerState.enable.y) {
          _this.scrollerTarget.object3d.position.y -= _this.scrollerState.dY;
          _this.scrollerState.dY *= 0.954321;
          _this.scrollerPYFast({ bound: _this.scrollerState.bound });
        }
        if (_this.scrollerState.enable.x) {
          _this.scrollerTarget.object3d.position.x += _this.scrollerState.dX;
          _this.scrollerState.dX *= 0.954321;
        }
        _this.srAFID = window.requestAnimationFrame(rAF);
      };
      this.srAFID = window.requestAnimationFrame(rAF);
    },
    scrollerPYFast: function scrollerPYFast(_ref3) {
      var bound = _ref3.bound;

      if (this.scrollerTarget) {
        if (this.scrollerTarget.object3d.position.y > bound.yMax) {
          var varying = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.scrollerTarget.object3d.position);
          varying.y -= (varying.y - bound.yMax) * 0.24;
          this.scrollerTarget.object3d.position.set(varying.x, varying.y, varying.z);
        }
        if (this.scrollerTarget.object3d.position.y < bound.yMin) {
          var _varying = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.scrollerTarget.object3d.position);
          _varying.y -= (_varying.y - bound.yMin) * 0.24;
          this.scrollerTarget.object3d.position.set(_varying.x, _varying.y, _varying.z);
        }
      }
    },
    scrollMe: function scrollMe(args) {
      switch (args.type) {
        case 'ts':
          this.scrollerTouchStart(args);
          break;
        case 'tm':
          this.scrollerTouchMove(args);
          break;
        case 'te':
          this.scrollerTouchEnd(args);
          break;
        case 'wheel':
          this.scrollerWheel(args);
          break;
      }
    },
    scrollerTouchStart: function scrollerTouchStart(_ref4) {
      var pageX = _ref4.pageX,
          pageY = _ref4.pageY,
          rect = _ref4.rect;

      this.scrollerState.status = 'ts';
      this.scrollerState.tsX = pageX - rect.left;
      this.scrollerState.tsY = pageY - rect.top;
    },
    scrollerTouchMove: function scrollerTouchMove(_ref5) {
      var pageX = _ref5.pageX,
          pageY = _ref5.pageY,
          rect = _ref5.rect;

      this.scrollerState.status = 'tm';

      this.scrollerState.dX = pageX - rect.left - this.scrollerState.tsX;
      this.scrollerState.dY = pageY - rect.top - this.scrollerState.tsY;

      this.scrollerState.tsX = pageX - rect.left;
      this.scrollerState.tsY = pageY - rect.top;

      this.scrollerState.dX *= 0.1;
      this.scrollerState.dY *= 0.1;
    },
    scrollerWheel: function scrollerWheel(_ref6) {
      var deltaX = _ref6.deltaX,
          deltaY = _ref6.deltaY;

      this.scrollerState.status = 'tm';

      this.scrollerState.dX = deltaX;
      this.scrollerState.dY = -deltaY;

      this.scrollerState.dX *= 0.1;
      this.scrollerState.dY *= 0.1;
    },
    scrollerTouchEnd: function scrollerTouchEnd() {},
    cleanupScroller: function cleanupScroller() {
      this.$emit('setMouse', function () {});
      window.cancelAnimationFrame(this.srAFID);
    }
  }
});

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(366)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(595),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c224c16",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(388)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(282),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d861101e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return textureCache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return preLoad; });
/* harmony export (immutable) */ __webpack_exports__["e"] = getFonts;
/* unused harmony export fontLinks */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return startAnimationLinks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return homeLinks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return menuLinks; });
/* unused harmony export agreePageLinks */
/* unused harmony export recordPageLinks */
/* unused harmony export resultPageLinks */
/* unused harmony export loginPageLinks */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return preloadBundle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_three__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var textureCache = {
  image: {},
  cache: {},
  setCache: function setCache(link) {
    var cachedItem = textureCache.cache[link];
    if (!cachedItem) {
      textureCache.cache[link] = new __WEBPACK_IMPORTED_MODULE_1_three__["TextureLoader"]().load(link, function (texture) {
        textureCache.cache[link].needsUpdate = true;
      });
    }
  },
  getTexture: function getTexture(link) {
    textureCache.setCache(link);
    return textureCache.cache[link];
  }
};

var preLoad = function preLoad(links, progress) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var loaded = 0;
    links.map(function (link) {
      // if (textureCache.cache[link]) {
      //   loaded++
      //   var currentVal = loaded / links.length
      //   if (progress) {
      //     progress(currentVal)
      //   }
      //   if (currentVal === 1) {
      //     resolve()
      //   }
      //   return {
      //     texture: textureCache.cache[link],
      //     link
      //   }
      // }

      function makePowerOfTwo(image) {
        var _Math = __WEBPACK_IMPORTED_MODULE_1_three__["Math"];
        var canvas = document.createElementNS('http://www.w3.org/1999/xhtml', 'canvas');
        canvas.width = _Math.nearestPowerOfTwo(image.width);
        canvas.height = _Math.nearestPowerOfTwo(image.height);
        var context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        console.info('Preprocess:: THREE.WebGLRenderer: image is not power of two (' + image.width + 'x' + image.height + '). Resized to ' + canvas.width + 'x' + canvas.height, image);
        return canvas;
      }

      var image = new Image();
      textureCache.image[link] = image;
      image.onload = function () {
        textureCache.cache[link] = new __WEBPACK_IMPORTED_MODULE_1_three__["CanvasTexture"](makePowerOfTwo(image));
        textureCache.cache[link].needsUpdate = true;

        loaded++;
        var currentVal = loaded / links.length;
        if (progress) {
          progress(currentVal);
        }
        if (currentVal === 1) {
          resolve();
          // window.requestAnimationFrame(done)
        }
      };
      image.src = link;

      // textureCache.cache[link] = new THREE.TextureLoader().load(link, (texture) => {
      //   textureCache.cache[link].needsUpdate = true
      //   loaded++
      //   var currentVal = loaded / links.length
      //   if (progress) {
      //     progress(currentVal)
      //   }
      //   if (currentVal === 1) {
      //     resolve()
      //     // window.requestAnimationFrame(done)
      //   }
      // })
      // return {
      //   texture: textureCache.cache[link],
      //   link
      // }
    });
  });
};

function getFonts() {
  return fontLinks.map(function (link) {
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(link);
  });
}

var fontLinks = [__webpack_require__(524), __webpack_require__(523), __webpack_require__(525)];

var startAnimationLinks = [__webpack_require__(194), __webpack_require__(193), __webpack_require__(191), __webpack_require__(192)];

var homeLinks = [__webpack_require__(167), __webpack_require__(479), __webpack_require__(480), __webpack_require__(481), __webpack_require__(482), __webpack_require__(483)];

var menuLinks = [__webpack_require__(196), __webpack_require__(197), __webpack_require__(198), __webpack_require__(199), __webpack_require__(200)];

var agreePageLinks = [__webpack_require__(476), __webpack_require__(162), __webpack_require__(166), __webpack_require__(164), __webpack_require__(163), __webpack_require__(165), __webpack_require__(161), __webpack_require__(160), __webpack_require__(159)];

var recordPageLinks = [__webpack_require__(178), __webpack_require__(179)];

var resultPageLinks = [__webpack_require__(188), __webpack_require__(186), __webpack_require__(185), __webpack_require__(184), __webpack_require__(190), __webpack_require__(183), __webpack_require__(182), __webpack_require__(181), __webpack_require__(180), __webpack_require__(187), __webpack_require__(189)];

var loginPageLinks = [__webpack_require__(176), __webpack_require__(172), __webpack_require__(174), __webpack_require__(175), __webpack_require__(173), __webpack_require__(177)];

var preloadBundle = [].concat(loginPageLinks, resultPageLinks, recordPageLinks, startAnimationLinks, agreePageLinks);

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(363)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(592),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-55c40504",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return glSystem; });
var glSystem = {
  _busy: false,
  _busy_timer: 0,
  set busy(v) {
    if (v) {
      glSystem._busy = true;
      clearTimeout(glSystem._busy_timer);
      glSystem._busy_timer = setTimeout(function () {
        glSystem._busy = false;
      }, 100);
    } else {
      glSystem._busy = false;
    }
  },

  get isBusy() {
    return glSystem._busy;
  }
};

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/l-1.7cfa6f5.png";

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/l-2.12e5fe3.png";

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/l-3.42dba6a.png";

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/l-4.cd711de.png";

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(353)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(585),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(381)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(608),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/agree-rule.2b969f8.png";

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/box-checked.fae7971.png";

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/box-unchecked.48ad9ec.png";

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rex.98a757e.png";

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/punch-about.0109413.png";

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/punch-icon.8910fe1.png";

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/enter.dfd5925.png";

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/title.87fe578.png";

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/boxing.b9086c0.jpg";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/la-1.12867ed.png";

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/la-2.fcaf863.png";

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/la-3.e3c714d.png";

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/la-4.29bf305.png";

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hider.da9f21a.png";

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login-email-text.f2343b5.png";

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login-facebook.20884d3.png";

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login-field-desc.556a298.png";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login-start-game.6ec05f4.png";

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login-submit.0aa36c7.png";

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/punch-num-desc.1d58515.png";

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/time-remain-desc.fcc91ab.png";

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/share-btn.cd4fc59.png";

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/share-rule-txt.91bdbdf.png";

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/share-txt.9c90438.png";

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/check-coupon.162a54e.png";

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/coupon-box-btn-nike.acd629f.png";

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/coupon-box-btn-rule.9f4ea0a.png";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/coupon-box-text.82ddc4f.png";

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/daily-task-box.b4642fc.png";

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hider-reverse.fadfb8c.png";

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/punch-number-desc.ef2502f.png";

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/try-again.de80094.png";

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hider-reverse.fadfb8c.png";

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/start-icon.f7bb93e.png";

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/white-ball-text.a7f54d0.png";

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/white-ball.e742ff9.png";

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/btn-nike.be1b207.png";

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/boxing-camp.2f67d66.png";

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/comics.0fa103d.png";

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home.bc9fba5.png";

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rewards.faac119.png";

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rules.144dc5c.png";

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(346)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(578),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1a7b2c8a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(393)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(286),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ebc558b8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(387)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(287),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d8529024",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(344)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(290),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-150827e0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(356)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(291),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e8e82ce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(385)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(292),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cf113a50",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LayoutHTML_Prototype__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LayoutHTML_Prototype___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_LayoutHTML_Prototype__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Prototypes_Preview__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Prototypes_Preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Prototypes_Preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Prototypes_Scene_Ball__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Prototypes_Scene_Ball___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Prototypes_Scene_Ball__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Prototypes_Scene_Fun__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Prototypes_Scene_Fun___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Prototypes_Scene_Fun__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Prototypes_Scene_Red__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Prototypes_Scene_Red___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Prototypes_Scene_Red__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Prototypes_Scene_Woody__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Prototypes_Scene_Woody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Prototypes_Scene_Woody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_LayoutHTML_Nike__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_LayoutHTML_Nike___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_LayoutHTML_Nike__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_NikeWebGL_Game__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_NikeWebGL_Game___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_NikeWebGL_Game__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_NikeWebGL_Pages_BoxingCamp_BoxingCamp__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_NikeWebGL_Pages_BoxingCamp_BoxingCamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_NikeWebGL_Pages_BoxingCamp_BoxingCamp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_NikeWebGL_Pages_Agree_Agree__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_NikeWebGL_Pages_Agree_Agree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_NikeWebGL_Pages_Agree_Agree__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_NikeWebGL_Pages_Play_Play__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_NikeWebGL_Pages_Play_Play___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_NikeWebGL_Pages_Play_Play__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_NikeWebGL_Pages_Play_Start__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_NikeWebGL_Pages_Play_Start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_NikeWebGL_Pages_Play_Start__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_NikeWebGL_Pages_Play_Countdown__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_NikeWebGL_Pages_Play_Countdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_NikeWebGL_Pages_Play_Countdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_NikeWebGL_Pages_Play_Record__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_NikeWebGL_Pages_Play_Record___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_NikeWebGL_Pages_Play_Record__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_NikeWebGL_Pages_Play_Result__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_NikeWebGL_Pages_Play_Result___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_NikeWebGL_Pages_Play_Result__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_NikeWebGL_Pages_Rules_Rules__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_NikeWebGL_Pages_Rules_Rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_NikeWebGL_Pages_Rules_Rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_NikeWebGL_Pages_DailyTask_DailyTask__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_NikeWebGL_Pages_DailyTask_DailyTask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_NikeWebGL_Pages_DailyTask_DailyTask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_NikeWebGL_Pages_Status_Status__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_NikeWebGL_Pages_Status_Status___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_NikeWebGL_Pages_Status_Status__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_NikeWebGL_Pages_Login_Login__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_NikeWebGL_Pages_Login_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_NikeWebGL_Pages_Login_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_NikeWebGL_Pages_ComicList_ComicList__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_NikeWebGL_Pages_ComicList_ComicList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_NikeWebGL_Pages_ComicList_ComicList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_NikeWebGL_Pages_ComicDetail_ComicDetail__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_NikeWebGL_Pages_ComicDetail_ComicDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_NikeWebGL_Pages_ComicDetail_ComicDetail__);


// import Hello from '@/components/Hello'





























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var nikeGame = [{
  path: 'game',
  component: __WEBPACK_IMPORTED_MODULE_9__components_NikeWebGL_Game___default.a,
  children: [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_10__components_NikeWebGL_Pages_BoxingCamp_BoxingCamp___default.a
  }, {
    path: 'agree',
    component: __WEBPACK_IMPORTED_MODULE_11__components_NikeWebGL_Pages_Agree_Agree___default.a
  }, {
    path: 'play',
    component: __WEBPACK_IMPORTED_MODULE_12__components_NikeWebGL_Pages_Play_Play___default.a,
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_13__components_NikeWebGL_Pages_Play_Start___default.a
    }, {
      path: 'countdown',
      component: __WEBPACK_IMPORTED_MODULE_14__components_NikeWebGL_Pages_Play_Countdown___default.a
    }, {
      path: 'record',
      component: __WEBPACK_IMPORTED_MODULE_15__components_NikeWebGL_Pages_Play_Record___default.a
    }, {
      path: 'result',
      component: __WEBPACK_IMPORTED_MODULE_16__components_NikeWebGL_Pages_Play_Result___default.a
    }]
  }, {
    path: 'status',
    component: __WEBPACK_IMPORTED_MODULE_19__components_NikeWebGL_Pages_Status_Status___default.a
  }, {
    path: 'rules',
    component: __WEBPACK_IMPORTED_MODULE_17__components_NikeWebGL_Pages_Rules_Rules___default.a
  }, {
    path: 'comic-list',
    component: __WEBPACK_IMPORTED_MODULE_21__components_NikeWebGL_Pages_ComicList_ComicList___default.a
  }, {
    path: 'comic-detail/:id',
    component: __WEBPACK_IMPORTED_MODULE_22__components_NikeWebGL_Pages_ComicDetail_ComicDetail___default.a
  }, {
    path: 'daily-task',
    component: __WEBPACK_IMPORTED_MODULE_18__components_NikeWebGL_Pages_DailyTask_DailyTask___default.a
  }, {
    path: 'login',
    component: __WEBPACK_IMPORTED_MODULE_20__components_NikeWebGL_Pages_Login_Login___default.a
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    redirect: '/nike/game'
    // name: 'Hello',
    // component: Hello
  }, {
    path: '/nike',
    component: __WEBPACK_IMPORTED_MODULE_8__components_LayoutHTML_Nike___default.a,
    children: nikeGame
  }, {
    path: '/cms',
    component: __WEBPACK_IMPORTED_MODULE_8__components_LayoutHTML_Nike___default.a,
    children: nikeGame
  }, {
    path: '/prototypes',
    component: __WEBPACK_IMPORTED_MODULE_2__components_LayoutHTML_Prototype___default.a,
    redirect: '/prototypes/scene/ball',
    children: [{
      path: 'scene',
      name: 'Preview',
      component: __WEBPACK_IMPORTED_MODULE_3__components_Prototypes_Preview___default.a,
      redirect: '/prototypes/scene/ball',
      children: [{
        path: 'ball',
        component: __WEBPACK_IMPORTED_MODULE_4__components_Prototypes_Scene_Ball___default.a
      }, {
        path: 'fun',
        component: __WEBPACK_IMPORTED_MODULE_5__components_Prototypes_Scene_Fun___default.a
      }, {
        path: 'red',
        component: __WEBPACK_IMPORTED_MODULE_6__components_Prototypes_Scene_Red___default.a
      }, {
        path: 'woody',
        component: __WEBPACK_IMPORTED_MODULE_7__components_Prototypes_Scene_Woody___default.a
      }]
    }]
  }]
}));

/***/ }),
/* 208 */,
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(370)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(598),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js__);
/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var refresher = _ref.refresher;

  var pxr = 1.0;
  var api = {};
  var size = 512 * pxr;

  // function imager (src) {
  //   var image = new Image()
  //   image.src = src
  //   var result = { image, ready: false }
  //   image.onload = () => {
  //     result.ready = true
  //   }
  //   return result
  // }

  // var images = {
  //   'box-btn-comics': imager(require('../img/shake/box-btn-comics.png')),
  //   'box-btn-game': imager(require('../img/shake/box-btn-game.png')),
  //   'box-txt-1': imager(require('../img/shake/box-txt-1.png')),
  //   'box-txt-2': imager(require('../img/shake/box-txt-2.png'))
  // };

  var canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;

  canvas.style.width = canvas.width / pxr + 'px';
  canvas.style.height = canvas.height / pxr + 'px';

  var ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, size, size);

  function getLeft(_ref2) {
    var boxW = _ref2.boxW;

    return (canvas.width - boxW) / 2;
  }
  // function drawImage ({ image, top, left, width, height }) {
  //   ctx.drawImage(image, left, top, width, height);
  // }
  // function drawGrad ({ x0, y0, x1, y1 }) {
  //   var gradient = ctx.createLinearGradient(x0, y0, x1, y1);
  //   gradient.addColorStop(0, 'transparent');
  //   gradient.addColorStop(1, 'black');
  //   ctx.fillStyle = gradient;
  //   ctx.fillRect(x0, y0, x1, y1);
  // }
  function drawBox(_ref3) {
    var top = _ref3.top,
        left = _ref3.left,
        boxW = _ref3.boxW,
        boxH = _ref3.boxH;

    ctx.lineWidth = 2 * pxr;
    ctx.strokeStyle = '#EE3932';
    ctx.strokeRect(left, top, boxW, boxH);
  }

  var animateDrawBox = function animateDrawBox(_ref4, _ref5) {
    var boxW = _ref4.boxW,
        boxH = _ref4.boxH,
        top = _ref4.top,
        left = _ref4.left;
    var delay = _ref5.delay,
        yTime = _ref5.yTime,
        hTime = _ref5.hTime,
        setter = _ref5.setter;

    var group = { boxW: boxW, boxH: boxH, top: top, left: left };

    group.top += boxH * 2.0;
    group.boxH += boxH * 2.0;

    new __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Tween(group).to({ top: top }, yTime).easing(__WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Easing.Quadratic.Out).onUpdate(function () {
      setter(group);
    }).delay(delay).start();

    new __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Tween(group).to({ boxH: boxH }, hTime).easing(__WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Easing.Quadratic.Out).onUpdate(function () {
      setter(group);
    }).delay(delay).start();
  };

  // var animateRevealText = (config,{ delay, hTime, setter }) => {
  //   var group = { drawImage: { ...config.drawImage }, drawGrad: { ...config.drawGrad } };

  //   new TWEEN.Tween(group.drawImage)
  //     .to({ ...config.drawImage2 }, hTime)
  //     .easing(TWEEN.Easing.Quadratic.Out)
  //     .onUpdate(() => {
  //       setter(group);
  //     })
  //     .delay(delay)
  //     .start();

  //   // new TWEEN.Tween(group.drawGrad)
  //   //   .to({ ...config.drawGrad2 }, hTime)
  //   //   .easing(TWEEN.Easing.Quadratic.Out)
  //   //   .onUpdate(() => {
  //   //     setter(group);
  //   //   })
  //   //   .delay(delay)
  //   //   .start();
  // }

  function box1() {
    var boxW = 335 * pxr;
    var boxH = 220 * pxr;
    var top = 20 * pxr;
    var left = getLeft({ boxW: 335 * pxr });
    return { boxW: boxW, boxH: boxH, top: top, left: left };
  }
  function box2() {
    var boxW = 315 * pxr;
    var boxH = 150 * pxr;
    var top = (20 + 60) * pxr;
    var left = 10 * pxr + getLeft({ boxW: 335 * pxr });
    return { boxW: boxW, boxH: boxH, top: top, left: left };
  }
  function box3() {
    var boxW = 295 * pxr;
    var boxH = 80 * pxr;
    var top = (20 + 60 + 60) * pxr;
    var left = 20 * pxr + getLeft({ boxW: 335 * pxr });
    return { boxW: boxW, boxH: boxH, top: top, left: left };
  }
  function box4() {
    var boxW = 138 * pxr;
    var boxH = 60 * pxr;
    var top = (20 + 60 + 60 + 10) * pxr;
    var left = (20 + 48.5) * pxr + getLeft({ boxW: 138 * pxr });
    return { boxW: boxW, boxH: boxH, top: top, left: left };
  }

  // function boxText1 () {
  //   var top = 100 * pxr;
  //   var left = (130 - 16) * pxr;
  //   var width = 285 * pxr;
  //   var height = 15 * pxr;
  //   return {
  //     drawImage: ({ image: images['box-txt-1'].image, top: top + 200, left, width, height }),
  //     drawImage2: ({ image: images['box-txt-1'].image, top: top, left, width, height }),
  //     drawGrad: ({ x0: left, y0: top, x1: 0, y1: top }),
  //     drawGrad2: ({ x0: left, y0: top, x1: 0, y1: top })
  //   }
  // }

  // function boxText2 () {
  //   var top = 150 * pxr;
  //   var left = (130) * pxr;
  //   var width = 98 * pxr;
  //   var height = 55 * pxr;
  //   return {
  //     drawImage: ({ image: images['box-txt-2'].image, top: top + 200, left, width, height }),
  //     drawImage2: ({ image: images['box-txt-2'].image, top: top, left, width, height }),
  //     drawGrad: ({ x0: left, y0: top, x1: 0, y1: top }),
  //     drawGrad2: ({ x0: left, y0: top, x1: 0, y1: top })
  //   }
  // }

  var ref = {};
  function start() {
    animateDrawBox(box1(), { delay: 0, yTime: 700, hTime: 100 + 2200, setter: function setter(v) {
        ref.b1 = v;
      } });
    animateDrawBox(box2(), { delay: 300, yTime: 700, hTime: 100 + 1700, setter: function setter(v) {
        ref.b2 = v;
      } });
    animateDrawBox(box3(), { delay: 600, yTime: 700, hTime: 100 + 1300, setter: function setter(v) {
        ref.b3 = v;
      } });
    animateDrawBox(box4(), { delay: 900, yTime: 700, hTime: 100 + 600, setter: function setter(v) {
        ref.b4 = v;
      } });

    // animateRevealText(boxText1(), { delay: 0, hTime: 500, setter: (v) => { ref.r1 = v } })
    // animateRevealText(boxText2(), { delay: 0, hTime: 500, setter: (v) => { ref.r2 = v } })
  }

  api.start = start;
  api.canvas = canvas;
  api.draw = draw;
  api.reset = reset;

  var drawing = false;
  function reset() {
    ref = {};
    ctx.clearRect(0, 0, size, size);
  }
  function draw() {
    if (drawing) {
      return;
    }
    drawing = true;

    ctx.clearRect(0, 0, size, size);

    if (ref.b1) {
      drawBox(ref.b1);
    }
    if (ref.b2) {
      drawBox(ref.b2);
    }
    if (ref.b3) {
      drawBox(ref.b3);
    }
    if (ref.b4) {
      drawBox(ref.b4);
    }

    // if (ref.r1) {
    //   drawImage(ref.r1.drawImage)
    //   drawGrad(ref.r1.drawGrad)
    // }
    // if (ref.r2) {
    //   drawImage(ref.r2.drawImage)
    //   drawGrad(ref.r2.drawGrad)
    // }
    drawing = false;
  }
  // draw(0);

  api.install = function (target) {
    target.appendChild(canvas);
  };
  api.uninstall = function (target) {
    target.removeChild(canvas);
  };

  return api;
});

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */

var GReduce = function GReduce() {
	var ACCEL_THRES = 10;

	var D_THROWING = 1;
	var D_RETREATING = 0;

	var T_ASC = 1;
	var T_DSC = 0;

	var currentDirection; // 1 throw + 1 retreat => 1 score
	var currentTrend; // 1 up of ACCEL_THRES + 1 down of ACCEL_THRES in acceleration => 1 throw OR 1 punch
	var currentAccel;
	var count;
	var track; // recorded track
	setDefaultValues();

	var callback = function callback() {};

	function tFlip() {
		if (currentTrend == T_ASC) {
			// if currentTrend is ascending and it goes decending, nothing special
			currentTrend = T_DSC;
		} else {
			// if currentTrend is decending and it goes ascending, it is a change between D_THROWING and D_RETREATING
			currentTrend = T_ASC;
			dFlip();
		}
	}

	function dFlip() {
		if (currentDirection == D_THROWING) {
			// from throwing back to retreating results in 1 score
			currentDirection = D_RETREATING;
			count++;
			callback(null, count, currentAccel);
		} else {
			currentDirection = D_THROWING;
		}
	}

	function setDefaultValues() {
		currentDirection = D_THROWING;
		currentTrend = T_ASC;
		currentAccel = 0;
		count = 0;
		track = [];
	}

	// ---------------
	//     Exports
	// ---------------

	this.reset = setDefaultValues;

	this.getCount = function () {
		return count;
	};

	this.getTrack = function () {
		return track;
	};

	this.setCallback = function (fn) {
		callback = fn;
	};

	this.setAccelThres = function (accelThres) {
		ACCEL_THRES = accelThres;
	};

	this.digest = function (data) {
		var _x, _y, _z;

		if (Array.isArray(data)) {
			_x = data[0];
			_y = data[1];
			_z = data[2];
		} else {
			// gyronorm data object
			_x = data.dm.x;
			_y = data.dm.y;
			_z = data.dm.z;
		}

		track.push([_x, _y, _z]);

		var netAccel = Math.sqrt(_x * _x + _y * _y + _z * _z);
		var accelDelta = netAccel - currentAccel;
		if (currentTrend == T_ASC && accelDelta > 0 || currentTrend == T_DSC && accelDelta < 0) {
			// still following the trend
			currentAccel = netAccel;
			return;
		}
		if (currentTrend == T_ASC && accelDelta < -ACCEL_THRES || currentTrend == T_DSC && accelDelta > ACCEL_THRES) {
			currentAccel = netAccel;
			tFlip();
			return;
		}
	};
};

if (true) module.exports = GReduce;

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// var CanvasTextWrapper = require('canvas-text-wrapper').CanvasTextWrapper;

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var factor = 1.0;
  var api = {};
  var canvas = document.createElement('canvas');
  canvas.width = 512;
  canvas.height = 512;

  canvas.style.width = 512 * factor + 'px';
  canvas.style.height = 512 * factor + 'px';

  var ctx, context;
  context = ctx = canvas.getContext("2d");
  // ctx.shadowColor = 'white';
  // ctx.shadowOffsetX = 0;
  // ctx.shadowOffsetY = 0;
  // ctx.shadowBlur = 0.0;

  ctx.translate(0.5, 0.5);

  // var grd = context.createLinearGradient(0, 0, canvas.width, canvas.height);
  // // light blue
  // grd.addColorStop(0, 'red');
  // // dark blue
  // grd.addColorStop(1, 'white');

  var drawing = false;

  function draw(word) {
    var padX = 100;
    var padY = 70; /* 20: */
    if (drawing) {
      return;
    }
    drawing = true;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    // ctx.fillStyle = 'red';
    // ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = 'white';
    ctx.font = '310px DINCond-Regular';
    var width = ctx.measureText(word).width;

    var charNum = (word + '').length;
    var autoCenter = width / (2 * charNum) * (charNum - 1);

    ctx.fillText(word, padX + 70 - autoCenter, padY + 310);
    ctx.font = '130px DINCond-Regular';
    ctx.fillText('"', padX + 70 + width - autoCenter, padY + 130 + 20);
    drawing = false;
  }
  //draw(0);

  function drawStroke(word) {
    var padX = 120;
    var padY = 70; /* 20: */
    if (drawing) {
      return;
    }
    drawing = true;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    // ctx.fillStyle = 'red';
    // ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.strokeStyle = 'white';
    ctx.lineWidth = 3.5;
    ctx.font = '310px DINCond-Medium';
    var width = ctx.measureText(word).width;

    var charNum = (word + '').length;
    var autoCenter = width / (2 * charNum) * (charNum - 1);

    ctx.strokeText(word, padX + 70 - autoCenter, padY + 310);
    // ctx.font = '130px DINCond-Medium';
    // ctx.strokeText('"', padX + 70 + width - autoCenter, padY + 130 + 20);
    drawing = false;
  }

  api.drawStroke = drawStroke;
  api.canvas = canvas;
  api.draw = draw;

  api.install = function (target) {
    target.appendChild(canvas);
  };
  api.uninstall = function (target) {
    target.removeChild(canvas);
  };

  return api;
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var factor = 250 / 512;
  var api = {};
  var canvas = document.createElement('canvas');
  canvas.width = 512;
  canvas.height = 512;

  canvas.style.width = 512 * factor + 'px';
  canvas.style.height = 512 * factor + 'px';

  var ctx, context;
  context = ctx = canvas.getContext("2d");

  var grd = context.createLinearGradient(0, 0, canvas.width, canvas.height);
  // light blue
  grd.addColorStop(0, 'red');
  // dark blue
  grd.addColorStop(1, 'white');

  var drawing = false;

  function draw(percentage) {
    if (drawing) {
      return;
    }
    drawing = true;
    context.clearRect(0, 0, canvas.width, canvas.height);
    var x = canvas.width / 2;
    var y = canvas.height / 2;
    var radius = 240;
    var startAngle = 1.5 * Math.PI;
    var endAngle = 1.5 * Math.PI + Math.PI * 2 * percentage;
    var counterClockwise = false;

    context.beginPath();
    context.arc(x, y, radius, 0, Math.PI * 2, counterClockwise);
    context.lineWidth = 5;
    // line color
    context.strokeStyle = '#1a1a1a';
    context.stroke();

    context.beginPath();
    context.arc(x, y, radius, startAngle, endAngle, counterClockwise);
    context.lineWidth = 5;
    // line color
    context.strokeStyle = grd;
    context.stroke();
    drawing = false;
  }
  draw(0);

  api.canvas = canvas;
  api.draw = draw;

  api.install = function (target) {
    target.appendChild(canvas);
  };
  api.uninstall = function (target) {
    target.removeChild(canvas);
  };

  return api;
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js__);
/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var renderresher = _ref.renderresher;

  var pxr = 1.0;
  var api = {};
  var size = 512 * pxr;

  // function imager (src) {
  //   var image = new Image()
  //   image.src = src
  //   var result = { image, ready: false }
  //   image.onload = () => {
  //     result.ready = true
  //   }
  //   return result
  // }

  // var images = {
  //   'box-btn-comics': imager(require('../img/shake/box-btn-comics.png')),
  //   'box-btn-game': imager(require('../img/shake/box-btn-game.png')),
  //   'box-txt-1': imager(require('../img/shake/box-txt-1.png')),
  //   'box-txt-2': imager(require('../img/shake/box-txt-2.png'))
  // };

  var canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;

  canvas.style.width = canvas.width / pxr + 'px';
  canvas.style.height = canvas.height / pxr + 'px';

  var ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, size, size);

  function getLeft(_ref2) {
    var boxW = _ref2.boxW;

    return (canvas.width - boxW) / 2;
  }

  // function drawImage ({ image, top, left, width, height }) {
  //   ctx.drawImage(image, left, top, width, height);
  // }
  // function drawGrad ({ x0, y0, x1, y1 }) {
  //   var gradient = ctx.createLinearGradient(x0, y0, x1, y1);
  //   gradient.addColorStop(0, 'transparent');
  //   gradient.addColorStop(1, 'black');
  //   ctx.fillStyle = gradient;
  //   ctx.fillRect(x0, y0, x1, y1);
  // }

  function drawBox(_ref3) {
    var top = _ref3.top,
        left = _ref3.left,
        boxW = _ref3.boxW,
        boxH = _ref3.boxH,
        opacity = _ref3.opacity;

    ctx.lineWidth = 3 * pxr;
    ctx.strokeStyle = 'rgba(238, 57, 50, ' + opacity + ')';
    ctx.strokeRect(left, top, boxW, boxH);
  }

  var animateDrawBox = function animateDrawBox(_ref4, _ref5) {
    var boxW = _ref4.boxW,
        boxH = _ref4.boxH,
        top = _ref4.top,
        left = _ref4.left;
    var delay = _ref5.delay,
        yTime = _ref5.yTime,
        hTime = _ref5.hTime,
        setter = _ref5.setter;

    var group = { boxW: boxW, boxH: boxH, top: top, left: left, opacity: 0 };
    setter(group);
    group.top = group.top + group.boxH;
    group.boxH = 0;

    new __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Tween(group).to({ boxH: boxH, top: top, opacity: 1 }, hTime).easing(__WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Easing.Quadratic.Out).onUpdate(function () {
      setter(group);
    }).delay(delay).start();
  };

  function box1() {
    var boxW = 260 * pxr;
    var boxH = 260 * pxr;
    var top = 20 * pxr;
    var left = getLeft({ boxW: 260 * pxr });
    return { boxW: boxW, boxH: boxH, top: top, left: left };
  }

  function box2() {
    var boxW = 230 * pxr;
    var boxH = 180 * pxr;
    var top = (60 + 20 + 4) * pxr;
    var left = getLeft({ boxW: 230 * pxr });
    return { boxW: boxW, boxH: boxH, top: top, left: left };
  }

  function box3() {
    var boxW = 200 * pxr;
    var boxH = 100 * pxr;
    var top = (60 + 60 + 20 + 4) * pxr;
    var left = getLeft({ boxW: 200 * pxr });
    return { boxW: boxW, boxH: boxH, top: top, left: left };
  }

  var render = {};
  function start() {
    animateDrawBox(box1(), { delay: 0.5 * 500, yTime: 300, hTime: 0.5 * 1000, setter: function setter(v) {
        render.b1 = v;
      } });
    animateDrawBox(box2(), { delay: 0.5 * 1000, yTime: 300, hTime: 0.5 * 1000, setter: function setter(v) {
        render.b2 = v;
      } });
    animateDrawBox(box3(), { delay: 0.5 * 1500, yTime: 300, hTime: 0.5 * 1000, setter: function setter(v) {
        render.b3 = v;
      } });
    // animateRevealText(boxText1(), { delay: 0, hTime: 500, setter: (v) => { render.r1 = v } })
    // animateRevealText(boxText2(), { delay: 0, hTime: 500, setter: (v) => { render.r2 = v } })
  }

  api.start = start;
  api.canvas = canvas;
  api.draw = draw;
  api.reset = reset;

  var drawing = false;
  function reset() {
    render = {};
    ctx.clearRect(0, 0, size, size);
  }
  function draw() {
    if (drawing) {
      return;
    }
    drawing = true;

    ctx.clearRect(0, 0, size, size);

    if (render.b1) {
      drawBox(render.b1);
    }
    if (render.b2) {
      drawBox(render.b2);
    }
    if (render.b3) {
      drawBox(render.b3);
    }
    if (render.b4) {
      drawBox(render.b4);
    }
    drawing = false;
  }
  // draw(0);

  api.install = function (target) {
    target.appendChild(canvas);
  };
  api.uninstall = function (target) {
    target.removeChild(canvas);
  };

  return api;
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_three__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Shared_GUPComputataionRenderer__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raw_loader_ParticleShader_velocityShader_frag__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raw_loader_ParticleShader_velocityShader_frag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_raw_loader_ParticleShader_velocityShader_frag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raw_loader_ParticleShader_positionShader_frag__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raw_loader_ParticleShader_positionShader_frag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_raw_loader_ParticleShader_positionShader_frag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raw_loader_ParticleShader_vertexShader_vert__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raw_loader_ParticleShader_vertexShader_vert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_raw_loader_ParticleShader_vertexShader_vert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_raw_loader_ParticleShader_fragmentShader_frag__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_raw_loader_ParticleShader_fragmentShader_frag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_raw_loader_ParticleShader_fragmentShader_frag__);

/* dis-eslint-disable */










/* harmony default export */ __webpack_exports__["a"] = (function () {
  var api = {};

  var WIDTH = 256;
  var BOUNDS = 128;

  var gpuCompute;
  var positionVariable;
  var velocityVariable;
  var particleShader;

  function fillTexture(texture) {
    // var waterMaxHeight = 10
    // function noise(x, y, z) {
    //   var multR = waterMaxHeight
    //   var mult = 0.025
    //   var r = 0
    //   for (var i = 0; i < 15; i++) {
    //     r += multR * simplex.noise(x * mult, y * mult)
    //     multR *= 0.53 + 0.025 * i
    //     mult *= 1.25
    //   }
    //   return r
    // }
    var pixels = texture.image.data;
    var p = 0;
    for (var j = 0; j < WIDTH; j++) {
      for (var i = 0; i < WIDTH; i++) {
        var x = (WIDTH / 2 - i) * 128 / WIDTH;
        var y = (WIDTH / 2 - j) * 128 / WIDTH;

        pixels[p + 0] = x;
        pixels[p + 1] = y;

        pixels[p + 2] = 0; // noise(Math.sin(x), Math.sin(y), 0.0)
        // pixels[ p + 1 ] = 0
        // pixels[ p + 2 ] = 0
        pixels[p + 3] = 0;
        p += 4;
      }
    }
  }

  function setupCompute(_ref) {
    var renderer = _ref.renderer;

    gpuCompute = new __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Shared_GUPComputataionRenderer__["a" /* default */](WIDTH, WIDTH, renderer);

    var positionTexture = gpuCompute.createTexture();
    fillTexture(positionTexture);
    positionVariable = gpuCompute.addVariable('positionInfo', __WEBPACK_IMPORTED_MODULE_4_raw_loader_ParticleShader_positionShader_frag___default.a, positionTexture);
    positionVariable.material.uniforms.mousePos = {
      value: new __WEBPACK_IMPORTED_MODULE_1_three__["Vector2"](0, 0)
    };

    var velocityTexture = gpuCompute.createTexture();
    velocityVariable = gpuCompute.addVariable('velocityInfo', __WEBPACK_IMPORTED_MODULE_3_raw_loader_ParticleShader_velocityShader_frag___default.a, velocityTexture);
    velocityVariable.material.defines.BOUNDS = BOUNDS.toFixed(1);
    velocityVariable.wrapS = __WEBPACK_IMPORTED_MODULE_1_three__["ClampToEdgeWrapping"];
    velocityVariable.wrapT = __WEBPACK_IMPORTED_MODULE_1_three__["ClampToEdgeWrapping"];
    velocityVariable.material.uniforms.mousePos = {
      value: new __WEBPACK_IMPORTED_MODULE_1_three__["Vector2"](0, 0)
    };

    api.setMouse = function (_ref2) {
      var pageX = _ref2.pageX,
          pageY = _ref2.pageY,
          rect = _ref2.rect,
          isIn = _ref2.isIn,
          type = _ref2.type;

      var posMouse = velocityVariable.material.uniforms.mousePos.value;
      var velMouse = positionVariable.material.uniforms.mousePos.value;
      if (rect && typeof pageX !== 'undefined' && typeof pageY !== 'undefined') {
        velMouse.x = (pageX - rect.left) / rect.width * 2 - 1;
        velMouse.y = -((pageY - rect.top) / rect.height) * 2 + 1;
        posMouse.x = (pageX - rect.left) / rect.width * 2 - 1;
        posMouse.y = -((pageY - rect.top) / rect.height) * 2 + 1;
        // console.log(mouse)
      }
    };

    gpuCompute.setVariableDependencies(positionVariable, [positionVariable, velocityVariable]);
    gpuCompute.setVariableDependencies(velocityVariable, [positionVariable, velocityVariable]);

    var error = gpuCompute.init();
    if (error !== null) {
      console.error(error);
    }
    return {};
  }

  function setupScene() {
    var material = particleShader = new __WEBPACK_IMPORTED_MODULE_1_three__["ShaderMaterial"]({
      blending: __WEBPACK_IMPORTED_MODULE_1_three__["AdditiveBlending"],
      depthTest: false,
      transparent: true,
      uniforms: {
        positionInfo: {
          value: null
        },
        velocityInfo: {
          value: null
        }
      },
      vertexShader: __WEBPACK_IMPORTED_MODULE_5_raw_loader_ParticleShader_vertexShader_vert___default.a,
      fragmentShader: __WEBPACK_IMPORTED_MODULE_6_raw_loader_ParticleShader_fragmentShader_frag___default.a // THREE.ShaderChunk[ 'meshphong_frag' ]
    });

    material.defines.WIDTH = WIDTH.toFixed(1);
    material.defines.BOUNDS = BOUNDS.toFixed(1);

    var geometry = new __WEBPACK_IMPORTED_MODULE_1_three__["PlaneBufferGeometry"](BOUNDS, BOUNDS, WIDTH - 1, WIDTH - 1);
    var points = new __WEBPACK_IMPORTED_MODULE_1_three__["Points"](geometry, material);
    // points = new THREE.Points( geometry, material );
    // points.rotation.x = -Math.PI / 2 * 0;
    points.matrixAutoUpdate = false;
    points.updateMatrix();

    return {
      points: points
    };
  }

  function setup(_ref3) {
    var renderer = _ref3.renderer;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, setupCompute({ renderer: renderer }), setupScene());
  }
  api.setup = setup;

  function render() {
    // @.@
    particleShader.uniforms.positionInfo.value = gpuCompute.getCurrentRenderTarget(positionVariable).texture;
    particleShader.uniforms.velocityInfo.value = gpuCompute.getCurrentRenderTarget(velocityVariable).texture;
    gpuCompute.compute();
  }
  api.render = render;

  return api;
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_three__ = __webpack_require__(3);

/* dis-eslint-disable */



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var api = {};

  function setupScene(_ref) {
    var rect = _ref.rect,
        position = _ref.position;

    var geometry = new __WEBPACK_IMPORTED_MODULE_1_three__["SphereBufferGeometry"](70, 125, 125);
    // var geometry = new THREE.BoxBufferGeometry(70, 70, 70, 128, 128, 128)
    var vertIndex = new Float32Array(geometry.attributes.position.count);
    for (var i = 0; i < vertIndex.length; i++) {
      vertIndex[i] = i;
    }
    geometry.addAttribute('vertIndex', new __WEBPACK_IMPORTED_MODULE_1_three__["BufferAttribute"](vertIndex, 1));

    var shaderMaterial = api.material = new __WEBPACK_IMPORTED_MODULE_1_three__["ShaderMaterial"]({
      side: __WEBPACK_IMPORTED_MODULE_1_three__["DoubleSide"],
      transparent: false,
      depthTest: true,
      blending: __WEBPACK_IMPORTED_MODULE_1_three__["NormalBlending"],
      uniforms: {
        pointSize: { value: window.devicePixelRatio * 1.0 || 1.0 },
        wood: { value: new __WEBPACK_IMPORTED_MODULE_1_three__["TextureLoader"]().load(__webpack_require__(520)) },
        ball: { value: new __WEBPACK_IMPORTED_MODULE_1_three__["TextureLoader"]().load(__webpack_require__(521)) },
        time: { value: 1.0 },
        opacity: { value: 1.0 },
        resolution: { value: new __WEBPACK_IMPORTED_MODULE_1_three__["Vector2"]() },
        mousePos: { value: new __WEBPACK_IMPORTED_MODULE_1_three__["Vector2"]() }
      },
      vertexShader: __webpack_require__(469),
      fragmentShader: __webpack_require__(468)
    });

    api.setPosition = function (_ref2) {
      var position = _ref2.position;

      if (api.points && position) {
        api.points.position.set(position.x, position.y, position.z);
      }
    };

    api.setMouse = function (_ref3) {
      var pageX = _ref3.pageX,
          pageY = _ref3.pageY,
          rect = _ref3.rect,
          isIn = _ref3.isIn,
          type = _ref3.type;

      var mouse = shaderMaterial.uniforms.mousePos.value;
      if (rect && typeof pageX !== 'undefined' && typeof pageY !== 'undefined') {
        mouse.x = (pageX - rect.left) / rect.width * 2 - 1;
        mouse.y = -((pageY - rect.top) / rect.height) * 2 + 1;
        // console.log(mouse)
      }
    };

    api.updateRect = function (_ref4) {
      var rect = _ref4.rect;

      if (rect) {
        shaderMaterial.uniforms.resolution.set(rect.width, rect.height);
      }
    };

    api.updateTime = function () {
      shaderMaterial.uniforms.time.value = window.performance.now() * 0.0001 % 10.0;
    };

    var points = api.points = new __WEBPACK_IMPORTED_MODULE_1_three__["Points"](geometry, shaderMaterial);
    points.$skipRayCaster = true;
    api.updateRect({ rect: rect });
    api.setPosition({ position: position });
    return {
      points: points
    };
  }

  function setup(_ref5) {
    var renderer = _ref5.renderer,
        rect = _ref5.rect,
        position = _ref5.position;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, setupScene({ rect: rect, position: position }));
  }
  api.setup = setup;

  function render() {
    api.updateTime();
  }
  api.render = render;

  return api;
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GPUComputationRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(3);
/* eslint-disable */

/**
 * @author yomboprime https://github.com/yomboprime
 *
 * GPUComputationRenderer, based on SimulationRenderer by zz85
 *
 * The GPUComputationRenderer uses the concept of variables. These variables are RGBA float textures that hold 4 floats
 * for each compute element (texel)
 *
 * Each variable has a fragment shader that defines the computation made to obtain the variable in question.
 * You can use as many variables you need, and make dependencies so you can use textures of other variables in the shader
 * (the sampler uniforms are added automatically) Most of the variables will need themselves as dependency.
 *
 * The renderer has actually two render targets per variable, to make ping-pong. Textures from the current frame are used
 * as inputs to render the textures of the next frame.
 *
 * The render targets of the variables can be used as input textures for your visualization shaders.
 *
 * Variable names should be valid identifiers and should not collide with THREE GLSL used identifiers.
 * a common approach could be to use 'texture' prefixing the variable name; i.e texturePosition, textureVelocity...
 *
 * The size of the computation (sizeX * sizeY) is defined as 'resolution' automatically in the shader. For example:
 * #DEFINE resolution vec2( 1024.0, 1024.0 )
 *
 * -------------
 *
 * Basic use:
 *
 * // Initialization...
 *
 * // Create computation renderer
 * var gpuCompute = new GPUComputationRenderer( 1024, 1024, renderer );
 *
 * // Create initial state float textures
 * var pos0 = gpuCompute.createTexture();
 * var vel0 = gpuCompute.createTexture();
 * // and fill in here the texture data...
 *
 * // Add texture variables
 * var velVar = gpuCompute.addVariable( "textureVelocity", fragmentShaderVel, pos0 );
 * var posVar = gpuCompute.addVariable( "texturePosition", fragmentShaderPos, vel0 );
 *
 * // Add variable dependencies
 * gpuCompute.setVariableDependencies( velVar, [ velVar, posVar ] );
 * gpuCompute.setVariableDependencies( posVar, [ velVar, posVar ] );
 *
 * // Add custom uniforms
 * velVar.material.uniforms.time = { value: 0.0 };
 *
 * // Check for completeness
 * var error = gpuCompute.init();
 * if ( error !== null ) {
 *		console.error( error );
  * }
 *
 *
 * // In each frame...
 *
 * // Compute!
 * gpuCompute.compute();
 *
 * // Update texture uniforms in your visualization materials with the gpu renderer output
 * myMaterial.uniforms.myTexture.value = gpuCompute.getCurrentRenderTarget( posVar ).texture;
 *
 * // Do your rendering
 * renderer.render( myScene, myCamera );
 *
 * -------------
 *
 * Also, you can use utility functions to create ShaderMaterial and perform computations (rendering between textures)
 * Note that the shaders can have multiple input textures.
 *
 * var myFilter1 = gpuCompute.createShaderMaterial( myFilterFragmentShader1, { theTexture: { value: null } } );
 * var myFilter2 = gpuCompute.createShaderMaterial( myFilterFragmentShader2, { theTexture: { value: null } } );
 *
 * var inputTexture = gpuCompute.createTexture();
 *
 * // Fill in here inputTexture...
 *
 * myFilter1.uniforms.theTexture.value = inputTexture;
 *
 * var myRenderTarget = gpuCompute.createRenderTarget();
 * myFilter2.uniforms.theTexture.value = myRenderTarget.texture;
 *
 * var outputRenderTarget = gpuCompute.createRenderTarget();
 *
 * // Now use the output texture where you want:
 * myMaterial.uniforms.map.value = outputRenderTarget.texture;
 *
 * // And compute each frame, before rendering to screen:
 * gpuCompute.doRenderTarget( myFilter1, myRenderTarget );
 * gpuCompute.doRenderTarget( myFilter2, outputRenderTarget );
 *
 *
 *
 * @param {int} sizeX Computation problem size is always 2d: sizeX * sizeY elements.
 * @param {int} sizeY Computation problem size is always 2d: sizeX * sizeY elements.
 * @param {WebGLRenderer} renderer The renderer
  */


function GPUComputationRenderer(sizeX, sizeY, renderer) {

  this.variables = [];

  this.currentTextureIndex = 0;

  var scene = new __WEBPACK_IMPORTED_MODULE_0_three__["Scene"]();

  var camera = new __WEBPACK_IMPORTED_MODULE_0_three__["Camera"]();
  camera.position.z = 1;

  var passThruUniforms = {
    texture: { value: null }
  };

  var passThruShader = createShaderMaterial(getPassThroughFragmentShader(), passThruUniforms);

  var mesh = new __WEBPACK_IMPORTED_MODULE_0_three__["Mesh"](new __WEBPACK_IMPORTED_MODULE_0_three__["PlaneBufferGeometry"](2, 2), passThruShader);
  scene.add(mesh);

  this.addVariable = function (variableName, computeFragmentShader, initialValueTexture) {

    var material = this.createShaderMaterial(computeFragmentShader);

    var variable = {
      name: variableName,
      initialValueTexture: initialValueTexture,
      material: material,
      dependencies: null,
      renderTargets: [],
      wrapS: null,
      wrapT: null,
      minFilter: __WEBPACK_IMPORTED_MODULE_0_three__["NearestFilter"],
      magFilter: __WEBPACK_IMPORTED_MODULE_0_three__["NearestFilter"]
    };

    this.variables.push(variable);

    return variable;
  };

  this.setVariableDependencies = function (variable, dependencies) {

    variable.dependencies = dependencies;
  };

  this.init = function () {

    if (!renderer.extensions.get("OES_texture_float")) {

      return "No OES_texture_float support for float textures.";
    }

    if (renderer.capabilities.maxVertexTextures === 0) {

      return "No support for vertex shader textures.";
    }

    for (var i = 0; i < this.variables.length; i++) {

      var variable = this.variables[i];

      // Creates rendertargets and initialize them with input texture
      variable.renderTargets[0] = this.createRenderTarget(sizeX, sizeY, variable.wrapS, variable.wrapT, variable.minFilter, variable.magFilter);
      variable.renderTargets[1] = this.createRenderTarget(sizeX, sizeY, variable.wrapS, variable.wrapT, variable.minFilter, variable.magFilter);
      this.renderTexture(variable.initialValueTexture, variable.renderTargets[0]);
      this.renderTexture(variable.initialValueTexture, variable.renderTargets[1]);

      // Adds dependencies uniforms to the ShaderMaterial
      var material = variable.material;
      var uniforms = material.uniforms;
      if (variable.dependencies !== null) {

        for (var d = 0; d < variable.dependencies.length; d++) {

          var depVar = variable.dependencies[d];

          if (depVar.name !== variable.name) {

            // Checks if variable exists
            var found = false;
            for (var j = 0; j < this.variables.length; j++) {

              if (depVar.name === this.variables[j].name) {
                found = true;
                break;
              }
            }
            if (!found) {
              return "Variable dependency not found. Variable=" + variable.name + ", dependency=" + depVar.name;
            }
          }

          uniforms[depVar.name] = { value: null };

          material.fragmentShader = "\nuniform sampler2D " + depVar.name + ";\n" + material.fragmentShader;
        }
      }
    }

    this.currentTextureIndex = 0;

    return null;
  };

  this.compute = function () {

    var currentTextureIndex = this.currentTextureIndex;
    var nextTextureIndex = this.currentTextureIndex === 0 ? 1 : 0;

    for (var i = 0, il = this.variables.length; i < il; i++) {

      var variable = this.variables[i];

      // Sets texture dependencies uniforms
      if (variable.dependencies !== null) {

        var uniforms = variable.material.uniforms;
        for (var d = 0, dl = variable.dependencies.length; d < dl; d++) {

          var depVar = variable.dependencies[d];

          uniforms[depVar.name].value = depVar.renderTargets[currentTextureIndex].texture;
        }
      }

      // Performs the computation for this variable
      this.doRenderTarget(variable.material, variable.renderTargets[nextTextureIndex]);
    }

    this.currentTextureIndex = nextTextureIndex;
  };

  this.getCurrentRenderTarget = function (variable) {

    return variable.renderTargets[this.currentTextureIndex];
  };

  this.getAlternateRenderTarget = function (variable) {

    return variable.renderTargets[this.currentTextureIndex === 0 ? 1 : 0];
  };

  function addResolutionDefine(materialShader) {

    materialShader.defines.resolution = 'vec2( ' + sizeX.toFixed(1) + ', ' + sizeY.toFixed(1) + " )";
  }
  this.addResolutionDefine = addResolutionDefine;

  // The following functions can be used to compute things manually

  function createShaderMaterial(computeFragmentShader, uniforms) {

    uniforms = uniforms || {};

    var material = new __WEBPACK_IMPORTED_MODULE_0_three__["ShaderMaterial"]({
      uniforms: uniforms,
      vertexShader: getPassThroughVertexShader(),
      fragmentShader: computeFragmentShader
    });

    addResolutionDefine(material);

    return material;
  }
  this.createShaderMaterial = createShaderMaterial;

  this.createRenderTarget = function (sizeXTexture, sizeYTexture, wrapS, wrapT, minFilter, magFilter) {

    sizeXTexture = sizeXTexture || sizeX;
    sizeYTexture = sizeYTexture || sizeY;

    wrapS = wrapS || __WEBPACK_IMPORTED_MODULE_0_three__["ClampToEdgeWrapping"];
    wrapT = wrapT || __WEBPACK_IMPORTED_MODULE_0_three__["ClampToEdgeWrapping"];

    minFilter = minFilter || __WEBPACK_IMPORTED_MODULE_0_three__["NearestFilter"];
    magFilter = magFilter || __WEBPACK_IMPORTED_MODULE_0_three__["NearestFilter"];

    var renderTarget = new __WEBPACK_IMPORTED_MODULE_0_three__["WebGLRenderTarget"](sizeXTexture, sizeYTexture, {
      wrapS: wrapS,
      wrapT: wrapT,
      minFilter: minFilter,
      magFilter: magFilter,
      format: __WEBPACK_IMPORTED_MODULE_0_three__["RGBAFormat"],
      type: /(iPad|iPhone|iPod)/g.test(navigator.userAgent) ? __WEBPACK_IMPORTED_MODULE_0_three__["HalfFloatType"] : __WEBPACK_IMPORTED_MODULE_0_three__["FloatType"],
      stencilBuffer: false
    });

    return renderTarget;
  };

  this.createTexture = function (sizeXTexture, sizeYTexture) {

    sizeXTexture = sizeXTexture || sizeX;
    sizeYTexture = sizeYTexture || sizeY;

    var a = new Float32Array(sizeXTexture * sizeYTexture * 4);
    var texture = new __WEBPACK_IMPORTED_MODULE_0_three__["DataTexture"](a, sizeX, sizeY, __WEBPACK_IMPORTED_MODULE_0_three__["RGBAFormat"], __WEBPACK_IMPORTED_MODULE_0_three__["FloatType"]);
    texture.needsUpdate = true;

    return texture;
  };

  this.renderTexture = function (input, output) {

    // Takes a texture, and render out in rendertarget
    // input = Texture
    // output = RenderTarget

    passThruUniforms.texture.value = input;

    this.doRenderTarget(passThruShader, output);

    passThruUniforms.texture.value = null;
  };

  this.doRenderTarget = function (material, output) {

    mesh.material = material;
    renderer.render(scene, camera, output);
    mesh.material = passThruShader;
  };

  // Shaders

  function getPassThroughVertexShader() {

    return "void main()	{\n" + "\n" + "	gl_Position = vec4( position, 1.0 );\n" + "\n" + "}\n";
  }

  function getPassThroughFragmentShader() {

    return "uniform sampler2D texture;\n" + "\n" + "void main() {\n" + "\n" + "	vec2 uv = gl_FragCoord.xy / resolution.xy;\n" + "\n" + "	gl_FragColor = texture2D( texture, uv );\n" + "\n" + "}\n";
  }
}

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__backend_firebase__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_WebGL_Shared_cache__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_WebGL_Mixins_llvms__ = __webpack_require__(22);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "router", function() { return __WEBPACK_IMPORTED_MODULE_4__router__["a"]; });


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






// import { appState } from './backend/firebase';

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.fullPath.indexOf('/cms') === 0) {
    __WEBPACK_IMPORTED_MODULE_5__backend_firebase__["appState"].useRT = true;
    __WEBPACK_IMPORTED_MODULE_5__backend_firebase__["appState"].useCMS = true;
    next();
  } else if (__WEBPACK_IMPORTED_MODULE_5__backend_firebase__["appState"].useCMS) {
    next({ path: to.fullPath.replace('/nike', '/cms') });
  } else {
    next();
  }
});

var state = {
  progress: 0.14,
  appState: __WEBPACK_IMPORTED_MODULE_5__backend_firebase__["appState"]
};

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;
function exec() {
  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
    template: '\n      <App v-if="state.progress === 1" />\n      <div v-else class="main-loader">\n        <div class="main-red-bar" :style="{ width: (w * state.progress) + \'px\' }"></div>\n        <div class="red-bar"></div>\n        <div style="width: 100%; height: 100%; background-color: black; display: flex; justify-content: center; align-items: center;">\n          <svg style="transform: scale(1.5)" width="141px" height="18px" viewBox="0 0 141 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n            <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n            <desc>Created with Sketch.</desc>\n            <defs></defs>\n            <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n                <g id="Nav-bar-scroll" transform="translate(-16.000000, -16.000000)">\n                    <g id="Group-4">\n                        <g id="Page-1" transform="translate(16.000000, 17.000000)" fill="#FFFFFF">\n                            <path d="M2.73179167,9.94204167 C2.73179167,11.1199583 2.33679167,11.7087083 1.546375,11.7087083 C0.953458333,11.7087083 0.438041667,11.4249583 0.000125,10.8570417 L0.000125,14.6962083 C0.956791667,14.9882917 1.796375,15.1349583 2.51845833,15.1349583 C3.88304167,15.1349583 4.91679167,14.737875 5.62054167,13.942875 C5.985125,13.530375 6.235125,13.0782917 6.37054167,12.5870417 C6.51845833,12.0899583 6.59304167,11.4249583 6.59304167,10.5937083 L6.59304167,0.837875 L2.73179167,0.837875 L2.73179167,9.94204167 Z" id="Fill-1"></path>\n                            <path d="M13.81025,10.0156667 C13.81025,10.6535833 13.7394167,11.0985833 13.5973333,11.35025 C13.45525,11.5885833 13.1994167,11.7085833 12.829,11.7085833 C12.4706667,11.7085833 12.2160833,11.58025 12.0648333,11.3223333 C11.9135833,11.0644167 11.83775,10.6260833 11.83775,10.0065 L11.83775,0.83775 L7.97691667,0.83775 L7.97691667,10.239 C7.97691667,12.04025 8.54441667,13.3515 9.68066667,14.17025 C10.5756667,14.814 11.6835833,15.1348333 13.0048333,15.1348333 C14.1715,15.1348333 15.1623333,14.8444167 15.9773333,14.2610833 C16.5819167,13.8248333 17.0144167,13.3360833 17.2735833,12.7960833 C17.539,12.2810833 17.6719167,11.6073333 17.6719167,10.7760833 L17.6719167,0.83775 L13.81025,0.83775 L13.81025,10.0156667 Z" id="Fill-3"></path>\n                            <path d="M23.9530833,6.62883333 L23.3418333,6.19216667 C22.8168333,5.82925 22.55475,5.46341667 22.55475,5.09425 C22.55475,4.86841667 22.6535,4.67466667 22.851,4.51383333 C23.04225,4.34716667 23.286,4.26425 23.58225,4.26425 C23.971,4.26425 24.3664167,4.40466667 24.7676667,4.6855 C25.1689167,4.96633333 25.52725,5.35091667 25.8418333,5.83841667 L25.8418333,1.54841667 C24.90975,1.07508333 23.9835,0.838 23.0639167,0.838 C22.0330833,0.838 21.1530833,1.1355 20.4251667,1.73133333 C20.1593333,1.94008333 19.92475,2.17925 19.721,2.4505 C19.51725,2.72133333 19.3380833,3.0205 19.1839167,3.34841667 C18.8751667,4.05091667 18.7205833,4.72383333 18.7205833,5.36675 C18.7205833,5.74216667 18.7643333,6.09925 18.8505833,6.43883333 C18.9368333,6.778 19.0730833,7.10675 19.2580833,7.42591667 C19.4435,7.74466667 19.6839167,8.05383333 19.9805833,8.35466667 C20.2764167,8.6555 20.63475,8.95758333 21.05475,9.26175 L21.6839167,9.73508333 C22.141,10.0859167 22.3693333,10.44675 22.3693333,10.8159167 C22.3693333,11.0721667 22.2643333,11.2846667 22.0543333,11.4550833 C21.8443333,11.6246667 21.5730833,11.7088333 21.2393333,11.7088333 C20.3568333,11.7088333 19.536,11.1905 18.7764167,10.153 L18.7764167,14.5521667 C19.8139167,14.9409167 20.786,15.1350833 21.6935,15.1350833 C23.0080833,15.1350833 24.09475,14.6950833 24.9530833,13.81425 C25.8105833,12.9334167 26.23975,11.8150833 26.23975,10.4588333 C26.23975,9.6605 26.0605833,8.96425 25.7030833,8.36966667 C25.351,7.77466667 24.7676667,7.19466667 23.9530833,6.62883333" id="Fill-5"></path>\n                            <polygon id="Fill-7" points="27.0339583 4.264125 29.1635417 4.264125 29.1635417 15.1349583 33.0247917 15.1349583 33.0247917 4.264125 35.238125 4.264125 35.238125 0.837875 27.0339583 0.837875"></polygon>\n                            <path d="M44.8552083,11.7092083 L44.8552083,4.43045833 L44.975625,4.43045833 C45.574375,4.43045833 46.0497917,4.764625 46.401875,5.430875 C46.7539583,6.09129167 46.9297917,6.993375 46.9297917,8.13504167 C46.9297917,10.4500417 46.238125,11.640875 44.8552083,11.7092083 M44.3277083,0.837958333 L40.9939583,0.837958333 L40.9939583,15.1350417 L44.6052083,15.1350417 C46.599375,15.1350417 48.099375,14.585875 49.105625,13.4867083 C50.2847917,12.197125 50.8739583,10.365875 50.8739583,7.995875 C50.8739583,5.58795833 50.1764583,3.71504167 48.7814583,2.37504167 C47.7197917,1.35045833 46.2352083,0.837958333 44.3277083,0.837958333" id="Fill-9"></path>\n                            <path d="M58.577125,10.7460833 C58.3304583,11.3881667 57.978375,11.709 57.5212917,11.709 C57.077125,11.709 56.729625,11.3835833 56.479625,10.7331667 C56.229625,10.0819167 56.1050417,9.16733333 56.1050417,7.9865 C56.1050417,6.78775 56.2375417,5.88066667 56.5029583,5.26275 C56.774625,4.59733333 57.1387917,4.264 57.595875,4.264 C58.5087917,4.264 58.9662917,5.53191667 58.9662917,8.06816667 C58.9662917,9.21233333 58.8362917,10.10525 58.577125,10.7460833 M57.577125,0.83775 C56.2312917,0.83775 55.0679583,1.31816667 54.085875,2.27733333 C52.7650417,3.5715 52.104625,5.43983333 52.104625,7.88316667 C52.104625,10.4348333 52.737125,12.3485833 54.0025417,13.624 C55.0092083,14.6315 56.215875,15.1348333 57.6229583,15.1348333 C59.209625,15.1348333 60.4967083,14.4794167 61.4850417,13.16775 C62.478375,11.8506667 62.9754583,10.14025 62.9754583,8.03566667 C62.9754583,5.83608333 62.4875417,4.0865 61.5125417,2.78733333 C60.537125,1.48775 59.2254583,0.83775 57.577125,0.83775" id="Fill-11"></path>\n                            <polygon id="Fill-13" points="69 15.1349167 72.8616667 15.1349167 72.8616667 0.837833333 69 0.837833333"></polygon>\n                            <polygon id="Fill-15" points="74.1652917 4.264125 76.294875 4.264125 76.294875 15.1349583 80.156125 15.1349583 80.156125 4.264125 82.3694583 4.264125 82.3694583 0.837875 74.1652917 0.837875"></polygon>\n                        </g>\n                        <path d="M145.381454,19.5467377 C142.02149,20.4325675 139.097287,21.2002613 136.599349,21.8729905 C134.098752,22.5442002 131.984527,23.1014525 130.248318,23.5512048 C128.518187,24.0096939 127.078691,24.3853738 125.92717,24.6991368 C123.247633,25.4075727 121.662629,25.8250371 121.17178,25.9492508 C120.94801,26.0050899 120.694987,26.0563708 120.419929,26.1209468 C120.138412,26.1813442 119.844738,26.2417417 119.544606,26.286565 C119.239535,26.3427841 118.937882,26.3796303 118.633571,26.4092593 C118.334578,26.4461055 118.038625,26.4567416 117.765846,26.4544624 C117.090738,26.4491444 116.447543,26.3602575 115.811946,26.1957789 C115.190785,26.0320599 114.63497,25.7578021 114.141082,25.4011151 C113.646813,25.0432885 113.25702,24.5775821 112.959167,23.9937398 C112.671572,23.4155954 112.529104,22.7234934 112.535943,21.8992007 C112.541261,21.1903849 112.695127,20.3664721 112.981582,19.401252 C113.271077,18.4565442 113.761547,17.3260856 114.440834,16 C114.188951,16.2282949 113.824233,16.5811833 113.34744,17.0560063 C112.879385,17.5543805 112.374479,18.1215091 111.823603,18.7874008 C111.282225,19.462789 110.717672,20.1947761 110.164896,20.994378 C109.587426,21.7962591 109.074161,22.6304281 108.604967,23.4866289 C108.136912,24.3439692 107.755478,25.2089068 107.459905,26.0837206 C107.163191,26.9513172 107.006287,27.7843466 107.000208,28.5942047 C106.994129,29.3562006 107.121401,30.0627372 107.372524,30.7271095 C107.627827,31.3903422 107.999003,31.9555715 108.497451,32.4372319 C108.994759,32.9162334 109.620478,33.3052084 110.384867,33.5806057 C111.134058,33.8510648 112.016979,33.9923722 113.016155,33.9995895 C113.714058,34.0052874 114.424878,33.9517273 115.132279,33.8354907 C115.845758,33.7215331 116.536443,33.5787064 117.194455,33.3937154 C117.855126,33.2174611 118.478946,33.0203146 119.059455,32.8163306 C119.643764,32.6051294 120.154369,32.4197585 120.588611,32.2328681 C121.028932,32.0531951 121.379213,31.9027712 121.636035,31.7758985 C121.903875,31.6573827 122.042544,31.5969852 122.0604,31.5969852 L157,16.4759626 C152.608188,17.6349105 148.735339,18.6624274 145.381454,19.5467377" id="Fill-16" fill="#EE3932"></path>\n                    </g>\n                </g>\n            </g>\n          </svg>\n        </div>\n\n      </div>\n    ',
    data: function data() {
      return {
        w: window.innerWidth,
        state: state
      };
    },

    components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
  });
}

function initPrep() {
  var loadTargets = [];
  loadTargets = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__components_WebGL_Shared_cache__["a" /* homeLinks */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__components_WebGL_Shared_cache__["b" /* menuLinks */]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__components_WebGL_Shared_cache__["c" /* startAnimationLinks */]));
  // if (window.location.pathname.indexOf('/play') !== -1) {
  //   loadTargets = [...loadTargets, ...startAnimationLinks]
  // }

  var progressHandler = function progressHandler(progress) {
    console.log(progress);
    if (progress === 1.0) {
      setTimeout(function () {
        state.progress = progress;
      }, 500);
    } else {
      state.progress = progress;
    }
  };
  var prepItems = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__components_WebGL_Mixins_llvms__["initLoad"])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__components_WebGL_Shared_cache__["d" /* preLoad */])(loadTargets)].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__components_WebGL_Shared_cache__["e" /* getFonts */])()));

  if (window.location.pathname.indexOf('/cms') === 0) {
    prepItems.push(__WEBPACK_IMPORTED_MODULE_5__backend_firebase__["readyRT"]());
  }
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(prepItems).then(function () {
    exec();
    setTimeout(function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__components_WebGL_Shared_cache__["d" /* preLoad */])([].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(loadTargets), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__components_WebGL_Shared_cache__["f" /* preloadBundle */])), progressHandler);
    }, 3000);
  });
}

initPrep();


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {},

  name: 'app'
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WebGL_Mixins_llvms__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backend_firebase__ = __webpack_require__(30);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var self = this;
    return {
      get vmsObj() {
        return self.getVMS();
      },
      llvmsAPI: __WEBPACK_IMPORTED_MODULE_1__components_WebGL_Mixins_llvms__["api"],
      llvms: __WEBPACK_IMPORTED_MODULE_1__components_WebGL_Mixins_llvms__,
      backend: __WEBPACK_IMPORTED_MODULE_2__backend_firebase__,
      appState: __WEBPACK_IMPORTED_MODULE_2__backend_firebase__["appState"],
      selectedStyle: false,
      currentObject: false,
      styleFilterQuery: ''
    };
  },
  created: function created() {
    this.$emit('api', this);
  },

  computed: {
    filteredStyles: function filteredStyles() {
      var _this = this;

      return this.llvmsAPI.listStyle().filter(function (item) {
        return item.name.indexOf(_this.styleFilterQuery) !== -1;
      });
    }
  },
  methods: {
    getVMS: function getVMS() {
      if (this.selectedStyle) {
        var style = this.llvmsAPI.getStyle(this.selectedStyle);
        return style;
      }
      if (this.currentObject && this.currentObject.userData.vms) {
        var _style = this.currentObject.userData.vms;
        return _style;
      }
    },
    save: function save(vmsObj) {
      __WEBPACK_IMPORTED_MODULE_1__components_WebGL_Mixins_llvms__["updateVS"](vmsObj);
    },
    refresher: function refresher() {
      if (this.currentObject.userData.$component) {
        this.currentObject.userData.$component.localRefresher = Math.random();
      }
    },
    glClick: function glClick(_ref) {
      var mouse = _ref.mouse,
          found = _ref.found;

      if (found.object.userData.vms) {
        // this.currentVMS = found.object.userData.vms
        this.currentObject = found.object;
        this.selectedStyle = found.object.userData.vms.name;
        this.currentObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.currentObject, __WEBPACK_IMPORTED_MODULE_1__components_WebGL_Mixins_llvms__["getTemplate"]({ name: found.object.userData.vms.name, data: found.object.userData.vms }));

        console.log({ mouse: mouse, found: found });
      }
    }
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backend_firebase__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WebGL_GLView__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WebGL_GLView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_WebGL_GLView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CMS_Controllers_Controllers__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CMS_Controllers_Controllers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_CMS_Controllers_Controllers__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    GLView: __WEBPACK_IMPORTED_MODULE_1__components_WebGL_GLView___default.a,
    Controllers: __WEBPACK_IMPORTED_MODULE_2__components_CMS_Controllers_Controllers___default.a
  },
  data: function data() {
    return {
      appState: __WEBPACK_IMPORTED_MODULE_0__backend_firebase__["appState"],
      apis: {},
      refresh: {},
      isBigEnoughAtStart: window.innerWidth > 828,
      isTallEnough: false,
      isBigEnough: false
    };
  },

  methods: {
    passer: function passer(args) {
      if (this.apis.controllers) {
        this.apis.controllers.glClick(args);
      }
    }
  },
  created: function created() {
    var _this = this;

    var resizer = function resizer() {
      _this.isTallEnough = window.innerHeight > 462;
      _this.isBigEnough = window.innerWidth > 828;
      // auto refresh size info :D
      for (var exec in _this.refresh) {
        var exe = _this.refresh[exec];
        if (exe) {
          _this.$nextTick(function () {
            exe();
          });
        }
      }
    };
    resizer();
    window.addEventListener('resize', resizer);
  },

  computed: {}
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backend_firebase__ = __webpack_require__(30);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      appState: __WEBPACK_IMPORTED_MODULE_0__backend_firebase__["appState"]
    };
  },

  methods: {
    loginGoogle: function loginGoogle() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__backend_firebase__["loginToGoogle"])();
    }
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_three__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backend_firebase__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WebGL_Shared_system__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NikeWebGL_element_Menu_Menu__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NikeWebGL_element_Menu_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_NikeWebGL_element_Menu_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_WebGL_Bundle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_WebGL_Mixins_FadeInOut__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__components_WebGL_Mixins_FadeInOut__["a" /* default */]],
  props: ['aspect'],
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    GLMenu: __WEBPACK_IMPORTED_MODULE_4__components_NikeWebGL_element_Menu_Menu___default.a
  }, __WEBPACK_IMPORTED_MODULE_5__components_WebGL_Bundle__["a" /* default */]),
  data: function data() {
    return {
      appState: __WEBPACK_IMPORTED_MODULE_2__backend_firebase__["appState"],
      glSystem: __WEBPACK_IMPORTED_MODULE_3__components_WebGL_Shared_system__["a" /* glSystem */],
      showPage: true,
      mouseStack: {},
      execStack: {},
      camera: false,
      scene: false,
      raycaster: false,
      setMouse: function setMouse() {},
      hover: function hover() {
        return [];
      },
      lastResult: []
    };
  },
  activated: function activated() {
    var _this = this;

    this.$emit('scene', this.scene);
    this.$emit('camera', this.camera);
    this.$emit('setMouse', function (args) {
      for (var name in _this.mouseStack) {
        var exec = _this.mouseStack[name];
        if (exec) {
          exec(args);
        }
      }
    });

    this.scene.background = new __WEBPACK_IMPORTED_MODULE_1_three__["Color"](0x000000);

    this.$nextTick(function () {
      _this.$emit('exec', _this.exec);
      // this.fadeInTween((v) => {
      //   // this.camera.position.z = 10
      //   this.$refs['mesh-1'].mesh.material.opacity = v
      //   this.$refs['mesh-1'].mesh.position.z = 5 * (1 - v)
      // }, () => {
      // })
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$nextTick(function () {
      next();
    });
    // this.fadeOutTween((v) => {
    //   // this.camera.position.z = 10
    //   this.$refs['mesh-1'].mesh.material.opacity = v
    //   this.$refs['mesh-1'].mesh.position.z = -5 * (1.0 - v)
    // }, () => {
    //   next()
    // })
  },
  deactivated: function deactivated() {
    this.$emit('setMouse', function () {});
    this.$emit('exec', function () {});
  },

  methods: {
    // alert ({ found }) {
    //   this.fadeOutTween((v) => {
    //     found.object.material.opacity = v
    //   }, () => {
    //     this.fadeInTween((v) => {
    //       found.object.material.opacity = v
    //     }, () => {
    //     })
    //   })
    // },
    handleTouchStart: function handleTouchStart(_ref) {
      var mouse = _ref.mouse,
          found = _ref.found;

      if (found[0]) {
        // click handler
        // useClick is for CMS
        if (found[0].object.userData && found[0].object.userData.gTS) {
          found[0].object.userData.gTS({ mouse: mouse, found: found[0] });
        }
        // this.$emit('glTouchStart', { mouse, found: found[0] })
      }
    },
    handleHit: function handleHit(_ref2) {
      var mouse = _ref2.mouse,
          found = _ref2.found;

      // console.log(found)
      if (found[0]) {
        // click handler
        // useClick is for CMS
        if (this.appState.useClick) {
          if (found[0].object.userData && found[0].object.userData.gclick) {
            found[0].object.userData.gclick({ mouse: mouse, found: found[0] });
          }
        }

        // for cms
        this.$emit('glClick', { mouse: mouse, found: found[0] });
      }
    },

    // highlight (result, color) {
    //   if (result.length === 0) { return }
    //   for (var i = 0; i < result.length; i++) {
    //     result[i].object.material.color.set(color)
    //   }
    // },
    exec: function exec() {
      for (var execItem in this.execStack) {
        var exec = this.execStack[execItem];
        if (exec) {
          exec();
        }
      }

      this.execTween();
    }
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tweenjs_tween_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_WebGL_Mixins_FadeInOut__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_three__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_WebGL_Bundle__ = __webpack_require__(5);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Agree',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_WebGL_Mixins_FadeInOut__["a" /* default */]],
  components: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7__components_WebGL_Bundle__["a" /* default */]),
  props: ['aspect'],
  data: function data() {
    return {
      readyAgree: false,
      checkedBox: false,
      visiStack: {
        enterNow: false
      },
      revealStack: {},
      shakeStack: {
        s1: function s1() {}
      },
      execStack: {
        grungeBg: function grungeBg() {}
      },
      tweening: false
    };
  },
  mounted: function mounted() {},
  activated: function activated() {
    var _this = this;

    this.$emit('exec', function () {
      for (var execItem in _this.execStack) {
        var exec = _this.execStack[execItem];
        if (exec) {
          exec();
        }
      }
    });
    this.animateAll();
  },
  deactivated: function deactivated() {
    this.$emit('exec', function () {});
  },

  methods: {
    shakeShake: function shakeShake(shaker, pos, time, ratio) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        shaker({ initPos: pos, timeRatio: ratio || 2.0 });
        setTimeout(function () {
          resolve();
        }, time);
      });
    },
    opacity: function opacity(mesh, v) {
      mesh.material.opacity = v;
      if (mesh.material.uniforms) {
        mesh.material.uniforms.opacity.value = v;
      }
    },
    revealMove: function revealMove(item, revaler, time, pos) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (item) {
          revaler({ initPos: pos, time: time });
          setTimeout(function () {
            resolve();
          }, 500);
        }
      });
    },
    scale: function scale(mesh, v) {
      mesh.scale.x = v;
      mesh.scale.y = v;
      mesh.scale.z = v;
    },
    scaleTHREE: function scaleTHREE(mesh, v) {
      mesh.scale.set(v.x, v.y, v.z);
    },
    scaleIn: function scaleIn(mesh, _ref) {
      var _this2 = this;

      var time = _ref.time,
          scale = _ref.scale,
          opacity = _ref.opacity,
          initScale = _ref.initScale,
          initOpacity = _ref.initOpacity,
          delay = _ref.delay;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var v = {
          scale: initScale || 0,
          opacity: initOpacity || 0
        };
        delay = delay || 0;

        new __WEBPACK_IMPORTED_MODULE_4__tweenjs_tween_js___default.a.Tween(v).to({ scale: scale, opacity: opacity }, time).easing(__WEBPACK_IMPORTED_MODULE_4__tweenjs_tween_js___default.a.Easing.Quadratic.Out).onUpdate(function () {
          _this2.opacity(mesh, v.opacity);
          _this2.scale(mesh, v.scale);
        }).delay(delay).onComplete(function () {
          resolve();
        }).start();
      });
    },
    moveInRight: function moveInRight(mesh, _ref2) {
      var time = _ref2.time,
          initPosX = _ref2.initPosX,
          posX = _ref2.posX;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var tween1 = new __WEBPACK_IMPORTED_MODULE_4__tweenjs_tween_js___default.a.Tween(mesh.position).to({ x: '+' + posX }, 0).onComplete(function () {
          resolve();
        });

        var tween2 = new __WEBPACK_IMPORTED_MODULE_4__tweenjs_tween_js___default.a.Tween(mesh.position).to({ x: '-' + posX }, time).easing(__WEBPACK_IMPORTED_MODULE_4__tweenjs_tween_js___default.a.Easing.Quadratic.Out).onUpdate(function () {
          // this.opacity(mesh, v.opacity)
        }).onComplete(function () {
          resolve();
        });

        tween1.chain(tween2).start();
      });
    },
    stretchIn: function stretchIn(mesh, _ref3) {
      var _this3 = this;

      var time = _ref3.time,
          scale = _ref3.scale,
          opacity = _ref3.opacity,
          initScale = _ref3.initScale,
          initOpacity = _ref3.initOpacity,
          delay = _ref3.delay;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var temp = new __WEBPACK_IMPORTED_MODULE_6_three__["Vector3"](initScale.x, initScale.y, initScale.z);
        var v = {
          scaleX: initScale.x || 0,
          scaleY: initScale.y || 0,
          scaleZ: initScale.z || 0,
          opacity: initOpacity || 0
        };
        delay = delay || 0;

        new __WEBPACK_IMPORTED_MODULE_4__tweenjs_tween_js___default.a.Tween(v).to({ scaleX: scale, scaleY: scale, scaleZ: scale, opacity: opacity }, time).easing(__WEBPACK_IMPORTED_MODULE_4__tweenjs_tween_js___default.a.Easing.Quadratic.Out).onUpdate(function () {
          _this3.opacity(mesh, v.opacity);
          temp.set(v.scaleX, v.scaleY, v.scaleZ);
          _this3.scaleTHREE(mesh, temp);
        }).delay(delay).onComplete(function () {
          resolve();
        }).start();
      });
    },
    animateAll: function animateAll() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.opacity(_this4.$refs['@agree@header@title'].mesh, 0);
                _this4.opacity(_this4.$refs['@agree@header@title2'].mesh, 0);
                _this4.opacity(_this4.$refs['@agree@bg@rex'].mesh, 0);
                _this4.opacity(_this4.$refs['@agree@tagline@title'].mesh, 0);

                _this4.stretchIn(_this4.$refs['@agree@grunge@punch-icon'].mesh, { time: 0, scale: 0.0000001, opacity: 0.0, initScale: { x: 0.00000001, y: 0.00000001, z: 1 }, initOpacity: 0, delay: 0 });
                _this4.stretchIn(_this4.$refs['@agree@grunge@punch-about'].mesh, { time: 0, scale: 0.0000001, opacity: 0.0, initScale: { x: 0.00000001, y: 0.00000001, z: 1 }, initOpacity: 0, delay: 0 });

                _this4.opacity(_this4.$refs['@agree@desc@punch-icon'].mesh, 0);
                _this4.opacity(_this4.$refs['@agree@desc@punch-about'].mesh, 0);

                _this4.opacity(_this4.$refs['@agree@grunge@enter-now'].mesh, 0);
                _this4.opacity(_this4.$refs['@agree@agree@agree-rule'].mesh, 0);
                _this4.opacity(_this4.$refs['@agree@agree@box-unchecked'].mesh, 0);
                _this4.opacity(_this4.$refs['@agree@agree@box-checked'].mesh, 0);

                _context.next = 14;
                return _this4.sleep(100);

              case 14:
                _this4.opacity(_this4.$refs['@agree@grunge@enter-now'].mesh, 0);

                _context.next = 17;
                return _this4.sleep(500);

              case 17:
                _this4.shakeShake(_this4.shakeStack.title1, { x: 0, y: 10, z: 0 }, 700, 1.0);
                _context.next = 20;
                return _this4.sleep(0);

              case 20:
                _this4.revealMove(_this4.$refs['@agree@header@title2'].mesh, _this4.revealStack.title2, 400, { x: 0, y: 3, z: 0 });
                _context.next = 23;
                return _this4.sleep(0);

              case 23:
                _this4.scaleIn(_this4.$refs['@agree@bg@rex'].mesh, { time: 1500, scale: 0.5, opacity: 1.0, initScale: 0.45, initOpacity: 0, delay: 0 });
                _context.next = 26;
                return _this4.sleep(0);

              case 26:
                _context.next = 28;
                return _this4.shakeShake(_this4.shakeStack.rexBG, { x: 0, y: 0, z: 50 }, 500, 1.0);

              case 28:
                _context.next = 30;
                return _this4.sleep(500);

              case 30:
                // this.shakeShake(this.shakeStack.tagline, { x: 0, y: 10, z: 0 }, 500, 1.0)
                _this4.revealMove(_this4.$refs['@agree@tagline@title'].mesh, _this4.revealStack.tagline, 400, { x: 0, y: 3, z: 0 });
                _this4.stretchIn(_this4.$refs['@agree@grunge@punch-icon'].mesh, { time: 500, scale: _this4.aspect, opacity: 1.0, initScale: { x: _this4.aspect, y: _this4.aspect, z: 1 }, initOpacity: 0, delay: 0 });
                _this4.stretchIn(_this4.$refs['@agree@grunge@punch-about'].mesh, { time: 500, scale: _this4.aspect, opacity: 1.0, initScale: { x: _this4.aspect, y: _this4.aspect, z: 1 }, initOpacity: 0, delay: 0 });

                _context.next = 35;
                return _this4.sleep(100);

              case 35:
                _this4.revealMove(_this4.$refs['@agree@desc@punch-icon'].mesh, _this4.revealStack.punchIcon, 300, { x: 0, y: 3, z: 0 });
                _this4.revealMove(_this4.$refs['@agree@desc@punch-about'].mesh, _this4.revealStack.punchAbout, 300, { x: 0, y: 3, z: 0 });
                _this4.revealMove(_this4.$refs['@agree@agree@agree-rule'].mesh, _this4.revealStack.agreeRule, 500, { x: 0, y: 3, z: 0 });

                // checker
                _context.next = 40;
                return _this4.revealMove(_this4.$refs['@agree@agree@box-unchecked'].mesh, _this4.revealStack.uncheckBox, 500, { x: 0, y: 3, z: 0 });

              case 40:

                // check action
                _this4.stretchIn(_this4.$refs['@agree@agree@box-checked'].mesh, { time: 500, scale: _this4.aspect, opacity: 1.0, initScale: { x: 1, y: 1, z: 1 }, initOpacity: 0, delay: 0 });
                _context.next = 43;
                return _this4.revealMove(_this4.$refs['@agree@agree@box-checked'].mesh, _this4.revealStack.checkedBox, 500, { x: 0, y: 0, z: 0 });

              case 43:
                _context.next = 45;
                return _this4.sleep(150);

              case 45:
                _context.next = 47;
                return _this4.revealMove(_this4.$refs['@agree@grunge@enter-now'].mesh, _this4.revealStack.enterNow, 300, { x: 0, y: 30, z: 0 });

              case 47:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    __add: function __add(v) {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$parent.scene.add(v);
      });
    },
    __remove: function __remove(v) {
      var _this6 = this;

      this.$nextTick(function () {
        _this6.$parent.scene.remove(v);
      });
    },
    toggleBox: function toggleBox() {
      this.checkedBox = !this.checkedBox;
    },
    exec: function exec() {
      for (var exe in this.execStack) {
        this.execStack[exe]();
      }
    }
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__boxingArea__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__ = __webpack_require__(5);

//
//
//
//

// import TWEEN from '@tweenjs/tween.js'



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BoxingArea',
  props: {
    vms: {
      type: String
    },
    totalTime: {
      type: Number,
      default: 3000
    }
  },
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__["a" /* default */]),
  data: function data() {
    return {
      progress: 0,
      texture: false,
      api: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__boxingArea__["a" /* default */])({ refresher: this.refresher })
    };
  },

  watch: {
    texture: function texture() {}
  },
  methods: {
    refresher: function refresher() {
      if (this.texture) {
        this.texture.needsUpdate = true;
      }
    },
    reset: function reset() {
      this.api.reset();
      if (this.texture) {
        this.texture.needsUpdate = true;
      }
    },
    start: function start() {
      this.api.start();

      console.log('start count down');
      this.startTime = window.performance.now();
      var self = this;
      self.progress = 0;
      window.requestAnimationFrame(function loopsy() {
        self.progress = (window.performance.now() - self.startTime) / self.totalTime;
        self.api.draw(self.progress || 0);
        if (self.texture) {
          self.texture.needsUpdate = true;
        }
        if (self.progress <= 1) {
          window.requestAnimationFrame(loopsy);
        } else {
          self.$emit('done');
        }
      });
    },
    __add: function __add(v) {
      this.$parent.object3d.add(v);
    },
    __remove: function __remove(v) {
      this.$parent.object3d.remove(v);
    }
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_WebGL_Mixins_FadeInOut__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NikeWebGL_Pages_BoxingCamp_BoxingArea_BoxingArea_vue__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NikeWebGL_Pages_BoxingCamp_BoxingArea_BoxingArea_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_NikeWebGL_Pages_BoxingCamp_BoxingArea_BoxingArea_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_WebGL_Bundle__ = __webpack_require__(5);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BoxingCamp',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_WebGL_Mixins_FadeInOut__["a" /* default */]],
  components: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    BoxingArea: __WEBPACK_IMPORTED_MODULE_5__components_NikeWebGL_Pages_BoxingCamp_BoxingArea_BoxingArea_vue___default.a
  }, __WEBPACK_IMPORTED_MODULE_6__components_WebGL_Bundle__["a" /* default */]),
  props: ['aspect'],
  data: function data() {
    return {
      revealStack: {},
      shakeStack: {},
      execStack: {
        grungeBg: function grungeBg() {}
      },
      tweening: false
    };
  },
  activated: function activated() {
    this.animateAll();
    this.$emit('exec', this.exec);
  },
  deactivated: function deactivated() {
    this.$emit('exec', function () {});
  },

  methods: {
    opacity: function opacity(mesh, v) {
      mesh.material.opacity = v;
      if (mesh.material.uniforms) {
        mesh.material.uniforms.opacity.value = v;
      }
    },
    scale: function scale(mesh, v) {
      mesh.scale.x = v;
      mesh.scale.y = v;
      mesh.scale.z = v;
    },
    position: function position(mesh, pos) {
      mesh.position.x = pos.x;
      mesh.position.y = pos.y;
      mesh.position.z = pos.z;
    },
    strech: function strech(mesh, v) {
      mesh.scale.y = v;
    },
    fadeInItems: function fadeInItems(item) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var opacity = _this.opacity;

        var updater = function updater(mesh) {
          opacity(item.mesh, 0);
          var v = { v: 0 };
          new _this.TWEEN.Tween(v).to({ v: 1 }, 500).onUpdate(function () {
            opacity(mesh, v.v);
          }).easing(_this.TWEEN.Easing.Quadratic.Out).onComplete(function () {
            resolve();
          }).start();
        };

        if (item) {
          updater(item.mesh);
        }
      });
    },
    fadeInZoom: function fadeInZoom(item) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var opacity = _this2.opacity;
        var scale = _this2.scale;

        var updater = function updater(mesh) {
          var origScale = item.mesh.scale.x;
          scale(item.mesh, item.mesh.scale.x * 0.98);
          opacity(item.mesh, 0);
          var v = { v: 0, s: item.mesh.scale.x * 0.98 };
          new _this2.TWEEN.Tween(v).to({ v: 1, s: origScale }, 2000).onUpdate(function () {
            opacity(mesh, v.v);
            scale(mesh, v.s);
          }).easing(_this2.TWEEN.Easing.Quadratic.Out).onComplete(function () {}).start();

          setTimeout(function () {
            resolve();
          }, 1500);
        };

        if (item) {
          updater(item.mesh);
        }
      });
    },
    shakeShake: function shakeShake(item, shaker, pos) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (item) {
          shaker({ initPos: pos });
          setTimeout(function () {
            resolve();
          }, 333);
        }
      });
    },
    revealMove: function revealMove(item, revaler, pos) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (item) {
          revaler({ initPos: pos });
          setTimeout(function () {
            resolve();
          }, 500);
        }
      });
    },
    animateAll: function animateAll() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.$refs['boxing-area'].reset();
                _this3.opacity(_this3.$refs['@landing@bg@boxing'].mesh, 0);

                _this3.opacity(_this3.$refs['@landing@shake@nike'].mesh, 0);
                _this3.opacity(_this3.$refs['@landing@shake@boxing'].mesh, 0);
                _this3.opacity(_this3.$refs['@landing@shake@camp'].mesh, 0);

                _this3.opacity(_this3.$refs['@landing@reveal@box-txt-1'].mesh, 0);
                _this3.opacity(_this3.$refs['@landing@reveal@box-txt-2'].mesh, 0);
                _this3.opacity(_this3.$refs['@landing@reveal@box-btn-game'].mesh, 0);
                _this3.opacity(_this3.$refs['@landing@reveal@box-btn-comics'].mesh, 0);

                // this.opacity(this.$refs['@landing@hero@camp'].mesh, 0)
                // this.opacity(this.$refs['@landing@button-area@bg'].mesh, 0)
                // this.opacity(this.$refs['@landing@button-area@enter-now'].mesh, 0)
                // this.opacity(this.$refs['@landing@button-area@watch-comics'].mesh, 0)

                _context.next = 11;
                return _this3.waitSec(1000);

              case 11:
                _context.next = 13;
                return _this3.fadeInZoom(_this3.$refs['@landing@bg@boxing']);

              case 13:
                _context.next = 15;
                return _this3.shakeShake(_this3.$refs['@landing@shake@boxing'], _this3.shakeStack.s1, { x: 13, y: 0, z: 0 });

              case 15:
                _context.next = 17;
                return _this3.shakeShake(_this3.$refs['@landing@shake@nike'], _this3.shakeStack.s2, { x: 13, y: 0, z: 0 });

              case 17:
                _context.next = 19;
                return _this3.shakeShake(_this3.$refs['@landing@shake@camp'], _this3.shakeStack.s3, { x: -13, y: 0, z: 0 });

              case 19:
                _context.next = 21;
                return _this3.waitSec(100);

              case 21:

                _this3.$refs['boxing-area'].start();
                _context.next = 24;
                return _this3.waitSec(500);

              case 24:
                _this3.revealMove(_this3.$refs['@landing@reveal@box-btn-game'], _this3.revealStack.r3, { x: 0, y: 10, z: 0 });
                _context.next = 27;
                return _this3.waitSec(400);

              case 27:
                _this3.revealMove(_this3.$refs['@landing@reveal@box-txt-1'], _this3.revealStack.r1, { x: 0, y: 10, z: 0 });
                _context.next = 30;
                return _this3.waitSec(120);

              case 30:
                _this3.revealMove(_this3.$refs['@landing@reveal@box-txt-2'], _this3.revealStack.r2, { x: 0, y: 10, z: 0 });
                _this3.revealMove(_this3.$refs['@landing@reveal@box-btn-comics'], _this3.revealStack.r4, { x: 0, y: 10, z: 0 });

                // await this.fadeInItems(this.$refs['@landing@hero@camp'])
                // await this.fadeInItems(this.$refs['@landing@button-area@bg'])
                // this.fadeInItems(this.$refs['@landing@button-area@watch-comics'])
                // this.fadeInItems(this.$refs['@landing@button-area@enter-now'])

              case 32:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    __add: function __add(v) {
      this.$parent.scene.add(v);
    },
    __remove: function __remove(v) {
      this.$parent.scene.remove(v);
    },
    exec: function exec() {
      for (var exe in this.execStack) {
        this.execStack[exe]();
      }
    }
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Shared_cache_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WebGL_Mixins_FadeInOut__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_WebGL_Bundle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_WebGL_Mixins_scroller__ = __webpack_require__(31);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








function cacheStuff() {
  __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Shared_cache_js__["g" /* textureCache */].setCache(__webpack_require__(92));
  __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Shared_cache_js__["g" /* textureCache */].setCache(__webpack_require__(93));
  __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Shared_cache_js__["g" /* textureCache */].setCache(__webpack_require__(94));
  __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Shared_cache_js__["g" /* textureCache */].setCache(__webpack_require__(95));

  __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Shared_cache_js__["g" /* textureCache */].setCache(__webpack_require__(168));
  __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Shared_cache_js__["g" /* textureCache */].setCache(__webpack_require__(169));
  __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Shared_cache_js__["g" /* textureCache */].setCache(__webpack_require__(170));
  __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Shared_cache_js__["g" /* textureCache */].setCache(__webpack_require__(171));
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ComicList',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_WebGL_Mixins_FadeInOut__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__components_WebGL_Mixins_scroller__["a" /* default */]],
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4__components_WebGL_Bundle__["a" /* default */]),
  props: ['aspect'],
  created: function created() {
    cacheStuff();
  },
  data: function data() {
    return {
      TWEEN: __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default.a,
      mouseStack: {},
      execStack: {},
      tweening: false,
      raycaster: false,

      rAFID: 0,
      comics: {
        defaultXPos: 0,
        defaultYPos: 0,
        isDraggin: false,
        found: false,
        state: {
          status: 'ready',
          tsX: 0,
          tsY: 0,
          dX: 0,
          dY: 0,
          aX: 0,
          aY: 0
        }
      }
    };
  },

  watch: {
    params: function params() {
      var _this = this;

      this.scrollerState.dY = 10;
      setTimeout(function () {
        _this.intro();
      }, 0);
    }
  },
  computed: {
    params: function params() {
      return this.$route.params.id;
    }
  },
  activated: function activated() {
    var _this2 = this;

    // this.$refs['comics-content']

    this.$emit('exec', function () {
      for (var execItem in _this2.execStack) {
        var exec = _this2.execStack[execItem];
        if (exec) {
          exec();
        }
      }
    });

    this.$emit('setMouse', function (args) {
      // this.mouseStack.scroller(args)
      // this.mouseStack.comics(args)
      for (var name in _this2.mouseStack) {
        var exec = _this2.mouseStack[name];
        if (exec) {
          // console.log(this.mouseStack)
          exec(args);
        }
      }
    });

    this.mouseStack.scroller = function (args) {
      if (!_this2.comics.isDraggin || Math.abs(_this2.comics.state.aY) > 3.0) {
        _this2.scrollEntry(args);
      }
    };

    this.rAF = function () {
      _this2.rAFID = window.requestAnimationFrame(_this2.rAF);
      var pos = _this2.$refs['comics-content'].object3d.position;

      pos.x += _this2.comics.state.dX;

      var needReset = false;
      if (pos.x > 0) {
        var goal = -pos.x;
        pos.x = pos.x + goal;
        needReset = true;
      }
      var currentComic = _this2.getCurrentComic();
      if (currentComic && currentComic.vmsObj) {
        var info = currentComic.readRectInfo;
        if (pos.x < -(info.meshWidth * info.aspect - info.screenWidth)) {
          var _goal = Math.abs(pos.x + (info.meshWidth * info.aspect - info.screenWidth));
          pos.x = pos.x + _goal;
          needReset = true;
        }
      }

      if (!needReset) {
        _this2.comics.state.aX += _this2.comics.state.dX;
        _this2.comics.state.aY += _this2.comics.state.dY;
        _this2.comics.state.dX *= 0.96;
        _this2.comics.state.dY *= 0.96;
      } else {
        _this2.comics.state.dX = 0;
        _this2.comics.state.dY = 0;
      }
    };
    this.rAFID = window.requestAnimationFrame(this.rAF);

    var intro = this.intro = function () {
      var pos = _this2.$refs['comics-content'].object3d.position;
      var currentComic = _this2.getCurrentComic();
      if (currentComic && currentComic.vmsObj) {
        var info = currentComic.readRectInfo;
        pos.x = -(info.meshWidth * info.aspect + info.screenWidth);
      }
      setTimeout(function () {
        _this2.comics.state.dX = 5.5;
      }, 100);
    };
    setTimeout(intro, 0);

    this.mouseStack.comics = function (args) {
      _this2.eventHandler(args);
    };

    this.setupScroller({
      target: this.$refs['page-content'],
      enable: { x: false, y: true },
      bound: this.scrollerState.bound
      // bound: {
      //   yMax: 50,
      //   yMin: 0,
      //   xMax: 0,
      //   xMin: 0
      // }
    });
  },
  deactivated: function deactivated() {
    this.cleanupScroller();
    this.mouseStack = {};
    this.execStack = {};
    window.cancelAnimationFrame(this.rAFID);
  },

  methods: {
    eventHandler: function eventHandler(args) {
      switch (args.type) {
        case 'ts':
          this.onTS(args);
          break;
        case 'tm':
          this.onTM(args);
          break;
        case 'te':
          this.onTE(args);
          break;

        case 'mdn':
          this.onTS(args);
          break;
        case 'mup':
          this.onTE(args);
          break;
        case 'mv':
          this.onTM(args);
          break;
      }
    },

    // onGTS (v) {
    //   console.log(v)
    //   this.comics.found = v
    //   this.comics.isDraggin = true
    // },
    onTS: function onTS(_ref) {
      var pageX = _ref.pageX,
          pageY = _ref.pageY,
          rect = _ref.rect;

      var raycaster = this.getRayCaster();
      // raycaster.run = true
      this.comics.found = raycaster.raycastNow();
      if (this.comics.found.found[0] && this.comics.found.found[0].object.userData.$component.vms.indexOf('@comic-detail@comics@s-') === 0) {
        this.comics.isDraggin = true;
      }

      this.comics.state.status = 'ts';
      this.comics.state.tsX = pageX - rect.left;
      this.comics.state.tsY = pageY - rect.top;
    },
    onTM: function onTM(_ref2) {
      var pageX = _ref2.pageX,
          pageY = _ref2.pageY,
          rect = _ref2.rect;

      if (!this.comics.isDraggin) {
        return;
      }
      this.comics.state.status = 'tm';

      this.comics.state.dX = pageX - rect.left - this.comics.state.tsX;
      this.comics.state.dY = pageY - rect.top - this.comics.state.tsY;

      this.comics.state.tsX = pageX - rect.left;
      this.comics.state.tsY = pageY - rect.top;

      this.comics.state.dX *= 0.14;
      this.comics.state.dY *= 0.14;
    },
    onTE: function onTE() {
      this.comics.isDraggin = false;
    },
    getCurrentComic: function getCurrentComic() {
      return this.$refs['s-' + this.$route.params.id];
    },
    getRayCaster: function getRayCaster() {
      return this.$parent.$parent.raycaster;
    },
    goComics: function goComics(id) {
      this.$router.push({ path: '/nike/game/comic-detail/' + id });
    },
    isAtPage: function isAtPage(page) {
      return page + '' === this.$route.params.id + '';
    },
    __add: function __add(v) {
      this.$parent.scene.add(v);
    },
    __remove: function __remove(v) {
      this.$parent.scene.remove(v);
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WebGL_Mixins_FadeInOut__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WebGL_Mixins_scroller__ = __webpack_require__(31);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ComicList',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_WebGL_Mixins_FadeInOut__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__components_WebGL_Mixins_scroller__["a" /* default */]],
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__["a" /* default */]),
  props: ['aspect'],
  data: function data() {
    return {
      mouseStack: {},
      execStack: {},
      tweening: false
    };
  },
  activated: function activated() {
    var _this = this;

    this.$emit('exec', function () {
      for (var execItem in _this.execStack) {
        var exec = _this.execStack[execItem];
        if (exec) {
          exec();
        }
      }
    });
    this.$emit('setMouse', function (args) {
      for (var name in _this.mouseStack) {
        var exec = _this.mouseStack[name];
        if (exec) {
          exec(args);
        }
      }
    });
    this.setupScroller({
      target: this.$refs['page-content'],
      enable: { x: false, y: true },
      bound: this.scrollerState.bound
      // bound: {
      //   yMax: 10,
      //   yMin: 0,
      //   xMax: 0,
      //   xMin: 0
      // }
    });
    this.emitHandler();
  },
  deactivated: function deactivated() {
    this.cleanupScroller();
  },

  methods: {
    __add: function __add(v) {
      this.$parent.scene.add(v);
    },
    __remove: function __remove(v) {
      this.$parent.scene.remove(v);
    }
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WebGL_Mixins_FadeInOut__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Mixins_scroller__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WebGL_Bundle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NikeWebGL_Pages_DailyTask_Slider__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NikeWebGL_Pages_DailyTask_Slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_NikeWebGL_Pages_DailyTask_Slider__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DailyTask',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_WebGL_Mixins_FadeInOut__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Mixins_scroller__["a" /* default */]],
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__components_WebGL_Bundle__["a" /* default */], {
    Slider: __WEBPACK_IMPORTED_MODULE_4__components_NikeWebGL_Pages_DailyTask_Slider___default.a
  }),
  props: ['aspect', 'raycaster'],
  data: function data() {
    return {
      mouseStack: {},
      execStack: {},
      tweening: false
    };
  },
  activated: function activated() {
    var _this = this;

    this.$emit('exec', function () {
      for (var execItem in _this.execStack) {
        var exec = _this.execStack[execItem];
        if (exec) {
          exec();
        }
      }
    });
    this.$emit('setMouse', function (args) {
      for (var name in _this.mouseStack) {
        var exec = _this.mouseStack[name];
        if (exec) {
          exec(args);
        }
      }
    });
    this.mouseStack.scroller = function (args) {
      _this.scrollEntry(args);
    };

    this.setupScroller({
      target: this.$refs['page-content'],
      enable: { x: false, y: true },
      bound: {
        yMax: 15,
        yMin: 0,
        xMax: 0,
        xMin: 0
      }
    });
  },
  deactivated: function deactivated() {
    this.cleanupScroller();
  },

  methods: {
    __add: function __add(v) {
      this.$parent.scene.add(v);
    },
    __remove: function __remove(v) {
      this.$parent.scene.remove(v);
    }
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__["a" /* default */]),
  data: function data() {
    return {
      TWEEN: __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default.a,
      raycaster: false,
      mouseStack: {},
      execStack: {},
      rAFID: 0,
      slider: {
        defaultXPos: 0,
        isDraggin: false,
        found: false,
        redeemed: false,
        state: {
          status: 'ready',
          tsX: 0,
          tsY: 0,
          dX: 0,
          dY: 0,
          aX: 0,
          aY: 0
        }
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$emit('exec', function () {
      for (var execItem in _this.execStack) {
        var exec = _this.execStack[execItem];
        if (exec) {
          exec();
        }
      }
    });

    this.$emit('setMouse', function (args) {
      for (var name in _this.mouseStack) {
        var exec = _this.mouseStack[name];
        if (exec) {
          exec(args);
        }
      }
    });

    this.rAF = function () {
      _this.rAFID = window.requestAnimationFrame(_this.rAF);
      var pos = _this.$refs['slider-handle'].mesh.position;

      pos.x += _this.slider.state.dX;

      _this.slider.state.aX += _this.slider.state.dX;
      _this.slider.state.aY += _this.slider.state.dY;
      _this.slider.state.dX *= 0.96;
      _this.slider.state.dY *= 0.96;
    };
    this.rAFID = window.requestAnimationFrame(this.rAF);

    this.mouseStack.slider = function (args) {
      _this.eventHandler(args);
    };
  },
  beforeDestroy: function beforeDestroy() {
    window.cancelAnimationFrame(this.rAFID);
  },

  methods: {
    eventHandler: function eventHandler(args) {
      switch (args.type) {
        case 'ts':
          this.onTS(args);
          break;
        case 'tm':
          this.onTM(args);
          break;
        case 'te':
          this.onTE(args);
          break;
      }
    },
    onGTS: function onGTS(v) {
      console.log(v);
      this.slider.found = v;
      this.slider.isDraggin = true;
    },
    onTS: function onTS(_ref) {
      var pageX = _ref.pageX,
          pageY = _ref.pageY,
          rect = _ref.rect;

      if (this.slider.redeemed) {
        return;
      }
      if (!this.slider.state.tweening) {
        this.slider.state.originalX = this.$refs['slider-handle'].mesh.position.x;
      }

      var raycaster = this.getRayCaster();
      raycaster.run = true;

      this.slider.state.status = 'ts';
      this.slider.state.tsX = pageX - rect.left;
      this.slider.state.tsY = pageY - rect.top;
    },
    onTM: function onTM(_ref2) {
      var pageX = _ref2.pageX,
          pageY = _ref2.pageY,
          rect = _ref2.rect;

      if (this.slider.redeemed || !this.slider.isDraggin) {
        return;
      }
      // console.log(args)
      this.slider.state.status = 'tm';

      this.slider.state.dX = pageX - rect.left - this.slider.state.tsX;
      this.slider.state.dY = pageY - rect.top - this.slider.state.tsY;

      this.slider.state.tsX = pageX - rect.left;
      this.slider.state.tsY = pageY - rect.top;

      this.slider.state.dX *= 0.17;
      this.slider.state.dY *= 0.17;
    },
    onTE: function onTE() {
      var _this2 = this;

      this.slider.isDraggin = false;
      if (this.slider.state.tweening) {
        return;
      }
      var pos = this.$refs['slider-handle'].mesh.position;
      var to = { x: pos.x - this.slider.state.aX };
      if (Math.abs(pos.x - this.slider.state.originalX) > -this.slider.state.originalX * 2 * 0.75) {
        to = { x: -this.slider.state.originalX };
        this.slider.redeemed = true;
      }

      this.slider.state.tweening = true;
      var tween = new __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default.a.Tween(pos).to(to, 1000).onUpdate(function () {
        _this2.slider.state.dX = 0;
        _this2.slider.state.aX = 0;
      }).onComplete(function () {
        _this2.slider.state.tweening = false;
      });
      tween.start();
    },
    getRayCaster: function getRayCaster() {
      return this.$parent.$parent.raycaster;
    },
    __add: function __add(v) {
      this.$parent.object3d.add(v);
      // this.$parent.$parent.$parent.scene.add(v)
    },
    __remove: function __remove(v) {
      this.$parent.object3d.remove(v);
      // this.$parent.$parent.$parent.scene.remove(v)
    }
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_three__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Prototypes_Visual_Woody_Woody_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Prototypes_Visual_Woody_Woody_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Prototypes_Visual_Woody_Woody_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_WebGL_Mixins_FadeInOut__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_WebGL_Bundle__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Rules',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_WebGL_Mixins_FadeInOut__["a" /* default */]],
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__components_WebGL_Bundle__["a" /* default */], {
    Woody: __WEBPACK_IMPORTED_MODULE_3__components_Prototypes_Visual_Woody_Woody_vue___default.a
  }),
  props: ['aspect'],
  data: function data() {
    return {
      TWEEN: __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default.a,
      THREE: __WEBPACK_IMPORTED_MODULE_2_three__,
      execStack: {},
      tweening: false
    };
  },
  mounted: function mounted() {},
  activated: function activated() {
    this.fadeInCurtain();
    this.$emit('exec', this.exec);
  },
  deactivated: function deactivated() {
    this.$emit('exec', function () {});
  },

  methods: {
    fadeInCurtain: function fadeInCurtain() {
      // var vm = this
      // setTimeout(() => {
      //   // var mesh = this.$refs['@login@bg@hider'].mesh
      //   var posGettter = {
      //     get pos () {
      //       var ans = { x: 0, y: 0, z: 0 }
      //       try {
      //         ans = vm.$refs['@login@bg@hider'].mesh.position
      //       } catch (e) {
      //       }

      //       return ans
      //     }
      //   }
      //   var tween = new this.TWEEN.Tween(posGettter.pos)
      //   .to({
      //     y: '-100'
      //   }, 1000)
      //   .easing(TWEEN.Easing.Quadratic.Out)

      //   var tween2 = new this.TWEEN.Tween(posGettter.pos)
      //   .to({
      //     y: '+100'
      //   }, 0)
      //   setTimeout(() => {
      //     tween2.chain(tween).start()
      //   }, 10)
      // }, 10)
    },
    demo: function demo(msg) {
      alert(msg);
    },
    __add: function __add(v) {
      this.$parent.scene.add(v);
    },
    __remove: function __remove(v) {
      this.$parent.scene.remove(v);
    },
    exec: function exec() {
      for (var exe in this.execStack) {
        this.execStack[exe]();
      }
    }
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WebGL_Mixins_FadeInOut__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RingCounter_RingCounter__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RingCounter_RingCounter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RingCounter_RingCounter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NumberCounter_NumberCounter_vue__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NumberCounter_NumberCounter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__NumberCounter_NumberCounter_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Countdown',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_WebGL_Mixins_FadeInOut__["a" /* default */]],
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__["a" /* default */], {
    RingCounter: __WEBPACK_IMPORTED_MODULE_3__RingCounter_RingCounter___default.a,
    NumberCounter: __WEBPACK_IMPORTED_MODULE_4__NumberCounter_NumberCounter_vue___default.a
  }),
  props: ['aspect', 'camera'],
  data: function data() {
    return {
      execStack: {},
      tweening: false
    };
  },

  computed: {
    isViewingPage: function isViewingPage() {
      return this.$router.currentRoute.fullPath.indexOf('game/play/countdown') !== -1;
    }
  },
  activated: function activated() {
    var _this = this;

    this.$emit('exec', function () {
      for (var execItem in _this.execStack) {
        var exec = _this.execStack[execItem];
        if (exec) {
          exec();
        }
      }
    });
    this.$nextTick(function () {
      _this.startBoth();
    });
  },
  deactivated: function deactivated() {
    this.$emit('exec', function () {});
  },

  methods: {
    startBoth: function startBoth() {
      if (this.$refs['ring-counter']) {
        this.$refs['ring-counter'].start();
      }
      if (this.$refs['number-counter']) {
        this.$refs['number-counter'].start();
      }
    },
    onPageEnter: function onPageEnter(v, done) {
      var _this2 = this;

      this.pageFadeIn(v, done);
      setTimeout(function () {
        _this2.startBoth();
      }, 500);
    },
    __add: function __add(v) {
      this.$parent.$parent.$parent.scene.add(v);
    },
    __remove: function __remove(v) {
      this.$parent.$parent.$parent.scene.remove(v);
    }
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NumberCounter__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__ = __webpack_require__(5);

//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NumberCounter',
  props: {
    word: {
      default: function _default() {
        return '';
      }
    },
    vms: {
      type: String
    },
    totalTime: {
      type: Number,
      default: 300
    }
  },
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__["a" /* default */]),
  data: function data() {
    return {
      rAFID: 0,
      progress: 0,
      texture: false,
      api: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__NumberCounter__["a" /* default */])()
    };
  },

  watch: {
    texture: function texture() {}
  },
  methods: {
    draw: function draw() {
      var _this = this;

      var rAF = function rAF() {
        _this.api.drawStroke(_this.word || 0);
        if (_this.texture) {
          _this.texture.needsUpdate = true;
        }
        _this.rAFID = window.requestAnimationFrame(rAF);
      };
      this.rAFID = window.requestAnimationFrame(rAF);
    },
    start: function start() {
      console.log('start number count down');
      this.startTime = window.performance.now();
      var self = this;
      self.progress = 0;
      window.requestAnimationFrame(function loopsy() {
        self.progress = (window.performance.now() - self.startTime) / self.totalTime;
        var value = Math.abs(Math.ceil((1.0 - self.progress) * self.totalTime / 1000).toFixed(0));
        if (value > 0) {
          self.api.draw(value || 0);
        }
        if (self.texture) {
          self.texture.needsUpdate = true;
        }
        if (self.progress <= 1) {
          window.requestAnimationFrame(loopsy);
        } else {
          self.$emit('done');
        }
      });
    },
    __add: function __add(v) {
      this.$parent.object3d.add(v);
    },
    __remove: function __remove(v) {
      window.cancelAnimationFrame(this.rAFID);
      this.$parent.object3d.remove(v);
    }
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Prototypes_Visual_Woody_Woody_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Prototypes_Visual_Woody_Woody_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Prototypes_Visual_Woody_Woody_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Shared_system__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WebGL_Mixins_FadeInOut__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_WebGL_Bundle__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Play',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_WebGL_Mixins_FadeInOut__["a" /* default */]],
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    Woody: __WEBPACK_IMPORTED_MODULE_1__components_Prototypes_Visual_Woody_Woody_vue___default.a
  }, __WEBPACK_IMPORTED_MODULE_4__components_WebGL_Bundle__["a" /* default */]),
  props: ['aspect', 'camera'],
  data: function data() {
    return {
      execStack: {},
      mouseStack: {},
      glSystem: __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Shared_system__["a" /* glSystem */],
      tweening: false
    };
  },
  activated: function activated() {
    var _this = this;

    this.$emit('exec', function () {
      for (var execItem in _this.execStack) {
        var exec = _this.execStack[execItem];
        if (exec) {
          exec();
        }
      }
    });
    this.$emit('setMouse', function (args) {
      for (var name in _this.mouseStack) {
        var exec = _this.mouseStack[name];
        if (exec) {
          exec(args);
        }
      }
    });
  },
  deactivated: function deactivated() {},

  methods: {
    tweenWoody: function tweenWoody() {
      this.$refs.woody.punch({ magnitude: Math.abs(1.5 - Math.random()) });
    },
    __add: function __add(v) {
      this.$parent.scene.add(v);
    },
    __remove: function __remove(v) {
      this.$parent.scene.remove(v);
    }
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WebGL_Mixins_FadeInOut__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RingCounter_RingCounter__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RingCounter_RingCounter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RingCounter_RingCounter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NumberCounter_NumberCounter_vue__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NumberCounter_NumberCounter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__NumberCounter_NumberCounter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gyronorm_dist_gyronorm_complete_js__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gyronorm_dist_gyronorm_complete_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_gyronorm_dist_gyronorm_complete_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Logic_g_reduce__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Logic_g_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Logic_g_reduce__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global createjs */
createjs.Sound.alternateExtensions = ['mp3'];
var url = __webpack_require__(522);
createjs.Sound.registerSound({ src: url, id: 'dingding' });








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Record',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_WebGL_Mixins_FadeInOut__["a" /* default */]],
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__["a" /* default */], {
    RingCounter: __WEBPACK_IMPORTED_MODULE_3__RingCounter_RingCounter___default.a,
    NumberCounter: __WEBPACK_IMPORTED_MODULE_4__NumberCounter_NumberCounter_vue___default.a
  }),
  props: ['aspect', 'camera'],
  data: function data() {
    return {
      state: {
        count: 0,
        force: 0,
        punchData: []
      },
      execStack: {},
      tweening: false
    };
  },
  mounted: function mounted() {},

  computed: {
    isViewingPage: function isViewingPage() {
      return this.$router.currentRoute.fullPath.indexOf('game/play/record') !== -1;
    }
  },
  activated: function activated() {
    var _this = this;

    this.$emit('exec', function () {
      for (var execItem in _this.execStack) {
        var exec = _this.execStack[execItem];
        if (exec) {
          exec();
        }
      }
    });

    this.initCanvas();
  },
  deactivated: function deactivated() {
    this.$emit('exec', function () {});
  },

  methods: {
    playSound: function playSound() {
      createjs.Sound.play('dingding');
    },
    initCanvas: function initCanvas() {
      var _this2 = this;

      this.$refs['ring'].start();
      this.$refs['number-counter'].start();
      this.$refs['punch-counter'].draw();

      this.playSound();

      var gReduce = new __WEBPACK_IMPORTED_MODULE_6__Logic_g_reduce___default.a();
      this.state.force = 0;
      this.state.count = 0;
      this.state.punchData = gReduce.getTrack();

      var gn = new __WEBPACK_IMPORTED_MODULE_5_gyronorm_dist_gyronorm_complete_js___default.a();
      gn.init({ frequency: 20 }).then(function () {
        gReduce.setAccelThres(20);
        gReduce.setCallback(function (err, count, force) {
          if (err) {
            console.log(err);
          }
          _this2.$emit('punched', Math.random());
          _this2.state.count = count;
          _this2.state.force = force;
          _this2.state.punchData = gReduce.getTrack();

          if (_this2.isViewingPage) {
            navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
            if (navigator.vibrate) {
              navigator.vibrate(500);
            }
          }
        });
        gn.start(gReduce.digest);
      });
    },
    onPageEnter: function onPageEnter(v, done) {
      this.pageFadeIn(v, done);
      this.initCanvas();
    },
    __add: function __add(v) {
      this.$parent.$parent.$parent.scene.add(v);
    },
    __remove: function __remove(v) {
      this.$parent.$parent.$parent.scene.remove(v);
    }
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_three__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Mixins_FadeInOut__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WebGL_Mixins_scroller__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_WebGL_Bundle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RingCounter_RingCounter__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RingCounter_RingCounter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__RingCounter_RingCounter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NumberCounter_NumberCounter_vue__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NumberCounter_NumberCounter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__NumberCounter_NumberCounter_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Result',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_WebGL_Mixins_FadeInOut__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__components_WebGL_Mixins_scroller__["a" /* default */]],
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4__components_WebGL_Bundle__["a" /* default */], {
    RingCounter: __WEBPACK_IMPORTED_MODULE_5__RingCounter_RingCounter___default.a,
    NumberCounter: __WEBPACK_IMPORTED_MODULE_6__NumberCounter_NumberCounter_vue___default.a
  }),
  props: ['aspect', 'camera'],
  data: function data() {
    return {
      THREE: __WEBPACK_IMPORTED_MODULE_1_three__,

      execStack: {},
      tweening: false
    };
  },

  computed: {
    isViewingPage: function isViewingPage() {
      return this.$router.currentRoute.fullPath.indexOf('game/play/result') !== -1;
    }
  },
  activated: function activated() {
    var _this = this;

    this.$nextTick(function () {
      _this.startApp();
    });
  },
  deactivated: function deactivated() {
    this.$emit('exec', function () {});
  },

  methods: {
    alert: function alert(txt) {
      window.alert(txt);
    },
    go: function go(location) {
      window.location.assign(location);
    },
    startApp: function startApp() {
      var _this2 = this;

      if (this.$refs['number-counter']) {
        this.$refs['number-counter'].draw();
      }
      this.$emit('exec', function () {
        for (var execItem in _this2.execStack) {
          var exec = _this2.execStack[execItem];
          if (exec) {
            exec();
          }
        }
      });

      this.setupScroller({
        target: this.$refs['sub-page-content'],
        enable: { x: false, y: true },
        bound: this.scrollerState.bound
      });
      this.emitHandler();
    },
    onPageEnter: function onPageEnter(v, done) {
      var _this3 = this;

      this.pageFadeIn(v, done);
      setTimeout(function () {
        _this3.startApp();
      }, 500);
    },
    onPageLeave: function onPageLeave(v, done) {
      this.pageFadeOut(v, done);
      this.cleanupScroller();
    },
    __add: function __add(v) {
      this.$parent.$parent.$parent.scene.add(v);
    },
    __remove: function __remove(v) {
      this.$parent.$parent.$parent.scene.remove(v);
    }
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ArcCanvas__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__ = __webpack_require__(5);

//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RingCounter',
  props: {
    vms: {
      type: String
    },
    totalTime: {
      type: Number,
      default: 3000
    }
  },
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__["a" /* default */]),
  data: function data() {
    return {
      progress: 0,
      texture: false,
      api: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ArcCanvas__["a" /* default */])()
    };
  },

  watch: {
    texture: function texture() {}
  },
  methods: {
    start: function start() {
      console.log('start count down');
      this.startTime = window.performance.now();
      var self = this;
      self.progress = 0;
      window.requestAnimationFrame(function loopsy() {
        self.progress = (window.performance.now() - self.startTime) / self.totalTime;
        self.api.draw(self.progress || 0);
        if (self.texture) {
          self.texture.needsUpdate = true;
        }
        if (self.progress <= 1) {
          window.requestAnimationFrame(loopsy);
        } else {
          self.$emit('done');
        }
      });
    },
    __add: function __add(v) {
      this.$parent.object3d.add(v);
    },
    __remove: function __remove(v) {
      this.$parent.object3d.remove(v);
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tweenjs_tween_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StartAnimation_StartAnimation_vue__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StartAnimation_StartAnimation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__StartAnimation_StartAnimation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_three__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_WebGL_Mixins_FadeInOut__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_WebGL_Bundle__ = __webpack_require__(5);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Start',
  mixins: [__WEBPACK_IMPORTED_MODULE_7__components_WebGL_Mixins_FadeInOut__["a" /* default */]],
  components: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__components_WebGL_Bundle__["a" /* default */], {
    StartAnimation: __WEBPACK_IMPORTED_MODULE_5__StartAnimation_StartAnimation_vue___default.a
  }),
  props: ['aspect', 'camera'],
  data: function data() {
    return {
      THREE: __WEBPACK_IMPORTED_MODULE_6_three__,
      shakeStack: {
        s1: function s1() {}
      },
      execStack: {},
      tweening: false
    };
  },
  activated: function activated() {
    var _this = this;

    this.$emit('exec', function () {
      for (var execItem in _this.execStack) {
        var exec = _this.execStack[execItem];
        if (exec) {
          exec();
        }
      }
    });

    this.hideAll();
    this.animateAll();
  },
  deactivated: function deactivated() {
    if (this.$refs['@play@canvas@start-canvas']) {
      this.$refs['@play@canvas@start-canvas'].reset();
    }
  },

  methods: {
    shakeShake: function shakeShake(shaker, pos, time, ratio) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        shaker({ initPos: pos, timeRatio: ratio || 2.0 });
        setTimeout(function () {
          resolve();
        }, time);
      });
    },
    runBoxy: function runBoxy() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.$refs['@play@canvas@start-canvas'].start();
        resolve();
      });
    },
    opacity: function opacity(mesh, v) {
      mesh.material.opacity = v;
      if (mesh.material.uniforms) {
        mesh.material.uniforms.opacity.value = v;
      }
    },
    scale: function scale(mesh, v) {
      mesh.scale.x = v;
      mesh.scale.y = v;
      mesh.scale.z = v;
    },
    scaleIn: function scaleIn(mesh, _ref) {
      var _this3 = this;

      var time = _ref.time,
          scale = _ref.scale,
          opacity = _ref.opacity,
          initScale = _ref.initScale,
          initOpacity = _ref.initOpacity,
          delay = _ref.delay;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var v = {
          scale: initScale || 0,
          opacity: initOpacity || 0
        };
        delay = delay || 0;

        new __WEBPACK_IMPORTED_MODULE_4__tweenjs_tween_js___default.a.Tween(v).to({ scale: scale, opacity: opacity }, time).easing(__WEBPACK_IMPORTED_MODULE_4__tweenjs_tween_js___default.a.Easing.Quadratic.Out).onUpdate(function () {
          _this3.opacity(mesh, v.opacity);
          _this3.scale(mesh, v.scale);
        }).delay(delay).onComplete(function () {
          resolve();
        }).start();
      });
    },
    hideAll: function hideAll() {
      this.opacity(this.$refs['@play@start@hold-tight'].mesh, 0);
      this.opacity(this.$refs['@play@start@start-icon'].mesh, 0);
      this.opacity(this.$refs['@play@start@white-ball'].mesh, 0);
      this.opacity(this.$refs['@play@start@white-ball-text'].mesh, 0);
      this.scaleIn(this.$refs['@play@start@white-ball-text'].mesh, { delay: 0, time: 0, scale: 0, opacity: 0, initScale: 0 });
    },
    animateAll: function animateAll() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.hideAll();
                _context.next = 3;
                return _this4.sleep(10);

              case 3:
                _this4.hideAll();

                _context.next = 6;
                return _this4.sleep(1000);

              case 6:
                _context.next = 8;
                return _this4.shakeShake(_this4.shakeStack.s1, { x: 0, y: 30, z: 0 }, 700);

              case 8:
                _context.next = 10;
                return _this4.runBoxy();

              case 10:
                _context.next = 12;
                return _this4.sleep(1500);

              case 12:

                _this4.scaleIn(_this4.$refs['@play@start@white-ball'].mesh, { time: 500, scale: _this4.aspect * 0.85, opacity: 1 });
                _context.next = 15;
                return _this4.scaleIn(_this4.$refs['@play@start@white-ball-text'].mesh, { delay: 500, time: 1000, scale: _this4.aspect * 0.85, opacity: 1, initScale: _this4.aspect * 0.85 });

              case 15:
                _context.next = 17;
                return _this4.shakeShake(_this4.shakeStack.s2, { x: -80, y: 0, z: 0 }, 700);

              case 17:
                _context.next = 19;
                return _this4.sleep(300);

              case 19:
                _context.next = 21;
                return _this4.shakeShake(_this4.shakeStack.s2, { x: -35, y: 3, z: 0 }, 600, 2.0);

              case 21:
                _context.next = 23;
                return _this4.shakeShake(_this4.shakeStack.s2, { x: -30, y: -3, z: 0 }, 600, 2.0);

              case 23:
                _context.next = 25;
                return _this4.shakeShake(_this4.shakeStack.s2, { x: -35, y: 0, z: 0 }, 600, 2.0);

              case 25:
                _context.next = 27;
                return _this4.sleep(1300);

              case 27:
                _context.next = 29;
                return _this4.shakeShake(_this4.shakeStack.s2, { x: -35, y: 3, z: 0 }, 600, 2.0);

              case 29:
                _context.next = 31;
                return _this4.shakeShake(_this4.shakeStack.s2, { x: -30, y: -3, z: 0 }, 600, 2.0);

              case 31:
                _context.next = 33;
                return _this4.shakeShake(_this4.shakeStack.s2, { x: -35, y: 0, z: 0 }, 600, 2.0);

              case 33:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    __add: function __add(v) {
      this.$parent.$parent.$parent.scene.add(v);
    },
    __remove: function __remove(v) {
      this.$parent.$parent.$parent.scene.remove(v);
    }
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StartAnimation_js__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__ = __webpack_require__(5);

//
//
//
//

// import TWEEN from '@tweenjs/tween.js'



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StartAnimation',
  props: {
    vms: {
      type: String
    },
    totalTime: {
      type: Number,
      default: 3000
    }
  },
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__["a" /* default */]),
  data: function data() {
    return {
      progress: 0,
      texture: false,
      api: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__StartAnimation_js__["a" /* default */])({ refresher: this.refresher })
    };
  },

  watch: {
    texture: function texture() {}
  },
  methods: {
    refresher: function refresher() {
      if (this.texture) {
        this.texture.needsUpdate = true;
      }
    },
    reset: function reset() {
      this.api.reset();
      if (this.texture) {
        this.texture.needsUpdate = true;
      }
    },
    start: function start() {
      this.api.start();

      console.log('start count down');
      this.startTime = window.performance.now();
      var self = this;
      self.progress = 0;
      window.requestAnimationFrame(function loopsy() {
        self.progress = (window.performance.now() - self.startTime) / self.totalTime;
        self.api.draw(self.progress || 0);
        if (self.texture) {
          self.texture.needsUpdate = true;
        }
        if (self.progress <= 1) {
          window.requestAnimationFrame(loopsy);
        } else {
          self.$emit('done');
        }
      });
    },
    __add: function __add(v) {
      this.$parent.object3d.add(v);
    },
    __remove: function __remove(v) {
      this.$parent.object3d.remove(v);
    }
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WebGL_Mixins_FadeInOut__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Mixins_scroller__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WebGL_Bundle__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Rules',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_WebGL_Mixins_FadeInOut__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Mixins_scroller__["a" /* default */]],
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__components_WebGL_Bundle__["a" /* default */]),
  props: ['aspect'],
  data: function data() {
    return {
      mouseStack: {},
      execStack: {},
      tweening: false
    };
  },
  activated: function activated() {
    var _this = this;

    this.$emit('exec', function () {
      for (var execItem in _this.execStack) {
        var exec = _this.execStack[execItem];
        if (exec) {
          exec();
        }
      }
    });

    this.$emit('setMouse', function (args) {
      for (var name in _this.mouseStack) {
        var exec = _this.mouseStack[name];
        if (exec) {
          exec(args);
        }
      }
    });

    this.setupScroller({
      target: this.$refs['page-content'],
      enable: { x: false, y: true },
      bound: {
        yMax: 165,
        yMin: 0,
        xMax: 0,
        xMin: 0
      }
    });
    this.emitHandler();
  },
  deactivated: function deactivated() {
    this.cleanupScroller();
  },

  methods: {
    __add: function __add(v) {
      this.$parent.scene.add(v);
    },
    __remove: function __remove(v) {
      this.$parent.scene.remove(v);
    }
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WebGL_Mixins_FadeInOut__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Mixins_scroller__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WebGL_Bundle__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Status',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_WebGL_Mixins_FadeInOut__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Mixins_scroller__["a" /* default */]],
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__components_WebGL_Bundle__["a" /* default */]),
  props: ['aspect'],
  data: function data() {
    return {
      mouseStack: {},
      execStack: {},
      tweening: false
    };
  },
  activated: function activated() {
    var _this = this;

    this.$emit('exec', function () {
      for (var execItem in _this.execStack) {
        var exec = _this.execStack[execItem];
        if (exec) {
          exec();
        }
      }
    });
    this.$emit('setMouse', function (args) {
      for (var name in _this.mouseStack) {
        var exec = _this.mouseStack[name];
        if (exec) {
          exec(args);
        }
      }
    });
    this.setupScroller({
      target: this.$refs['page-content'],
      enable: { x: false, y: true },
      bound: {
        yMax: 52.5,
        yMin: 0,
        xMax: 0,
        xMin: 0
      }
    });
    this.emitHandler();
  },
  deactivated: function deactivated() {
    this.cleanupScroller();
  },

  methods: {
    __add: function __add(v) {
      this.$parent.scene.add(v);
    },
    __remove: function __remove(v) {
      this.$parent.scene.remove(v);
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_three__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_WebGL_Mixins_FadeInOut__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_WebGL_Bundle__ = __webpack_require__(5);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GLMenu',
  props: ['aspect'],
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_WebGL_Mixins_FadeInOut__["a" /* default */]],
  components: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_6__components_WebGL_Bundle__["a" /* default */]),
  data: function data() {
    return {
      THREE: __WEBPACK_IMPORTED_MODULE_4_three__,
      execStack: {},
      tween: {},
      tweening: false,
      showFSMenu: false
    };
  },

  watch: {
    showFSMenu: function showFSMenu() {
      this.$emit('showPage', !this.showFSMenu);
    }
  },
  activated: function activated() {
    var _this = this;

    try {
      this.$refs['nike-logo'].mesh.material.uniforms.opacity.value = 0;
      this.$refs['nav-red-line'].mesh.material.opacity = 0;
      this.$refs['nav-grey-box'].mesh.material.opacity = 0;
      this.$refs['menu-open'].mesh.material.uniforms.opacity.value = 0;
    } catch (e) {
      console.log(e);
    }

    this.animateAll();

    this.$emit('exec', function () {
      for (var execItem in _this.execStack) {
        var exec = _this.execStack[execItem];
        if (exec) {
          exec();
        }
      }
    });
  },
  deactivated: function deactivated() {
    this.$emit('exec', function () {});
  },
  mounted: function mounted() {},

  methods: {
    animateGreyNavLayer: function animateGreyNavLayer() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.$nextTick(function () {
          if (_this2.$refs['nav-grey-box']) {
            var mesh = _this2.$refs['nav-grey-box'].mesh;
            mesh.material.opacity = 0;
            var v = { v: 0 };
            new _this2.TWEEN.Tween(v).to({ v: 0.7 }, 500).easing(_this2.TWEEN.Easing.Quadratic.Out).onUpdate(function () {
              mesh.material.opacity = v.v;
            }).start();
          }
        });
      });
    },
    animateMenuBtn: function animateMenuBtn() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.$nextTick(function () {
          if (_this3.$refs['menu-open']) {
            var mesh = _this3.$refs['menu-open'].mesh;
            mesh.material.uniforms.opacity.value = 0;
            new _this3.TWEEN.Tween(mesh.material.uniforms.opacity).to({ value: 1.0 }, 500).easing(_this3.TWEEN.Easing.Quadratic.Out).start();

            mesh.position.x += 3;
            new _this3.TWEEN.Tween(mesh.position).to(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, mesh.position, {
              x: mesh.position.x - 3
            }), 500).easing(_this3.TWEEN.Easing.Quadratic.Out).onComplete(function () {
              resolve();
            }).start();
          }
        });
      });
    },
    animateNavLine: function animateNavLine() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.$nextTick(function () {
          if (_this4.$refs['nike-logo']) {
            var mesh = _this4.$refs['nike-logo'].mesh;
            mesh.material.uniforms.opacity.value = 0;
            new _this4.TWEEN.Tween(mesh.material.uniforms.opacity).to({ value: 1.0 }, 500).easing(_this4.TWEEN.Easing.Quadratic.Out).start();

            mesh.position.y -= 3;
            new _this4.TWEEN.Tween(mesh.position).to(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, mesh.position, {
              y: mesh.position.y + 3
            }), 500).easing(_this4.TWEEN.Easing.Quadratic.Out).onComplete(function () {
              resolve();
            }).start();
          }
        });
      });
    },
    animateRedLine: function animateRedLine() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.$nextTick(function () {
          if (_this5.$refs['nav-red-line']) {
            var mesh = _this5.$refs['nav-red-line'].mesh;
            mesh.material.opacity = 0;
            var v = { v: 0 };
            new _this5.TWEEN.Tween(v).to({ v: 1 }, 500).easing(_this5.TWEEN.Easing.Quadratic.Out).onUpdate(function () {
              mesh.material.opacity = v.v;
            }).start();
          }
        });
      });
    },
    animateAll: function animateAll() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this6.sleep(500);

              case 2:
                if (!(_this6.$route.path.indexOf('/home') !== -1)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return _this6.sleep(2000);

              case 5:
                _context.next = 7;
                return [_this6.animateNavLine(), _this6.animateRedLine(), _this6.animateMenuBtn(), _this6.animateGreyNavLayer()];

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },

    // getSceneWidth () {
    //   var dist = 50
    //   var vFOV = THREE.Math.degToRad(75) // convert vertical fov to radians
    //   var height = 2 * Math.tan(vFOV / 2) * dist // visible height
    //   var width = height * this.aspect // visible width
    //   return width
    // },
    // getSceneHeight () {
    //   var dist = 50
    //   var vFOV = THREE.Math.degToRad(75) // convert vertical fov to radians
    //   var height = 2 * Math.tan(vFOV / 2) * dist // visible height
    //   // var width = height * this.aspect // visible width
    //   return height
    // },
    menuIn: function menuIn(el, done) {
      var updater = function updater(mesh) {
        if (mesh) {
          mesh.visible = true;
          done();
          // this.tweening = true
          // this.fadeInTween((v) => {
          //   if (mesh.material) {
          //     mesh.material.opacity = v
          //   }
          //   if (mesh.material.uniforms) {
          //     mesh.material.uniforms.opacity.value = v
          //   }
          // }, () => {
          //   done()
          //   this.tweening = false
          // })
        }
      };
      if (this.$refs['nav-bar']) {
        this.$refs['nav-bar'].object3d.children.forEach(updater);
      }
    },
    menuOut: function menuOut(el, done) {
      var updater = function updater(mesh) {
        if (mesh) {
          mesh.visible = false;
          done();

          // this.tweening = true
          // this.fadeOutTween((v) => {
          //   if (mesh.material) {
          //     mesh.material.opacity = v
          //   }
          //   if (mesh.material.uniforms) {
          //     mesh.material.uniforms.opacity.value = v
          //   }
          // }, () => {
          //   done()
          //   this.tweening = false
          // })
        }
      };
      if (this.$refs['nav-bar']) {
        this.$refs['nav-bar'].object3d.children.forEach(updater);
      }
    },
    fsMenuIn: function fsMenuIn(el, done) {
      var updater = function updater(mesh) {
        if (mesh) {
          mesh.visible = true;
          // this.tweening = true
          // mesh.visible = true
          // this.fadeInTween((v) => {
          //   if (mesh.material) {
          //     mesh.material.opacity = v
          //   }
          //   if (mesh.material.uniforms) {
          //     mesh.material.uniforms.opacity.value = v
          //   }
          // }, () => {
          //   done()
          //   this.tweening = false
          // })
        }
        done();
      };
      if (this.$refs['fs-menu']) {
        this.$refs['fs-menu'].object3d.children.forEach(updater);
      }
    },
    fsMenuOut: function fsMenuOut(el, done) {
      var updater = function updater(mesh) {
        if (mesh) {
          mesh.visible = false;
          // this.tweening = true
          // this.fadeOutTween((v) => {
          //   if (mesh.material) {
          //     mesh.material.opacity = v
          //   }
          //   if (mesh.material.uniforms) {
          //     mesh.material.uniforms.opacity.value = v
          //   }
          // }, () => {
          //   done()
          //   mesh.visible = false
          //   this.tweening = false
          // })
        }
        done();
      };
      if (this.$refs['fs-menu']) {
        this.$refs['fs-menu'].object3d.children.forEach(updater);
      }
    },
    __add: function __add(v) {
      this.$parent.scene.add(v);
    },
    __remove: function __remove(v) {
      this.$parent.scene.remove(v);
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_WebGL_GLView__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_WebGL_GLView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_WebGL_GLView__);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    GLView: __WEBPACK_IMPORTED_MODULE_0__components_WebGL_GLView___default.a
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WebGL_Bundle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Mixins_FadeInOut__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_WebGL_Mixins_FadeInOut__["a" /* default */]],
  props: ['aspect'],
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_WebGL_Bundle__["a" /* default */]),
  data: function data() {
    return {
      camera: false,
      scene: false,
      setMouse: function setMouse() {},
      hover: function hover() {
        return [];
      },
      lastResult: []
    };
  },
  activated: function activated() {
    var _this = this;

    this.$emit('scene', this.scene);
    this.$emit('camera', this.camera);
    this.$emit('setMouse', this.setMouse);

    this.$nextTick(function () {
      _this.$emit('exec', _this.exec);
      _this.fadeInTween(function (v) {
        _this.$refs['ball-p'].points.material.opacity = v;
        _this.$refs['box-p'].points.material.opacity = v;
      }, function () {});
    });
  },
  deactivated: function deactivated() {
    this.$emit('setMouse', function () {});
    this.$emit('exec', function () {});
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    var _this2 = this;

    this.fadeOutTween(function (v) {
      _this2.$refs['ball-p'].points.material.opacity = v;
      _this2.$refs['box-p'].points.material.opacity = v;
    }, function () {
      next();
    });
  },

  methods: {
    handleHit: function handleHit(_ref) {
      var mouse = _ref.mouse,
          found = _ref.found;

      if (found[0]) {
        this.stopAllTween();
        this.fadeOutTween(function (v) {
          found[0].object.rotation.z = Math.PI * -2.0 * v;
        }, function () {});
      }
    },
    highlight: function highlight(result, color) {
      for (var i = 0; i < result.length; i++) {
        result[i].object.material.color.set(color);
      }
    },
    exec: function exec() {
      this.execTween();

      // this.highlight(this.lastResult, 0x00ffff)
      // var result = this.hover()
      // this.highlight(result, 0xff00ff)
      // this.lastResult = result

      this.camera.position.z = 20;
      this.$refs['ball-p'].points.position.z = 8.5 + 8.5 * Math.sin(window.performance.now() / 1000);
      this.$refs['box-p'].points.position.z = 8.5 + 8.5 * Math.sin(window.performance.now() / 1000);
      this.$refs['box-p'].points.rotation.z = 8.5 + 8.5 * Math.sin(window.performance.now() / 1000);
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_three__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Prototypes_Visual_ParticleSea_ParticleSea_vue__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Prototypes_Visual_ParticleSea_ParticleSea_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Prototypes_Visual_ParticleSea_ParticleSea_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Prototypes_Visual_Woody_Woody_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Prototypes_Visual_Woody_Woody_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Prototypes_Visual_Woody_Woody_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_WebGL_Mixins_FadeInOut__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_WebGL_Mixins_FadeInOut__["a" /* default */]],
  props: ['aspect', 'renderer'],
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__["a" /* default */], {
    Woody: __WEBPACK_IMPORTED_MODULE_4__components_Prototypes_Visual_Woody_Woody_vue___default.a,
    ParticleSea: __WEBPACK_IMPORTED_MODULE_3__components_Prototypes_Visual_ParticleSea_ParticleSea_vue___default.a
  }),
  data: function data() {
    return {
      woodyBall: false,
      particleSea: false,
      camera: false,
      scene: false,
      setRMouse: function setRMouse() {},
      hover: function hover() {
        return [];
      },
      lastResult: []
    };
  },

  watch: {},
  activated: function activated() {
    var _this = this;

    this.$emit('scene', this.scene);
    this.$emit('camera', this.camera);
    this.$emit('setMouse', function (data) {
      if (_this.setRMouse) {
        _this.setRMouse(data);
      }
      if (_this.particleSea) {
        _this.particleSea.setMouse(data);
      }
      if (_this.woodyBall) {
        _this.woodyBall.setMouse(data);
      }
    });

    this.scene.background = new __WEBPACK_IMPORTED_MODULE_1_three__["Color"](0x000000);

    this.$nextTick(function () {
      _this.$emit('exec', _this.exec);
      // this.fadeInTween((v) => {
      //   this.camera.position.z = 10
      //   this.$refs['mesh-1'].mesh.material.opacity = v
      //   this.$refs['mesh-1'].mesh.position.z = 5 * (1 - v)
      // }, () => {
      // })
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    next();

    // this.fadeOutTween((v) => {
    //   this.camera.position.z = 10
    //   this.$refs['mesh-1'].mesh.material.opacity = v
    //   this.$refs['mesh-1'].mesh.position.z = -5 * (1.0 - v)
    // }, () => {
    //   next()
    // })
  },
  deactivated: function deactivated() {
    this.$emit('setMouse', function () {});
    this.$emit('exec', function () {});
  },

  methods: {
    handleHit: function handleHit(_ref) {
      var _this2 = this;

      var mouse = _ref.mouse,
          found = _ref.found;

      if (found[0]) {
        this.stopAllTween();
        this.fadeOutTween(function (v) {
          found[0].object.material.opacity = v;
        }, function () {
          _this2.fadeInTween(function (v) {
            found[0].object.material.opacity = v;
          }, function () {});
        });
      }
    },
    highlight: function highlight(result, color) {
      if (result.length === 0) {
        return;
      }
      for (var i = 0; i < result.length; i++) {
        if (result[i].object.material.color) {
          result[i].object.material.color.set(color);
        }
      }
    },
    exec: function exec() {
      // this.$refs['mesh-1'].mesh.material.color.set(0xffffff)

      // this.highlight(this.lastResult, 0x00ffff)
      // var result = this.hover()
      // this.highlight(result, 0xff00ff)
      // this.lastResult = result

      if (this.particleSea) {
        this.particleSea.render();
      }
      if (this.woodyBall) {
        this.woodyBall.render();
      }

      this.execTween();
    }
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WebGL_Bundle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Mixins_FadeInOut__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_WebGL_Mixins_FadeInOut__["a" /* default */]],
  props: ['aspect'],
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_WebGL_Bundle__["a" /* default */]),
  data: function data() {
    return {
      camera: false,
      scene: false,
      setMouse: function setMouse() {},
      hover: function hover() {
        return [];
      },
      lastResult: []
    };
  },
  activated: function activated() {
    var _this = this;

    this.$emit('scene', this.scene);
    this.$emit('camera', this.camera);
    this.$emit('setMouse', this.setMouse);

    this.$nextTick(function () {
      _this.$emit('exec', _this.exec);
      _this.fadeInTween(function (v) {
        _this.camera.position.z = 10;
        _this.$refs['mesh-1'].mesh.material.opacity = v;
        _this.$refs['mesh-1'].mesh.position.z = 5 * (1 - v);
      }, function () {});
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    var _this2 = this;

    this.fadeOutTween(function (v) {
      _this2.camera.position.z = 10;
      _this2.$refs['mesh-1'].mesh.material.opacity = v;
      _this2.$refs['mesh-1'].mesh.position.z = -5 * (1.0 - v);
    }, function () {
      next();
    });
  },
  deactivated: function deactivated() {
    this.$emit('setMouse', function () {});
    this.$emit('exec', function () {});
  },

  methods: {
    handleHit: function handleHit(_ref) {
      var _this3 = this;

      var mouse = _ref.mouse,
          found = _ref.found;

      if (found[0]) {
        this.stopAllTween();
        this.fadeOutTween(function (v) {
          found[0].object.material.opacity = v;
        }, function () {
          _this3.fadeInTween(function (v) {
            found[0].object.material.opacity = v;
          }, function () {});
        });
      }
    },
    highlight: function highlight(result, color) {
      if (result.length === 0) {
        return;
      }
      for (var i = 0; i < result.length; i++) {
        result[i].object.material.color.set(color);
      }
    },
    exec: function exec() {
      // this.$refs['mesh-1'].mesh.material.color.set(0xffffff)

      // this.highlight(this.lastResult, 0x00ffff)
      // var result = this.hover()
      // this.highlight(result, 0xff00ff)
      // this.lastResult = result

      this.execTween();
    }
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_three__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Prototypes_Visual_Woody_Woody_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Prototypes_Visual_Woody_Woody_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Prototypes_Visual_Woody_Woody_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_WebGL_Mixins_FadeInOut__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_WebGL_Mixins_FadeInOut__["a" /* default */]],
  props: ['aspect', 'renderer'],
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__components_WebGL_Bundle__["a" /* default */], {
    Woody: __WEBPACK_IMPORTED_MODULE_3__components_Prototypes_Visual_Woody_Woody_vue___default.a
  }),
  data: function data() {
    return {
      woodyBall: false,
      camera: false,
      scene: false,
      setRMouse: function setRMouse() {},
      hover: function hover() {
        return [];
      },
      lastResult: []
    };
  },

  watch: {
    woodyBall: function woodyBall() {
      var _this = this;

      this.$emit('setMouse', function (data) {
        if (_this.setRMouse) {
          _this.setRMouse(data);
        }
        if (_this.woodyBall) {
          _this.woodyBall.setMouse(data);
        }
      });
    },
    setRMouse: function setRMouse() {
      var _this2 = this;

      this.$emit('setMouse', function (data) {
        if (_this2.setRMouse) {
          _this2.setRMouse(data);
        }
        if (_this2.woodyBall) {
          _this2.woodyBall.setMouse(data);
        }
      });
    }
  },
  activated: function activated() {
    var _this3 = this;

    this.$emit('scene', this.scene);
    this.$emit('camera', this.camera);
    this.$emit('setMouse', function (data) {
      if (_this3.setRMouse) {
        _this3.setRMouse(data);
      }
      if (_this3.woodyBall) {
        _this3.woodyBall.setMouse(data);
      }
    });

    this.scene.background = new __WEBPACK_IMPORTED_MODULE_1_three__["Color"](0x000000);

    this.$nextTick(function () {
      _this3.$emit('exec', _this3.exec);
      // this.fadeInTween((v) => {
      //   this.camera.position.z = 10
      //   this.$refs['mesh-1'].mesh.material.opacity = v
      //   this.$refs['mesh-1'].mesh.position.z = 5 * (1 - v)
      // }, () => {
      // })
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    next();

    // this.fadeOutTween((v) => {
    //   this.camera.position.z = 10
    //   this.$refs['mesh-1'].mesh.material.opacity = v
    //   this.$refs['mesh-1'].mesh.position.z = -5 * (1.0 - v)
    // }, () => {
    //   next()
    // })
  },
  deactivated: function deactivated() {
    this.$emit('setMouse', function () {});
    this.$emit('exec', function () {});
  },

  methods: {
    handleHit: function handleHit(_ref) {
      var _this4 = this;

      var mouse = _ref.mouse,
          found = _ref.found;

      if (found[0]) {
        var magnitude = Math.abs(1.0 - Math.random());
        // console.log(found[0].object.material)
        this.stopAllTween();
        this.punchInTween(function (v) {
          found[0].object.material.uniforms.mousePos.value.x = v;
        }, function () {
          _this4.punchOutTween(function (v) {
            found[0].object.material.uniforms.mousePos.value.x = v;
          }, function () {}, magnitude);
        }, magnitude);
      }
    },
    highlight: function highlight(result, color) {
      if (result.length === 0) {
        return;
      }
      for (var i = 0; i < result.length; i++) {
        if (result[i].object.material.color) {
          result[i].object.material.color.set(color);
        }
      }
    },
    exec: function exec() {
      // this.$refs['mesh-1'].mesh.material.color.set(0xffffff)

      // this.highlight(this.lastResult, 0x00ffff)
      // var result = this.hover()
      // this.highlight(result, 0xff00ff)
      // this.lastResult = result

      if (this.woodyBall) {
        this.woodyBall.render();
      }

      this.execTween();
    }
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Prototypes_Visual_ParticleSea_ParticleSea_js__ = __webpack_require__(232);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['renderer'],
  data: function data() {
    return {
      api: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_Prototypes_Visual_ParticleSea_ParticleSea_js__["a" /* default */])(),
      info: false
      // mesh: null
    };
  },
  mounted: function mounted() {
    this.info = this.api.setup({ renderer: this.renderer });

    this.$emit('api', this.api);
    this.$parent.__add(this.info.points);
    // this.mesh = new THREE.Mesh()
    // this.$emit('mesh', this.mesh)
  },
  beforeDestroy: function beforeDestroy() {
    if (this.info) {
      this.$parent.__remove(this.info.points);
    }
  },

  methods: {
    exec: function exec() {
      this.api.render();
    }
  },
  watch: {}
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Prototypes_Visual_Woody_Woody_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js__);
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['renderer', 'rect', 'position', 'scale', 'gclick'],
  data: function data() {
    return {
      api: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_Prototypes_Visual_Woody_Woody_js__["a" /* default */])(),
      info: false,
      punchTween: false
      // mesh: null
    };
  },
  mounted: function mounted() {
    this.info = this.api.setup({ renderer: this.renderer, rect: this.rect, position: this.position || { x: 0, y: 0, z: 0 } });
    // this.api.updateRect({ rect: this.rect })

    if (this.gclick) {
      this.api.points.userData.gclick = this.gclick;
    }

    this.$emit('api', this.api);
    // this.info.points.$skipRayCaster = true
    this.$parent.__add(this.info.points);
    // this.mesh = new THREE.Mesh()
    // this.$emit('mesh', this.mesh)
  },
  beforeDestroy: function beforeDestroy() {
    if (this.info) {
      this.$parent.__remove(this.info.points);
    }
  },

  methods: {
    exec: function exec() {
      this.api.render();
    },
    punch: function punch(_ref) {
      var _this = this;

      var magnitude = _ref.magnitude;

      this.punchInTween(function (v) {
        _this.api.material.uniforms.mousePos.value.x = v;
      }, function () {
        _this.punchOutTween(function (v) {
          _this.api.material.uniforms.mousePos.value.x = v;
        }, function () {}, magnitude);
      }, magnitude);
    },
    punchOutTween: function punchOutTween(update, done, magnitude) {
      var factor = 1000;
      var varying = {
        opacity: 1 * factor

        //
      };if (this.punchTween) {
        this.punchTween.stop();
      }

      this.punchTween = new __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default.a.Tween(varying).to({ opacity: 0 * factor }, 800 * (magnitude || 1)).easing(__WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default.a.Easing.Quadratic.Out).onUpdate(function () {
        update(varying.opacity / factor);
      }).onStop(function () {
        done();
      }).onComplete(function () {
        done();
      });
      this.punchTween.start();
    },
    punchInTween: function punchInTween(update, done, magnitude) {
      var factor = 1000;
      var varying = {
        opacity: 0 * factor
      };

      if (this.punchTween) {
        this.punchTween.stop();
      }

      this.punchTween = new __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default.a.Tween(varying).to({ opacity: 1 * factor }, 800 * (magnitude || 1)).easing(__WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default.a.Easing.Quadratic.Out).onUpdate(function () {
        update(varying.opacity / factor);
      }).onStop(function () {
        done();
      }).onComplete(function () {
        done();
      });

      this.punchTween.start();
    }
  },
  watch: {
    position: function position() {
      this.api.setPosition({ position: this.position });
    },
    rect: function rect() {
      this.api.updateRect({ rect: this.rect });
    }
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(3);
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'position': {},
    'gclick': {},
    'gTS': {},
    'scale': {},
    'visible': {
      default: true
    }
  },
  data: function data() {
    return {
      mesh: null,
      default: {
        geometry: false,
        material: false
      }
    };
  },
  created: function created() {
    this.mesh = new __WEBPACK_IMPORTED_MODULE_0_three__["Mesh"]();
    if (this.gclick) {
      this.mesh.userData.gclick = this.gclick;
    }
    if (this.gTS) {
      this.mesh.userData.gTS = this.gTS;
    }
    if (this.position) {
      this.mesh.position.set(this.position.x || 0, this.position.y || 0, this.position.z || 0);
    }
    if (this.scale) {
      this.mesh.scale.set(this.scale.x || 1, this.scale.y || 1, this.scale.z || 1);
    }
    this.default.geometry = this.mesh.geometry;
    this.default.material = this.mesh.material;
    this.$emit('mesh', this.mesh);
  },

  watch: {
    position: function position() {
      if (this.position) {
        this.mesh.position.set(this.position.x || 0, this.position.y || 0, this.position.z || 0);
      }
    },
    scale: function scale() {
      if (this.scale) {
        this.mesh.scale.set(this.scale.x || 1, this.scale.y || 1, this.scale.z || 1);
      }
    },
    visible: function visible() {
      this.mesh.visible = this.visible;
    }
  },
  // calling parent methods.
  mounted: function mounted() {
    this.mesh.visible = this.visible;
    this.$parent.__add(this.mesh);
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.__remove(this.mesh);
  },

  methods: {
    // let child add
    __add: function __add(v, type) {
      if (type === 'geometry') {
        this.mesh.geometry = v;
      }
      if (type === 'material') {
        this.mesh.material = v;
      }
    },
    __remove: function __remove(v, type) {
      if (type === 'geometry') {
        this.mesh.geometry = this.default.geometry;
      }
      if (type === 'material') {
        this.mesh.material = this.default.material;
      }
    }
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(3);
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['position', 'scale'],
  data: function data() {
    return {
      object3d: null
    };
  },
  created: function created() {
    this.object3d = new __WEBPACK_IMPORTED_MODULE_0_three__["Object3D"]();
    if (this.position) {
      this.object3d.position.set(this.position.x || 0, this.position.y || 0, this.position.z || 0);
    }
    if (this.scale) {
      this.object3d.scale.set(this.scale.x || 0, this.scale.y || 0, this.scale.z || 0);
    }
    this.$emit('object', this.object3d);
  },

  watch: {
    position: function position() {
      if (this.position) {
        this.object3d.position.set(this.position.x || 0, this.position.y || 0, this.position.z || 0);
      }
    },
    scale: function scale() {
      if (this.scale) {
        this.object3d.scale.set(this.scale.x || 0, this.scale.y || 0, this.scale.z || 0);
      }
    }
  },
  // calling parent methods.
  mounted: function mounted() {
    this.$parent.__add(this.object3d);
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.__remove(this.object3d);
  },

  methods: {
    // let child add
    __add: function __add(v) {
      this.object3d.add(v);
    },
    __remove: function __remove(v) {
      this.object3d.remove(v);
    }
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["default"] = ({
  abstract: true,
  render: function render() {
    return null;
  },

  props: ['fov', 'aspect', 'near', 'far', 'position'],
  data: function data() {
    return {
      camera: null
    };
  },
  created: function created() {
    this.camera = new __WEBPACK_IMPORTED_MODULE_0_three__["PerspectiveCamera"](this.fov, this.aspect, this.near, this.far);

    if (this.position) {
      this.camera.position.x = this.position.x;
      this.camera.position.y = this.position.y;
      this.camera.position.z = this.position.z;
    }
    this.$emit('camera', this.camera);
  },

  watch: {
    position: function position() {
      if (this.position) {
        this.camera.position.x = this.position.x;
        this.camera.position.y = this.position.y;
        this.camera.position.z = this.position.z;
      }
    },
    aspect: function aspect() {
      if (this.camera) {
        this.camera.aspect = this.aspect;
        this.camera.updateProjectionMatrix();
      }
    }
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(3);
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      points: null,
      default: {
        geometry: false,
        material: false
      }
    };
  },
  created: function created() {
    this.points = new __WEBPACK_IMPORTED_MODULE_0_three__["Points"]();
    this.default.geometry = this.points.geometry;
    this.default.material = this.points.material;
    this.$emit('points', this.points);
  },

  watch: {},
  mounted: function mounted() {
    this.$parent.__add(this.points);
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.__remove(this.points);
  },

  methods: {
    __add: function __add(v, type) {
      if (type === 'geometry') {
        this.points.geometry = v;
      }
      if (type === 'material') {
        this.points.material = v;
      }
    },
    __remove: function __remove(v, type) {
      if (type === 'geometry') {
        this.points.geometry = this.default.geometry;
      }
      if (type === 'material') {
        this.points.material = this.default.material;
      }
    }
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_WebGL_Shared_system__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_three__ = __webpack_require__(3);
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  // abstract: true,
  // render () {
  //   return null
  // },
  props: ['camera', 'scene'],
  data: function data() {
    return {
      glSystem: __WEBPACK_IMPORTED_MODULE_0__components_WebGL_Shared_system__["a" /* glSystem */],
      run: false,
      raycaster: null,
      mouse: new __WEBPACK_IMPORTED_MODULE_1_three__["Vector2"](0, 0)
    };
  },
  created: function created() {
    this.raycaster = new __WEBPACK_IMPORTED_MODULE_1_three__["Raycaster"]();
    this.mouse.isIn = false;
    this.$emit('raycaster', this);
    this.$emit('raycast', this.raycast);
    this.$emit('setMouse', this.setMouse);
    // this.$emit('finder', this.finder)
    this.$emit('hover', this.hover);
  },
  activated: function activated() {
    this.$emit('raycast', this.raycast);
    this.$emit('setMouse', this.setMouse);
    // this.$emit('finder', this.finder)
    this.$emit('hover', this.hover);
  },

  methods: {
    finder: function finder() {
      if (this.camera && this.scene && this.mouse) {
        this.raycaster.setFromCamera(this.mouse, this.camera);
        var restore = [];
        this.scene.traverse(function (ele) {
          if (ele.$skipRayCaster === true) {
            restore.push({
              parent: ele.parent,
              ele: ele
            });
            ele.parent.remove(ele);
          }
        });
        var intersects = this.raycaster.intersectObjects(this.scene.children, true);
        restore.forEach(function (item) {
          item.parent.add(item.ele);
        });
        // console.log(intersects)
        return intersects;
      } else {
        return [];
      }
    },
    hover: function hover() {
      if (this.mouse.isIn) {
        return this.finder();
      } else {
        return [];
      }
    },
    setMouse: function setMouse(_ref) {
      var pageX = _ref.pageX,
          pageY = _ref.pageY,
          rect = _ref.rect,
          isIn = _ref.isIn,
          type = _ref.type;

      if (rect && typeof pageX !== 'undefined' && typeof pageY !== 'undefined') {
        this.mouse.x = (pageX - rect.left) / rect.width * 2 - 1;
        this.mouse.y = -((pageY - rect.top) / rect.height) * 2 + 1;
        // console.log(this.mouse)
      }
      if (typeof isIn !== 'undefined') {
        this.mouse.isIn = isIn;
      }
      if (type === 'click') {
        this.run = true;
        // this.$emit('glClick', { mouse: this.mouse, found: this.finder() })
      }
    },
    raycast: function raycast() {
      if (this.run) {
        this.run = false;
        // this.glSystem.busy = true
        var result = this.finder();
        // if (typeof result[0] === 'undefined') {
        //   this.glSystem.busy = false
        // }
        this.$emit('glClick', { mouse: this.mouse, found: result });
        this.$emit('glTouchStart', { mouse: this.mouse, found: result });
      }
    },
    raycastNow: function raycastNow() {
      var result = this.finder();
      return { mouse: this.mouse, found: result };
    }
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(3);
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      scene: null
    };
  },
  created: function created() {
    this.scene = new __WEBPACK_IMPORTED_MODULE_0_three__["Scene"]();
    // this.scene
    this.$emit('scene', this.scene);
  },

  methods: {
    __add: function __add(item) {
      this.scene.add(item);
    },
    __remove: function __remove(item) {
      this.scene.remove(item);
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(3);
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    rect: {
      type: window.DOMRect
    },
    alpha: {
      type: Boolean,
      default: true
    },
    antialias: {
      type: Boolean,
      default: false
    },
    camera: {},
    scene: {}
  },
  data: function data() {
    return {
      renderer: null
    };
  },
  created: function created() {
    this.renderer = new __WEBPACK_IMPORTED_MODULE_0_three__["WebGLRenderer"]({
      alpha: this.alpha,
      antialias: this.antialias
    });
    var ratio = window.devicePixelRatio || 1;
    // this.renderer.setPixelRatio(ratio >= 2 ? 2 : 1)
    this.renderer.setPixelRatio(ratio);
    this.renderer.setSize(this.rect.width, this.rect.height);
    this.$emit('renderer', this.renderer);
  },
  mounted: function mounted() {
    this.renderer.domElement.style.marginBottom = '-6px';
    this.$refs.mounter.appendChild(this.renderer.domElement);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.mounter.removeChild(this.renderer.domElement);
  },

  watch: {
    rect: function rect() {
      if (this.renderer && this.rect) {
        this.renderer.setSize(this.rect.width, this.rect.height);
      }
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Mixins_llvms__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_Mesh__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_Mesh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Components_Mesh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Geometry_PlaneGeometry__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Geometry_PlaneGeometry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Geometry_PlaneGeometry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Material_MeshCanvasMaterial__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Material_MeshCanvasMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Material_MeshCanvasMaterial__);
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CanvasMesh',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__Mixins_llvms__["llvmsMesh"]],
  props: {
    canvas: {},
    position: {},
    link: {},
    scale: {},
    gclick: {},
    translate: {},
    vms: {},
    visible: {
      default: true
    },
    // gOpacity: {},
    color: {}
  },
  // ['position', 'link', 'scale', 'gclick', 'translate', 'vms', 'gOpacity', 'color'],
  components: {
    Mesh: __WEBPACK_IMPORTED_MODULE_1__Components_Mesh___default.a,
    PlaneGeometry: __WEBPACK_IMPORTED_MODULE_2__Geometry_PlaneGeometry___default.a,
    MeshCanvasMaterial: __WEBPACK_IMPORTED_MODULE_3__Material_MeshCanvasMaterial___default.a
  },
  data: function data() {
    return {
      mesh: false,
      ready: false,
      sWidth: 20,
      sHeight: 20
    };
  },
  mounted: function mounted() {
    // if (this.link) {
    //   var img = new Image()
    //   img.onload = () => {
    //     this.sWidth = img.width / 10
    //     this.sHeight = img.height / 10
    //     // if (this.scale) {
    //     //   this.sWidth = img.width / 10 * (this.scale.x)
    //     //   this.sHeight = img.height / 10 * (this.scale.y)
    //     // } else {
    //     // }
    //     this.ready = true
    //   }
    //   img.src = this.link
    // } else {
    //   this.ready = true
    // }
    if (this.canvas) {
      this.ready = true;
    }
  },

  computed: {},
  watch: {},
  methods: {
    __add: function __add(data) {
      this.$parent.__add(data);
    },
    __remove: function __remove(data) {
      this.$parent.__remove(data);
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Mixins_llvms__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_Mesh__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_Mesh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Components_Mesh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Geometry_PlaneGeometry__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Geometry_PlaneGeometry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Geometry_PlaneGeometry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Material_MeshGrungeMaterial__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Material_MeshGrungeMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Material_MeshGrungeMaterial__);
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ImageMesh',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__Mixins_llvms__["llvmsMesh"]],
  props: {
    position: {},
    link: {},
    scale: {},
    gclick: {},
    translate: {},
    vms: {},
    visible: {
      default: true
    },
    gOpacity: {},
    color: {}
  },
  // ['position', 'link', 'scale', 'gclick', 'translate', 'vms', 'gOpacity', 'color'],
  components: {
    Mesh: __WEBPACK_IMPORTED_MODULE_1__Components_Mesh___default.a,
    PlaneGeometry: __WEBPACK_IMPORTED_MODULE_2__Geometry_PlaneGeometry___default.a,
    MeshGrungeMaterial: __WEBPACK_IMPORTED_MODULE_3__Material_MeshGrungeMaterial___default.a
  },
  data: function data() {
    return {
      mesh: false,
      ready: false,
      sWidth: 20,
      sHeight: 20
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.link) {
      var img = new Image();
      img.onload = function () {
        _this.sWidth = img.width / 10;
        _this.sHeight = img.height / 10;
        // if (this.scale) {
        //   this.sWidth = img.width / 10 * (this.scale.x)
        //   this.sHeight = img.height / 10 * (this.scale.y)
        // } else {
        // }
        _this.ready = true;
      };
      img.src = this.link;
    } else {
      this.ready = true;
    }
  },

  computed: {},
  watch: {},
  methods: {
    __add: function __add(data) {
      this.$parent.__add(data);
    },
    __remove: function __remove(data) {
      this.$parent.__remove(data);
    }
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Mixins_llvms__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Mesh__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Mesh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Components_Mesh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Geometry_PlaneGeometry__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Geometry_PlaneGeometry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Geometry_PlaneGeometry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Material_MeshPictureMaterial__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Material_MeshPictureMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Material_MeshPictureMaterial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_WebGL_Shared_cache__ = __webpack_require__(47);
//
//
//
//
//
//
//


// import { textureCache } from '../Shared/cache'






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ImageMesh',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__Mixins_llvms__["llvmsMesh"]],
  props: {
    blendEquation: {},
    blendSrc: {},
    blendDst: {},

    depthTest: {},
    transparent: {},
    blending: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_0_three__["NormalBlending"];
      }
    },
    position: {},
    link: {},
    // alphaMap: {},
    scale: {},
    gclick: {},
    gTS: {},
    translate: {},
    vms: {},
    visible: {
      default: true
    }
  },
  components: {
    Mesh: __WEBPACK_IMPORTED_MODULE_2__Components_Mesh___default.a,
    PlaneGeometry: __WEBPACK_IMPORTED_MODULE_3__Geometry_PlaneGeometry___default.a,
    MeshPictureMaterial: __WEBPACK_IMPORTED_MODULE_4__Material_MeshPictureMaterial___default.a
  },
  data: function data() {
    return {
      THREE: __WEBPACK_IMPORTED_MODULE_0_three__,
      mesh: false,
      ready: false,
      sWidth: 1,
      sHeight: 1
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.mesh) {
      this.mesh.visible = false;
      this.mesh.userData.$component = this;
    }
    if (this.link) {
      // textureCache.setCache(this.link, () => {
      // })
      var img;
      var handle = function handle() {
        _this.sWidth = img.width / 10;
        _this.sHeight = img.height / 10;
        // if (this.scale) {
        //   this.sWidth = img.width / 10 * (this.scale.x)
        //   this.sHeight = img.height / 10 * (this.scale.y)
        // } else {
        // }
        _this.ready = true;
        _this.mesh.visible = _this.visible;
        _this.$nextTick(function () {
          _this.$emit('ready');
        });
      };

      var storedImage = __WEBPACK_IMPORTED_MODULE_5__components_WebGL_Shared_cache__["g" /* textureCache */].image[this.link];
      if (storedImage) {
        img = storedImage;
        handle();
      } else {
        img = new Image();
        img.onload = handle;
        img.src = this.link;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {},

  computed: {},
  watch: {},
  methods: {
    __add: function __add(data) {
      this.$parent.__add(data);
    },
    __remove: function __remove(data) {
      this.$parent.__remove(data);
    }
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Mixins_llvms__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_Mesh__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_Mesh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Components_Mesh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Geometry_PlaneGeometry__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Geometry_PlaneGeometry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Geometry_PlaneGeometry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Material_MeshRevealMaterial__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Material_MeshRevealMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Material_MeshRevealMaterial__);
//
//
//
//
//
//
//





// import { textureCache } from '@/components/WebGL/Shared/cache'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ImageMesh',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__Mixins_llvms__["llvmsMesh"]],
  props: {
    position: {},
    link: {},
    scale: {},
    gclick: {},
    translate: {},
    vms: {},
    visible: {
      default: true
    },
    gOpacity: {},
    color: {}
  },
  // ['position', 'link', 'scale', 'gclick', 'translate', 'vms', 'gOpacity', 'color'],
  components: {
    Mesh: __WEBPACK_IMPORTED_MODULE_1__Components_Mesh___default.a,
    PlaneGeometry: __WEBPACK_IMPORTED_MODULE_2__Geometry_PlaneGeometry___default.a,
    MeshRevealMaterial: __WEBPACK_IMPORTED_MODULE_3__Material_MeshRevealMaterial___default.a
  },
  data: function data() {
    return {
      mesh: false,
      ready: false,
      sWidth: 20,
      sHeight: 20
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.link) {
      var img = new Image();
      img.onload = function () {
        _this.sWidth = img.width / 10;
        _this.sHeight = img.height / 10;
        // if (this.scale) {
        //   this.sWidth = img.width / 10 * (this.scale.x)
        //   this.sHeight = img.height / 10 * (this.scale.y)
        // } else {
        // }
        _this.ready = true;
      };
      img.src = this.link;
    } else {
      this.ready = true;
    }
  },

  computed: {},
  watch: {},
  methods: {
    __add: function __add(data) {
      this.$parent.__add(data);
    },
    __remove: function __remove(data) {
      this.$parent.__remove(data);
    }
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Mixins_llvms__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_Mesh__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_Mesh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Components_Mesh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Geometry_PlaneGeometry__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Geometry_PlaneGeometry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Geometry_PlaneGeometry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Material_MeshShakeMaterial__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Material_MeshShakeMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Material_MeshShakeMaterial__);
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ImageMesh',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__Mixins_llvms__["llvmsMesh"]],
  props: {
    position: {},
    link: {},
    scale: {},
    gclick: {},
    translate: {},
    vms: {},
    visible: {
      default: true
    },
    gOpacity: {},
    color: {}
  },
  // ['position', 'link', 'scale', 'gclick', 'translate', 'vms', 'gOpacity', 'color'],
  components: {
    Mesh: __WEBPACK_IMPORTED_MODULE_1__Components_Mesh___default.a,
    PlaneGeometry: __WEBPACK_IMPORTED_MODULE_2__Geometry_PlaneGeometry___default.a,
    MeshShakeMaterial: __WEBPACK_IMPORTED_MODULE_3__Material_MeshShakeMaterial___default.a
  },
  data: function data() {
    return {
      mesh: false,
      ready: false,
      sWidth: 20,
      sHeight: 20
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.link) {
      var img = new Image();
      img.onload = function () {
        _this.sWidth = img.width / 10;
        _this.sHeight = img.height / 10;
        // if (this.scale) {
        //   this.sWidth = img.width / 10 * (this.scale.x)
        //   this.sHeight = img.height / 10 * (this.scale.y)
        // } else {
        // }
        _this.ready = true;
      };
      img.src = this.link;
    } else {
      this.ready = true;
    }
  },

  computed: {},
  watch: {},
  methods: {
    __add: function __add(data) {
      this.$parent.__add(data);
    },
    __remove: function __remove(data) {
      this.$parent.__remove(data);
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

// import * as llvms from '../Mixins/llvms'
/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['aspect', 'fov', 'z'],
  created: function created() {
    this.hydrate();
  },
  mounted: function mounted() {
    this.hydrate();
  },

  watch: {
    aspect: function aspect() {
      this.hydrate();
    },
    fov: function fov() {
      this.hydrate();
    },
    z: function z() {
      this.hydrate();
    }
  },
  methods: {
    hydrate: function hydrate() {
      // llvms.info.aspect = this.aspect
      // llvms.info.fov = this.fov
      // llvms.info.z = this.z
      // console.log(llvms.info)
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WebGL_Bundle__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var rAFID = 0;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_WebGL_Bundle__["a" /* default */]),
  data: function data() {
    return {
      view: { left: 0, top: 0 },
      evlt: false,
      exec: function exec() {},
      uninstaller: function uninstaller() {},
      setMouse: function setMouse() {},
      rect: false,
      aspect: 1.0,
      renderer: false,
      camera: false,
      scene: false,
      keepAlive: false
    };
  },
  mounted: function mounted() {
    this.install();
    this.loop();
  },
  beforeDestroy: function beforeDestroy() {
    this.uninstaller();
    this.stop();
  },

  computed: {
    ready: function ready() {
      return this.camera && this.scene && this.rect;
    },
    keepRenderer: function keepRenderer() {
      return this.camera && this.scene && this.rect || this.keepAlive;
    }
  },
  watch: {
    ready: function ready() {
      if (this.ready) {
        this.keepAlive = true;
      }
    }
  },
  methods: {
    stop: function stop() {
      window.cancelAnimationFrame(rAFID);
    },
    loop: function loop() {
      var _this = this;

      var loopsiloop = function loopsiloop() {
        rAFID = window.requestAnimationFrame(loopsiloop);

        // var rect = this.$refs.container.getBoundingClientRect()
        // if (rect.left !== this.view.left || rect.top !== this.view.top) {
        //   this.evlt.resizer()
        //   this.view.left = rect.left
        //   this.view.top = rect.top
        // }

        if (_this.renderer) {
          _this.exec();
          _this.renderer.render(_this.scene, _this.camera);
        }
      };
      rAFID = window.requestAnimationFrame(loopsiloop);
    },
    install: function install() {
      var _this2 = this;

      var ev = this.evlt = {
        resizer: function resizer() {
          if (!_this2.$refs.container) {
            return;
          }
          _this2.rect = _this2.$refs.container.getBoundingClientRect();
          _this2.aspect = _this2.rect.width / _this2.rect.height;
        },
        tsData: false,
        tmData: false,
        emitClick: false,
        onTS: function onTS(evt) {
          evt.preventDefault();
          ev.tsData = { type: 'click', isIn: true, touches: evt.touches, pageX: evt.touches[0].pageX, pageY: evt.touches[0].pageY, rect: _this2.rect };
          ev.emitClick = true;
          setTimeout(function () {
            ev.emitClick = false;
          }, 345);
          _this2.setMouse({ type: 'ts', isIn: true, touches: evt.touches, pageX: evt.touches[0].pageX, pageY: evt.touches[0].pageY, rect: _this2.rect });
        },
        onTM: function onTM(evt) {
          evt.preventDefault();
          var dx = ev.tsData.pageX - evt.touches[0].pageX;
          var dy = ev.tsData.pageY - evt.touches[0].pageY;
          if (Math.sqrt(dx * dx + dy * dy) > 80) {
            ev.emitClick = false;
          }
          _this2.setMouse({ type: 'tm', touches: evt.touches, pageX: evt.touches[0].pageX, pageY: evt.touches[0].pageY, rect: _this2.rect });
        },
        onTE: function onTE(evt) {
          if (ev.emitClick) {
            ev.emitClick = false;
            _this2.setMouse(ev.tsData);
          }
          _this2.setMouse({ type: 'te', isIn: false });
        },
        onMDN: function onMDN(evt) {
          _this2.setMouse({ type: 'mdn', pageX: evt.clientX, pageY: evt.clientY, rect: _this2.rect });
        },
        onMUP: function onMUP(evt) {
          _this2.setMouse({ type: 'mup', pageX: evt.clientX, pageY: evt.clientY, rect: _this2.rect });
        },
        onMV: function onMV(evt) {
          evt.preventDefault();
          _this2.setMouse({ type: 'mv', pageX: evt.pageX, pageY: evt.pageY, rect: _this2.rect });
        },
        onMO: function onMO(evt) {
          _this2.setMouse({ isIn: true });
        },
        onME: function onME(evt) {
          _this2.setMouse({ isIn: true });
        },
        onML: function onML(evt) {
          _this2.setMouse({ isIn: false });
        },
        onCL: function onCL(evt) {
          _this2.setMouse({ type: 'click', pageX: evt.pageX, pageY: evt.pageY, rect: _this2.rect });
        },
        onWHL: function onWHL(evt) {
          _this2.setMouse({ type: 'wheel', deltaX: evt.deltaX, deltaY: evt.deltaY });
        }
      };
      ev.resizer();
      console.log('emitting refresher');
      this.$emit('refresh', function () {
        ev.resizer();
      });
      var container = this.$refs.container;
      container.addEventListener('mouseover', ev.onMO, false);
      container.addEventListener('mouseenter', ev.onME, false);
      container.addEventListener('mouseleave', ev.onML, false);

      container.addEventListener('mousemove', ev.onMV, false);
      container.addEventListener('mousedown', ev.onMDN, false);
      container.addEventListener('mouseup', ev.onMUP, false);

      container.addEventListener('click', ev.onCL, false);
      container.addEventListener('wheel', ev.onWHL, false);

      container.addEventListener('touchstart', ev.onTS, false);
      container.addEventListener('touchmove', ev.onTM, false);
      container.addEventListener('touchend', ev.onTE, false);
      container.style['-webkit-tap-highlight-color'] = 'rgba(0,0,0,0)';
      window.addEventListener('resize', ev.resizer, false);
      this.uninstaller = function () {
        container.removeEventListener('mouseover', ev.onMO);
        container.removeEventListener('mouseenter', ev.onME);
        container.removeEventListener('mouseleave', ev.onML);

        container.removeEventListener('mousemove', ev.onMV);
        container.removeEventListener('mousedown', ev.onMDN);
        container.removeEventListener('mouseup', ev.onMUP);

        container.removeEventListener('click', ev.onCL);
        container.removeEventListener('wheel', ev.onWHL);

        container.removeEventListener('touchstart', ev.onTS);
        container.removeEventListener('touchmove', ev.onTM);
        container.removeEventListener('touchend', ev.onTE);
        window.removeEventListener('resize', ev.resizer);
      };
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["default"] = ({
  abstract: true,
  render: function render() {
    return null;
  },
  data: function data() {
    return {
      geometry: null
    };
  },
  created: function created() {
    this.geometry = new __WEBPACK_IMPORTED_MODULE_0_three__["BoxGeometry"](2, 2, 2, 10, 10, 10);
    // this.geometry
    this.$emit('geometry', this.geometry);
  },

  watch: {},
  mounted: function mounted() {
    this.$parent.__add(this.geometry, 'geometry');
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.__remove(this.geometry, 'geometry');
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['width', 'height', 'wseg', 'hseg', 'translate', 'scale'],
  abstract: true,
  render: function render() {
    return null;
  },
  data: function data() {
    return {
      geometry: null
    };
  },
  created: function created() {
    this.makeGeo();
    // this.geometry
    this.$emit('geometry', this.geometry);
  },

  watch: {
    width: function width() {
      this.makeGeo();
    },
    height: function height() {
      this.makeGeo();
    },
    translate: function translate() {
      this.makeGeo();
      this.$parent.__add(this.geometry, 'geometry');
      this.$parent.__remove(this.geometry, 'geometry');
      this.$parent.__add(this.geometry, 'geometry');
    }
  },
  methods: {
    makeGeo: function makeGeo() {
      this.geometry = new __WEBPACK_IMPORTED_MODULE_0_three__["PlaneBufferGeometry"](this.width || 1.0, this.height || 1.0, this.wseg || 20.0, this.hseg || 20.0);
      if (this.translate) {
        var x = this.translate.x;
        // if (typeof this.translate.x === 'function') {
        //   x = this.translate.x(this.width)
        // }
        var y = this.translate.y;
        // if (typeof this.translate.y === 'function') {
        //   y = this.translate.y(this.height)
        // }
        var z = this.translate.z;
        // if (typeof this.translate.z === 'function') {
        //   z = this.translate.z(1.0)
        // }
        this.geometry.applyMatrix(new __WEBPACK_IMPORTED_MODULE_0_three__["Matrix4"]().makeTranslation(x, y, z));
        // this.$forceUpdate()
      }
    }
  },
  mounted: function mounted() {
    this.$parent.__add(this.geometry, 'geometry');
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.__remove(this.geometry, 'geometry');
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["default"] = ({
  abstract: true,
  render: function render() {
    return null;
  },
  data: function data() {
    return {
      geometry: null
    };
  },
  created: function created() {
    this.geometry = new __WEBPACK_IMPORTED_MODULE_0_three__["SphereGeometry"](2, 32, 32);
    // this.geometry
    this.$emit('geometry', this.geometry);
  },

  watch: {},
  mounted: function mounted() {
    this.$parent.__add(this.geometry, 'geometry');
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.__remove(this.geometry, 'geometry');
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["default"] = ({
  abstract: true,
  render: function render() {
    return null;
  },

  props: {
    color: {
      type: Number,
      default: function _default() {
        return 0xffffff;
      }
    },
    intensity: {
      type: Number,
      default: function _default() {
        return 5;
      }
    },
    distance: {
      type: Number,
      default: function _default() {
        return 100;
      }
    }
  },
  data: function data() {
    return {
      light: null
    };
  },
  created: function created() {
    this.light = new __WEBPACK_IMPORTED_MODULE_0_three__["PointLight"](this.color, this.intensity, this.distance);
    this.light.position.set(5, 5, 10);
    // this.light
    this.$emit('light', this.light);
    this.$parent.__add(this.light);
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    this.$parent.__remove(this.light);
  },

  watch: {
    color: function color(v) {
      this.light.color.set(v);
    },
    intensity: function intensity(v) {
      this.light.intensity = v;
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["default"] = ({
  abstract: true,
  render: function render() {
    return null;
  },

  props: {
    image: {},
    color: {
      type: Number
    },
    opacity: {
      type: Number,
      default: 1.0
    },
    blending: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_0_three__["AdditiveBlending"];
        // return null
      }
    }
  },
  data: function data() {
    return {
      material: null
    };
  },
  created: function created() {
    this.material = new __WEBPACK_IMPORTED_MODULE_0_three__["MeshBasicMaterial"]({
      map: this.image ? new __WEBPACK_IMPORTED_MODULE_0_three__["TextureLoader"]().load(this.image) : null,
      color: this.color || 0xee0302,
      opacity: this.opacity,
      blending: this.blending,
      transparent: true
    });
    // this.material
    this.$emit('material', this.material);
  },

  watch: {},
  mounted: function mounted() {
    this.$parent.__add(this.material, 'material');
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.__remove(this.material, 'material');
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["default"] = ({
  abstract: true,
  render: function render() {
    return null;
  },

  props: {
    depthTest: {
      type: Boolean,
      default: false
    },
    color: {
      type: Number,
      default: 0xbababa
    },
    canvas: {},
    // gOpacity: {
    //   type: Number,
    //   default: 1.0
    // },
    blending: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_0_three__["AdditiveBlending"];
        // return null
      }
    }
  },
  data: function data() {
    return {
      texture: null,
      material: null
    };
  },
  created: function created() {
    var texture = this.texture = new __WEBPACK_IMPORTED_MODULE_0_three__["CanvasTexture"](this.canvas, __WEBPACK_IMPORTED_MODULE_0_three__["UVMapping"], __WEBPACK_IMPORTED_MODULE_0_three__["ClampToEdgeWrapping"], __WEBPACK_IMPORTED_MODULE_0_three__["ClampToEdgeWrapping"], __WEBPACK_IMPORTED_MODULE_0_three__["LinearFilter"], __WEBPACK_IMPORTED_MODULE_0_three__["LinearFilter"]);
    this.material = new __WEBPACK_IMPORTED_MODULE_0_three__["ShaderMaterial"]({
      transparent: true,
      // blending: THREE.AdditiveBlending,
      blending: __WEBPACK_IMPORTED_MODULE_0_three__["AdditiveBlending"],
      depthTest: false,
      uniforms: {
        canvas: { value: texture },
        useImage: { value: typeof texture !== 'undefined' },
        time: { value: 0.0 },
        color: { value: new __WEBPACK_IMPORTED_MODULE_0_three__["Color"](this.color) },
        opacity: { value: 1.0
          // gOpacity: { value: this.gOpacity }
        } },
      vertexShader: '\n        varying vec2 vUv;\n        void main ( void ) {\n          vUv = uv;\n          vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n          vec4 outputPos = projectionMatrix * mvPosition;\n          gl_Position = outputPos;\n        }\n      ',
      fragmentShader: '\n        #include <common>\n\n        uniform bool useImage;\n        uniform sampler2D canvas;\n\n        varying vec2 vUv;\n        // uniform float gOpacity;\n        uniform float opacity;\n        uniform float time;\n        uniform vec3 color;\n\n        void main () {\n          if (useImage) {\n            vec4 canvasColor = texture2D(canvas, vUv);\n            gl_FragColor = vec4(vec3(canvasColor), canvasColor.a * opacity);\n          } else {\n            gl_FragColor = vec4(color, opacity);\n          }\n        }\n      '
    });
    // this.material
    this.$emit('material', this.material);
    this.$emit('texture', this.texture);
    this.$emit('exec', this.exec);
  },

  watch: {
    // gOpacity () {
    //   this.material.uniforms.gOpacity.value = this.gOpacity
    // },
    color: function color() {
      this.material.uniforms.color.value.set(this.color);
    }
  },
  methods: {
    exec: function exec() {
      if (this.material) {
        if (this.material.uniforms.texture.value) {
          this.material.uniforms.texture.value.needsUpdate = true;
        }
        this.material.uniforms.time.value = window.performance.now() * 0.001;
        this.material.uniforms.time.value = this.material.uniforms.time.value % 10;
      }
    }
  },
  mounted: function mounted() {
    this.$parent.__add(this.material, 'material');
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.__remove(this.material, 'material');
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["default"] = ({
  abstract: true,
  render: function render() {
    return null;
  },

  props: {
    image: {},
    depthTest: {
      type: Boolean,
      default: true
    },
    color: {
      type: Number,
      default: 0xbababa
    },
    gOpacity: {
      type: Number,
      default: 1.0
    },
    blending: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_0_three__["AdditiveBlending"];
        // return null
      }
    }
  },
  data: function data() {
    return {
      material: null
    };
  },
  created: function created() {
    this.material = new __WEBPACK_IMPORTED_MODULE_0_three__["ShaderMaterial"]({
      transparent: true,
      // blending: THREE.AdditiveBlending,
      blending: __WEBPACK_IMPORTED_MODULE_0_three__["NormalBlending"],
      depthTest: this.depthTest,
      uniforms: {
        image: { value: new __WEBPACK_IMPORTED_MODULE_0_three__["TextureLoader"]().load(this.image) },
        useImage: { value: typeof this.image !== 'undefined' },
        time: { value: 0.0 },
        color: { value: new __WEBPACK_IMPORTED_MODULE_0_three__["Color"](this.color) },
        opacity: { value: 1.0 },
        gOpacity: { value: this.gOpacity }
      },
      vertexShader: '\n        varying vec2 vUv;\n        void main ( void ) {\n          vUv = uv;\n          vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n          vec4 outputPos = projectionMatrix * mvPosition;\n          gl_Position = outputPos;\n        }\n      ',
      fragmentShader: '\n        #include <common>\n\n        uniform bool useImage;\n        uniform sampler2D image;\n\n\n        varying vec2 vUv;\n        uniform float gOpacity;\n        uniform float opacity;\n        uniform float time;\n        uniform vec3 color;\n\n        void main () {\n          if (useImage) {\n            vec4 imageColor = texture2D(image, vUv);\n            float noise = rand(vec2(vUv) + time);\n            float noise2 = rand(vec2(vUv + vec2(0.3, 0.2) + noise) + time);\n            float noise3 = rand(vec2(vUv + vec2(0.5, -0.6) + noise2) + time);\n            float noise4 = noise * noise2 * noise3;\n            gl_FragColor = vec4(vec3(vec3(imageColor) - noise4 * 0.5), imageColor.a * opacity);\n          } else {\n            float noise = rand(vec2(vUv) + time);\n            float noise2 = rand(vec2(vUv + vec2(0.3, 0.2) + noise) + time);\n            float noise3 = rand(vec2(vUv + vec2(0.5, -0.6) + noise2) + time);\n            float noise4 = noise * noise2 * noise3;\n            vec3 finalColor = vec3(noise4 * color);\n            if (finalColor.r <= 0.1 * gOpacity) {\n              discard;\n            } else {\n              gl_FragColor = vec4(finalColor, gOpacity * opacity);\n            }\n\n          }\n\n\n        }\n      '
    });
    // this.material
    this.$emit('material', this.material);
    this.$emit('exec', this.exec);
  },

  watch: {
    gOpacity: function gOpacity() {
      this.material.uniforms.gOpacity.value = this.gOpacity;
    },
    color: function color() {
      this.material.uniforms.color.value.set(this.color);
    }
  },
  methods: {
    exec: function exec() {
      if (this.material) {
        this.material.uniforms.time.value = window.performance.now() * 0.001;
        this.material.uniforms.time.value = this.material.uniforms.time.value % 1;
      }
    }
  },
  mounted: function mounted() {
    this.$parent.__add(this.material, 'material');
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.__remove(this.material, 'material');
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["default"] = ({
  abstract: true,
  render: function render() {
    return null;
  },

  props: {
    image: {},
    depthTest: {
      type: Boolean,
      default: true
    },
    color: {
      type: Number,
      default: 0xbababa
    },
    gOpacity: {
      type: Number,
      default: 1.0
    },
    blending: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_0_three__["AdditiveBlending"];
        // return null
      }
    }
  },
  data: function data() {
    return {
      material: null
    };
  },
  created: function created() {
    this.material = new __WEBPACK_IMPORTED_MODULE_0_three__["ShaderMaterial"]({
      transparent: true,
      // blending: THREE.AdditiveBlending,
      blending: __WEBPACK_IMPORTED_MODULE_0_three__["NormalBlending"],
      depthTest: false,
      side: __WEBPACK_IMPORTED_MODULE_0_three__["DoubleSide"],
      uniforms: {
        image: { value: new __WEBPACK_IMPORTED_MODULE_0_three__["TextureLoader"]().load(this.image) },
        useImage: { value: typeof this.image !== 'undefined' },
        time: { value: 0.0 },
        color: { value: new __WEBPACK_IMPORTED_MODULE_0_three__["Color"](this.color) },
        opacity: { value: 1.0 },
        gOpacity: { value: this.gOpacity }
      },
      vertexShader: '\n        varying vec2 vUv;\n        void main ( void ) {\n          vUv = uv;\n          vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n          vec4 outputPos = projectionMatrix * mvPosition;\n          gl_Position = outputPos;\n        }\n      ',
      fragmentShader: '\n        #include <common>\n\n        uniform bool useImage;\n        uniform sampler2D image;\n\n\n        varying vec2 vUv;\n        uniform float gOpacity;\n        uniform float opacity;\n        uniform float time;\n        uniform vec3 color;\n\n        void main () {\n\n          gl_FragColor = vec4(0.0, 0.0, 0.0, 0.5);\n        }\n      '
    });
    // this.material
    this.$emit('material', this.material);
    this.$emit('exec', this.exec);
  },

  watch: {
    gOpacity: function gOpacity() {
      this.material.uniforms.gOpacity.value = this.gOpacity;
    },
    color: function color() {
      this.material.uniforms.color.value.set(this.color);
    }
  },
  methods: {
    exec: function exec() {
      if (this.material) {
        this.material.uniforms.time.value = window.performance.now() * 0.001;
        this.material.uniforms.time.value = this.material.uniforms.time.value % 1;
      }
    }
  },
  mounted: function mounted() {
    this.$parent.__add(this.material, 'material');
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.__remove(this.material, 'material');
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["default"] = ({
  abstract: true,
  render: function render() {
    return null;
  },

  props: {
    opacity: {
      type: Number
    },
    blending: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_0_three__["AdditiveBlending"];
      }
    }
  },
  data: function data() {
    return {
      material: null
    };
  },
  created: function created() {
    this.material = new __WEBPACK_IMPORTED_MODULE_0_three__["MeshPhongMaterial"]({
      color: 0xee0302,
      specular: 0xffffff,
      shininess: 1.0,
      opacity: this.opacity,
      blending: this.blending,
      transparent: true
    });
    // this.material
    this.$emit('material', this.material);
  },

  watch: {},
  mounted: function mounted() {
    this.$parent.__add(this.material, 'material');
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.__remove(this.material, 'material');
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_cache__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_three__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  abstract: true,
  render: function render() {
    return null;
  },

  props: {
    blendEquation: {},
    blendSrc: {},
    blendDst: {},

    image: {},
    transparent: {
      default: true
    },
    depthTest: {
      type: Boolean,
      default: true
    },
    color: {
      type: Number
    },
    opacity: {
      type: Number,
      default: 1.0
    },
    blending: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1_three__["NormalBlending"];
        // return null
      }
    }
  },
  data: function data() {
    return {
      material: null
    };
  },
  created: function created() {
    // var vm = this
    this.material = new __WEBPACK_IMPORTED_MODULE_1_three__["ShaderMaterial"]({
      transparent: this.transparent,
      // blending: THREE.AdditiveBlending,
      blending: this.blending,

      // blendEquation: this.blendEquation, // default
      // blendSrc: this.blendSrc, // default
      // blendDst: this.blendDst, // default

      depthTest: this.depthTest,
      defines: {
        USE_ALPHAMAP: { value: true },
        ALPHATEST: { value: 0.5 }
      },
      uniforms: {
        // alphaMap: { value: (function () {
        //   var ans = textureCache.getTexture(vm.alphaMap)
        //   ans.needsUpdate = true
        //   return ans
        // }()) },
        image: { value: __WEBPACK_IMPORTED_MODULE_0__Shared_cache__["g" /* textureCache */].getTexture(this.image) },
        opacity: { value: this.opacity }
      },
      vertexShader: '\n        varying vec2 vUv;\n        void main ( void ) {\n          vUv = uv;\n          vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n          vec4 outputPos = projectionMatrix * mvPosition;\n          gl_Position = outputPos;\n        }\n      ',
      fragmentShader: '\n        uniform sampler2D image;\n        varying vec2 vUv;\n        uniform float opacity;\n        void main () {\n          vec4 finalColor = texture2D(image, vUv);\n          finalColor.a *= opacity;\n          if (finalColor.a < 0.001) {\n            discard;\n          } else {\n            gl_FragColor = finalColor;\n          }\n        }\n      '
    });
    // this.material
    this.$emit('material', this.material);
  },

  watch: {},
  mounted: function mounted() {
    this.$parent.__add(this.material, 'material');
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.__remove(this.material, 'material');
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_three__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Shake',
  abstract: true,
  render: function render() {
    return null;
  },

  props: {
    image: {},
    shake: {
      type: Number,
      default: 1
    },
    depthTest: {
      type: Boolean,
      default: false
    },
    blending: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1_three__["AdditiveBlending"];
        // return null
      }
    }
  },
  data: function data() {
    return {
      material: null
    };
  },
  created: function created() {
    this.material = new __WEBPACK_IMPORTED_MODULE_1_three__["ShaderMaterial"]({
      transparent: true,
      // blending: THREE.AdditiveBlending,
      blending: __WEBPACK_IMPORTED_MODULE_1_three__["NormalBlending"],
      depthTest: this.depthTest,
      uniforms: {
        image: { value: new __WEBPACK_IMPORTED_MODULE_1_three__["TextureLoader"]().load(this.image) },
        time: { value: 0.0 },
        color: { value: new __WEBPACK_IMPORTED_MODULE_1_three__["Color"](this.color) },
        opacity: { value: 0.0 },
        progress: { value: 0.0 },
        initPos: { value: new __WEBPACK_IMPORTED_MODULE_1_three__["Vector3"](0.0, 0.0, 0.0) },
        resolution: { value: new __WEBPACK_IMPORTED_MODULE_1_three__["Vector2"]() }
      },
      vertexShader: '\n        #include <common>\n\n        varying vec2 vUv;\n        uniform float time;\n        uniform float progress;\n        uniform vec3 initPos;\n\n        void main ( void ) {\n          vUv = uv;\n\n          vec3 newPos = position - (1.0 - progress) * initPos;\n\n          vec4 mvPosition = modelViewMatrix * vec4( newPos, 1.0 );\n          vec4 outputPos = projectionMatrix * mvPosition;\n          gl_Position = outputPos;\n        }\n      ',
      fragmentShader: '\n        #include <common>\n\n        uniform sampler2D image;\n\n        varying vec2 vUv;\n\n        uniform float opacity;\n        uniform float time;\n        uniform vec3 color;\n        uniform float progress;\n        uniform vec2 resolution;\n\n        void main () {\n          vec4 _c = vec4(0.0);\n\n          // vec4 _g = vec4(gl_FragCoord.y / resolution.y) * (1.0 - progress);\n\n          _c += texture2D(image, vUv);\n\n          _c.a *= opacity;\n\n          gl_FragColor = _c;\n\n        }\n      '
    });

    // setTimeout(() => {
    //   this.reveal()
    // }, 1000)

    // this.material
    this.$emit('material', this.material);
    this.$emit('exec', this.exec);
    this.$emit('reveal', this.reveal);
  },


  watch: {
    color: function color() {
      this.material.uniforms.color.value.set(this.color);
    }
  },
  methods: {
    reveal: function reveal(_ref) {
      var _this = this;

      var initPos = _ref.initPos,
          time = _ref.time;

      this.material.uniforms.initPos.value.set(initPos.x, initPos.y, initPos.z);

      var v = {
        prg: 0,
        opacity: 0
      };

      new __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Tween(v).to({ prg: 1 }, time || 1000.0).easing(__WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Easing.Quadratic.Out).onUpdate(function () {
        // this.material.uniforms.shake.value = v.s
        _this.material.uniforms.progress.value = v.prg;
      }).start();

      new __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Tween(v).to({ opacity: 1 }, time || 1000.0).easing(__WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Easing.Quadratic.Out).onUpdate(function () {
        // this.material.uniforms.shake.value = v.s
        _this.material.uniforms.opacity.value = v.opacity;
      }).start();

      //
    },
    exec: function exec() {
      if (this.material) {
        this.material.uniforms.time.value = window.performance.now() * 0.001;
        this.material.uniforms.time.value = this.material.uniforms.time.value % 1;
      }
    }
  },
  mounted: function mounted() {
    this.$parent.__add(this.material, 'material');
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.__remove(this.material, 'material');
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_three__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Shake',
  abstract: true,
  render: function render() {
    return null;
  },

  props: {
    image: {},
    shake: {
      type: Number,
      default: 1
    },
    depthTest: {
      type: Boolean,
      default: false
    },
    blending: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1_three__["AdditiveBlending"];
        // return null
      }
    }
  },
  data: function data() {
    return {
      material: null
    };
  },
  created: function created() {
    this.material = new __WEBPACK_IMPORTED_MODULE_1_three__["ShaderMaterial"]({
      transparent: true,
      // blending: THREE.AdditiveBlending,
      blending: __WEBPACK_IMPORTED_MODULE_1_three__["NormalBlending"],
      depthTest: this.depthTest,
      uniforms: {
        image: { value: new __WEBPACK_IMPORTED_MODULE_1_three__["TextureLoader"]().load(this.image) },
        time: { value: 0.0 },
        color: { value: new __WEBPACK_IMPORTED_MODULE_1_three__["Color"](this.color) },
        opacity: { value: 0.0 },
        progress: { value: 0.0 },
        shake: { value: 0.0 },
        initPos: { value: new __WEBPACK_IMPORTED_MODULE_1_three__["Vector3"](0.0, 0.0, 0.0) }
      },
      vertexShader: '\n        #include <common>\n\n        varying vec2 vUv;\n        varying vec2 vK[6];\n        uniform float time;\n        uniform float shake;\n        uniform vec3 initPos;\n        uniform float progress;\n\n        void main ( void ) {\n          vUv = uv;\n\n          vec2 vTC = uv;\n          float cv = shake * time * 100.0;\n\n          vK[ 0] = vTC + vec2( cv * -0.024, cv * -0.02);\n          vK[ 1] = vTC + vec2( cv * -0.016, cv * -0.01);\n          vK[ 2] = vTC + vec2( cv * -0.008, cv * -0.00);\n\n          vK[ 3] = vTC + vec2( cv *  0.004, cv *  0.00);\n          vK[ 4] = vTC + vec2( cv *  0.012, cv *  0.01);\n          vK[ 5] = vTC + vec2( cv *  0.020, cv *  0.02);\n\n          vec3 newPos = vec3(vec3(position) - initPos * (1.0 - progress));\n\n          newPos += (shake * 0.16667 * 2.0) * ( rand((vK[0] - uv)) + rand(vec2(0.12345)) );\n          newPos += (shake * 0.16667 * 2.0) * ( rand((vK[1] - uv)) + rand(vec2(0.32355)) );\n          newPos += (shake * 0.16667 * 2.0) * ( rand((vK[2] - uv)) + rand(vec2(0.88779)) );\n          newPos += (shake * 0.16667 * 2.0) * ( rand((vK[3] - uv)) + rand(vec2(0.55667)) );\n          newPos += (shake * 0.16667 * 2.0) * ( rand((vK[4] - uv)) + rand(vec2(0.22334)) );\n          newPos += (shake * 0.16667 * 2.0) * ( rand((vK[5] - uv)) + rand(vec2(0.62235)) );\n\n          vec4 mvPosition = modelViewMatrix * vec4( newPos, 1.0 );\n          vec4 outputPos = projectionMatrix * mvPosition;\n          gl_Position = outputPos;\n        }\n      ',
      fragmentShader: '\n        #include <common>\n\n        uniform sampler2D image;\n\n        varying vec2 vUv;\n        varying vec2 vK[6];\n\n        uniform float opacity;\n        uniform float time;\n        uniform vec3 color;\n\n        void main () {\n          vec4 _c = vec4(0.0);\n\n          _c += texture2D(image, vK[ 0]) * 0.00442991210551;\n          _c += texture2D(image, vK[ 1]) * 0.00895781211794;\n          _c += texture2D(image, vK[ 2]) * 0.02159638660533;\n          _c += texture2D(image, vK[ 3]) * 0.04436833387183;\n          _c += texture2D(image, vK[ 4]) * 0.07767442199335;\n          _c += texture2D(image, vK[ 5]) * 0.11587662110566;\n          _c += texture2D(image, vK[ 0]) * 0.14730805612155;\n\n          _c += texture2D(image, vUv) * 0.159576912161;\n\n          _c += texture2D(image, vK[ 0]) * 0.147308056121;\n          _c += texture2D(image, vK[ 1]) * 0.115876621105;\n          _c += texture2D(image, vK[ 2]) * 0.077674421993;\n          _c += texture2D(image, vK[ 3]) * 0.044368333871;\n          _c += texture2D(image, vK[ 4]) * 0.021596386605;\n          _c += texture2D(image, vK[ 5]) * 0.008957812117;\n          _c += texture2D(image, vK[ 0]) * 0.004429912105;\n\n          _c.a *= opacity;\n\n          gl_FragColor = _c;\n\n        }\n      '
    });

    // setTimeout(() => {
    //   this.shakeShake()
    // }, 1000)

    // this.material
    this.$emit('material', this.material);
    this.$emit('exec', this.exec);
    this.$emit('shake', this.shakeShake);
  },


  watch: {
    color: function color() {
      this.material.uniforms.color.value.set(this.color);
    }
  },
  methods: {
    shakeShake: function shakeShake(_ref) {
      var _this = this;

      var initPos = _ref.initPos,
          timeRatio = _ref.timeRatio;

      this.material.uniforms.initPos.value.set(initPos.x, initPos.y, initPos.z);
      timeRatio = timeRatio || 1.0;

      var v = {
        prg: 0,
        o: 0,
        s: 1.0
      };

      new __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Tween(v).to({ prg: 1 }, timeRatio * 380 * 0.5).easing(__WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Easing.Quadratic.Out).onUpdate(function () {
        // this.material.uniforms.shake.value = v.s
        _this.material.uniforms.progress.value = v.prg;
      }).start();

      new __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Tween(v).to({ o: 1 }, timeRatio * 380 * 0.25).easing(__WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Easing.Bounce.InOut).onUpdate(function () {
        // this.material.uniforms.shake.value = v.s
        _this.material.uniforms.opacity.value = v.o;
      }).start();

      new __WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Tween(v).to({ s: 0 }, timeRatio * 600 * 0.5).easing(__WEBPACK_IMPORTED_MODULE_0__tweenjs_tween_js___default.a.Easing.Bounce.Out).onUpdate(function () {
        _this.material.uniforms.shake.value = v.s;
        // this.material.uniforms.opacity.value = v.o
      }).start();
    },
    exec: function exec() {
      if (this.material) {
        this.material.uniforms.time.value = window.performance.now() * 0.001;
        this.material.uniforms.time.value = this.material.uniforms.time.value % 1;
      }
    }
  },
  mounted: function mounted() {
    this.$parent.__add(this.material, 'material');
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.__remove(this.material, 'material');
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["default"] = ({
  abstract: true,
  render: function render() {
    return null;
  },

  props: {
    color: {
      // type: Number,
      default: function _default() {
        return Math.random() * 0xffffff;
      }
    },
    size: {
      type: Number,
      default: function _default() {
        return window.devicePixelRatio || 1.0;
      }
    },
    sizeAttenuation: {
      type: Boolean,
      default: false
    },
    blending: {
      // type: Number,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_0_three__["AdditiveBlending"];
      }
    },
    opacity: {
      type: Number,
      default: function _default() {
        return 1.0;
      }
    },
    depthTest: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  },
  data: function data() {
    return {
      material: null
    };
  },
  created: function created() {
    this.material = new __WEBPACK_IMPORTED_MODULE_0_three__["PointsMaterial"]({
      color: this.color,
      size: this.size,
      sizeAttenuation: this.sizeAttenuation,
      opacity: this.opacity,
      blending: this.blending,
      depthTest: this.depthTest
    });
    // this.material
    this.$emit('material', this.material);
  },

  watch: {
    color: function color() {
      this.material.color.set(this.color);
    },
    size: function size() {
      this.material.size = this.size;
    },
    opacity: function opacity() {
      this.material.opacity = this.opacity;
    }
  },
  mounted: function mounted() {
    this.$parent.__add(this.material, 'material');
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.__remove(this.material, 'material');
  }
});

/***/ }),
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */
/***/ (function(module, exports) {

module.exports = "\n#include <common>\n\nvarying vec4 particleVel;\n\nvoid main() {\n\n  vec4 rainbow = particleVel;\n\n  vec4 outputColor = vec4(\n  \trainbow.x + 0.6,\n  \t(rainbow.y * rainbow.x) + 0.6,\n  \trainbow.y + 0.6,\n  \t0.2\n  );\n\n  gl_FragColor = outputColor;\n\n  // gl_FragColor = vec4( vec3(0.0,0.0,1.0) , 0.5);\n}\n"

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = "#include <common>\n\nuniform vec2 mousePos;\n\n//  Classic Perlin 3D Noise\n//  by Stefan Gustavson\n//\nvec4 permute(vec4 x){return mod(((x*34.0)+1.0)*x, 289.0);}\nvec2 fade(vec2 t) {return t*t*t*(t*(t*6.0-15.0)+10.0);}\n\nfloat cnoise(vec2 P){\n  vec4 Pi = floor(P.xyxy) + vec4(0.0, 0.0, 1.0, 1.0);\n  vec4 Pf = fract(P.xyxy) - vec4(0.0, 0.0, 1.0, 1.0);\n  Pi = mod(Pi, 289.0); // To avoid truncation effects in permutation\n  vec4 ix = Pi.xzxz;\n  vec4 iy = Pi.yyww;\n  vec4 fx = Pf.xzxz;\n  vec4 fy = Pf.yyww;\n  vec4 i = permute(permute(ix) + iy);\n  vec4 gx = 2.0 * fract(i * 0.0243902439) - 1.0; // 1/41 = 0.024...\n  vec4 gy = abs(gx) - 0.5;\n  vec4 tx = floor(gx + 0.5);\n  gx = gx - tx;\n  vec2 g00 = vec2(gx.x,gy.x);\n  vec2 g10 = vec2(gx.y,gy.y);\n  vec2 g01 = vec2(gx.z,gy.z);\n  vec2 g11 = vec2(gx.w,gy.w);\n  vec4 norm = 1.79284291400159 - 0.85373472095314 *\n      vec4(dot(g00, g00), dot(g01, g01), dot(g10, g10), dot(g11, g11));\n  g00 *= norm.x;\n  g01 *= norm.y;\n  g10 *= norm.z;\n  g11 *= norm.w;\n  float n00 = dot(g00, vec2(fx.x, fy.x));\n  float n10 = dot(g10, vec2(fx.y, fy.y));\n  float n01 = dot(g01, vec2(fx.z, fy.z));\n  float n11 = dot(g11, vec2(fx.w, fy.w));\n  vec2 fade_xy = fade(Pf.xy);\n  vec2 n_x = mix(vec2(n00, n01), vec2(n10, n11), fade_xy.x);\n  float n_xy = mix(n_x.x, n_x.y, fade_xy.y);\n  return 2.3 * n_xy;\n}\n\n#define M_PI 3.1415926535897932384626433832795\nfloat atan2(in float y, in float x) {\n\tbool xgty = (abs(x) > abs(y));\n\treturn mix(M_PI/2.0 - atan(x,y), atan(y,x), float(xgty));\n}\nvec3 fromBall(float r, float az, float el) {\n\treturn vec3(\n    r * cos(el) * cos(az),\n    r * cos(el) * sin(az),\n    r * sin(el)\n  );\n}\nvoid toBall(vec3 pos, out float az, out float el) {\n\taz = atan2(pos.y, pos.x);\n\tel = atan2(pos.z, sqrt(pos.x * pos.x + pos.y * pos.y));\n}\n// float az = 0.0;\n// float el = 0.0;\n// vec3 noiser = vec3(lastVel);\n// toBall(noiser, az, el);\n// lastVel.xyz = fromBall(1.0, az, el);\n\nvoid main()\t{\n  vec2 cellSize = 1.0 / resolution.xy;\n  vec2 uv = gl_FragCoord.xy * cellSize;\n\n  vec4 lastVel = texture2D( velocityInfo, uv );\n  vec4 lastPos = texture2D( positionInfo, uv );\n\n  float noisiness = 9.0;\n\n  float az = 0.0;\n  float el = 0.0;\n\n  vec3 noiser = vec3(lastPos) + cnoise(vec2(lastVel * noisiness)) * noisiness * 0.5;\n  toBall(noiser, az, el);\n  if (rand(lastVel.xy) > 0.33333) {\n    lastPos.xyz = fromBall(75.0, az, el);\n  } else {\n    lastPos.xyz += fromBall(-6.0, az, el);\n  }\n\n  lastPos.xyz += lastVel.xyz * noisiness;\n  gl_FragColor = lastPos;\n}\n"

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = "#include <common>\n\nuniform vec2 mousePos;\n\nfloat constrain(float val, float min, float max) {\n    if (val < min) {\n        return min;\n    } else if (val > max) {\n        return max;\n    } else {\n        return val;\n    }\n}\n\nvec3 getDiff (in vec3 lastPos, in vec3 mousePos) {\n  vec3 diff = lastPos.xyz / 33.3 - mousePos;\n  float distance = constrain(length(diff), 5.0, 100.0);\n  float strength = 0.35 / (distance * distance);\n\n  diff = normalize(diff);\n  // delta\n  diff = diff * strength * -2.0;\n  // diff = diff * strength * (-20.83) * (1.0 / delta) * 0.0183;\n\n  return diff;\n}\n\n\nvoid main()\t{\n  vec2 cellSize = 1.0 / resolution.xy;\n  vec2 uv = gl_FragCoord.xy * cellSize;\n\n  vec4 lastPos = texture2D( positionInfo, uv );\n  vec4 lastVel = texture2D( velocityInfo, uv );\n\n\n  vec3 diff = getDiff( lastPos.xyz, vec3(mousePos, 0.1) );\n\n  lastVel.xyz += diff;\n\n  gl_FragColor = lastVel;\n}\n"

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports = "#include <common>\n\nuniform sampler2D positionInfo;\nuniform sampler2D velocityInfo;\n\nvarying vec4 particleVel;\n\n\n// #define M_PI 3.1415926535897932384626433832795\n\n// float atan2(in float y, in float x) {\n// \tbool xgty = (abs(x) > abs(y));\n// \treturn mix(M_PI/2.0 - atan(x,y), atan(y,x), float(xgty));\n// }\n\n// vec3 fromBall(float r, float az, float el) {\n// \treturn vec3(\n//     r * cos(el) * cos(az),\n//     r * cos(el) * sin(az),\n//     r * sin(el)\n//   );\n// }\n\n// void toBall(vec3 pos, out float az, out float el) {\n// \taz = atan2(pos.y, pos.x);\n// \tel = atan2(pos.z, sqrt(pos.x * pos.x + pos.y * pos.y));\n// }\n\nvoid main() {\n  vec2 cellSize = vec2( 1.0 / WIDTH, 1.0 / WIDTH );\n  #include <uv_vertex>\n\n  // vec3 objectNormal = vec3(\n  //   ( texture2D( fireworkPosition, uv + vec2( - cellSize.x, 0 ) ).x - texture2D( fireworkPosition, uv + vec2( cellSize.x, 0 ) ).x ) * WIDTH / BOUNDS,\n  //   ( texture2D( fireworkPosition, uv + vec2( 0, - cellSize.y ) ).x - texture2D( fireworkPosition, uv + vec2( 0, cellSize.y ) ).x ) * WIDTH / BOUNDS,\n  //   1.0 );\n\n  vec3 objectNormal = vec3(1.0);\n\n  vec4 fireworkCoord = texture2D( positionInfo, uv );\n  particleVel = texture2D( velocityInfo, uv );\n\n  vec3 transformed = vec3( fireworkCoord.x, fireworkCoord.y, fireworkCoord.z );\n\n  gl_PointSize = 1.0;\n\n  // float az = 0.0;\n  // float el = 0.0;\n  // vec3 noiser = transformed;\n  // toBall(noiser, az, el);\n  // vec3 newPos = fromBall(70.0, az, el);\n\n  vec4 mvPosition = modelViewMatrix * vec4( transformed, 1.0 );\n  vec4 outputPos = projectionMatrix * mvPosition;\n\n  gl_Position = outputPos;\n\n}"

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports = "varying vec2 vUv;\n// varying float vfinalSize;\n// varying vec3 vNormal;\n// uniform sampler2D wood;\n\nuniform vec2 mousePos;\nuniform vec2 resolution;\nuniform float opacity;\n\n// uniform sampler2D ball;\n\nvoid main() {\n\n  // vec4 woodColor = texture2D( wood, vUv );\n  // gl_FragColor = vec4(vec3(woodColor) * 0.5, 0.223 * opacity);\n\n  // vec4 ballColor = texture2D( ball, gl_PointCoord );\n  // if (ballColor.r < 0.001) {\n  //   discard;\n  // } else {\n  //   ballColor = mix(vec4(1.0,1.0,1.0, 1.0), vec4(238.0 / 255.0, 57.0 / 255.0, 50.0 / 255.0, 1.0), mousePos.x);\n  //  gl_FragColor = ballColor;\n  // }\n\n  // vec4 ballColor = texture2D( ball, gl_PointCoord );\n\n  vec2 coord = gl_PointCoord.xy - vec2(0.5);\n  if (length(coord) > 0.5) {\n    discard;\n  } else {\n    vec4 ballColor = mix(vec4(0.58,0.58,0.58, opacity), vec4(255.0 / 255.0, 57.0 / 255.0, 50.0 / 255.0, opacity), mousePos.x);\n    gl_FragColor = ballColor;\n  }\n\n  // float finalSize = vfinalSize * 2.0;\n  // vec2 pos = mod(gl_PointCoord.xy, vec2(finalSize)) - vec2(finalSize / 2.0);\n  // float dist_squared = dot(pos, pos);\n  // gl_FragColor = (dist_squared < finalSize * finalSize)\n  //         ? vec4(.90, .90, .90, 0.03)\n  //         : vec4(.20, .20, .40, 0.03);\n  // gl_FragColor = vec4(vec3(1.0), 0.03);\n  // gl_PointCoord.xy\n}\n"

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = "// varying vec2 vUv;\n// varying float vfinalSize;\n// varying vec3 vNormal;\n\nuniform sampler2D wood;\nuniform float pointSize;\nuniform vec2 mousePos;\nuniform float time;\n\nattribute float vertIndex;\n\n#define M_PI 3.1415926535897932384626433832795\n\n#include <common>\n\n//  Classic Perlin 3D Noise\n//  by Stefan Gustavson\n//\nvec4 permute(vec4 x){return mod(((x*34.0)+1.0)*x, 289.0);}\nvec2 fade(vec2 t) {return t*t*t*(t*(t*6.0-15.0)+10.0);}\n\nfloat cnoise(vec2 P){\n  vec4 Pi = floor(P.xyxy) + vec4(0.0, 0.0, 1.0, 1.0);\n  vec4 Pf = fract(P.xyxy) - vec4(0.0, 0.0, 1.0, 1.0);\n  Pi = mod(Pi, 289.0); // To avoid truncation effects in permutation\n  vec4 ix = Pi.xzxz;\n  vec4 iy = Pi.yyww;\n  vec4 fx = Pf.xzxz;\n  vec4 fy = Pf.yyww;\n  vec4 i = permute(permute(ix) + iy);\n  vec4 gx = 2.0 * fract(i * 0.0243902439) - 1.0; // 1/41 = 0.024...\n  vec4 gy = abs(gx) - 0.5;\n  vec4 tx = floor(gx + 0.5);\n  gx = gx - tx;\n  vec2 g00 = vec2(gx.x,gy.x);\n  vec2 g10 = vec2(gx.y,gy.y);\n  vec2 g01 = vec2(gx.z,gy.z);\n  vec2 g11 = vec2(gx.w,gy.w);\n  vec4 norm = 1.79284291400159 - 0.85373472095314 *\n      vec4(dot(g00, g00), dot(g01, g01), dot(g10, g10), dot(g11, g11));\n  g00 *= norm.x;\n  g01 *= norm.y;\n  g10 *= norm.z;\n  g11 *= norm.w;\n  float n00 = dot(g00, vec2(fx.x, fy.x));\n  float n10 = dot(g10, vec2(fx.y, fy.y));\n  float n01 = dot(g01, vec2(fx.z, fy.z));\n  float n11 = dot(g11, vec2(fx.w, fy.w));\n  vec2 fade_xy = fade(Pf.xy);\n  vec2 n_x = mix(vec2(n00, n01), vec2(n10, n11), fade_xy.x);\n  float n_xy = mix(n_x.x, n_x.y, fade_xy.y);\n  return 2.3 * n_xy;\n}\n\nfloat atan2(in float y, in float x) {\n\tbool xgty = (abs(x) > abs(y));\n\treturn mix(M_PI/2.0 - atan(x,y), atan(y,x), float(xgty));\n}\n\nvec3 fromBall(float r, float az, float el) {\n\treturn vec3(\n    r * cos(el) * cos(az),\n    r * cos(el) * sin(az),\n    r * sin(el)\n  );\n}\n\nvoid toBall(vec3 pos, out float az, out float el) {\n\taz = atan2(pos.y, pos.x);\n\tel = atan2(pos.z, sqrt(pos.x * pos.x + pos.y * pos.y));\n}\n\nfloat evaluateBezierPosition(float v1, float v2, float v3, float v4, float t ) {\n    vec3 p;\n    float OneMinusT = 1.0 - t;\n    float b0 = OneMinusT*OneMinusT*OneMinusT;\n    float b1 = 3.0*t*OneMinusT*OneMinusT;\n    float b2 = 3.0*t*t*OneMinusT;\n    float b3 = t*t*t;\n    return b0*v1 + b1*v2 + b2*v3 + b3*v4;\n}\n\nvoid main() {\n  // vUv = uv;\n\n  vec2 dynamicUV = uv;\n  dynamicUV = dynamicUV * 0.5;\n  dynamicUV += abs(-sin(time) * cos(time));\n  dynamicUV = dynamicUV * 0.5 + cnoise(uv * 0.25) * 0.05;\n  // dynamicUV.x = dynamicUV.x * 0.75 + (sin(time * 3.0) * cos(time * 3.0) + 0.5) * 0.25;\n\n  // dynamicUV *= abs(mousePos.x);\n\n  vec4 woodColor = texture2D(wood, dynamicUV);\n\n  float az = 0.0;\n  float el = 0.0;\n\n  // vec3 noiser = position + woodColor.z * normal.z * 20.0;\n\n  vec3 noiser = woodColor.z * normal.z * 20.0\n    + (vec3(woodColor) * 2.0 - 1.0) * 30.0;\n\n  toBall(mix(position + noiser, position + noiser * 0.75, mousePos.x), az, el);\n\n  vec3 levitation = vec3(woodColor) * normal * 8.0;\n  // vNormal = levitation;\n\n  vec3 newPos = fromBall(70.0, az, el) + levitation;\n  // vec3 newPos = position + normal * vec3(woodColor) * 20.0;\n  // vec3 newPos = position;\n\n  vec4 finalDot = projectionMatrix * modelViewMatrix * vec4(newPos, 1.0);\n  float finalSize = woodColor.z * 5.0;\n\n  float slider = clamp(mousePos.x, 0.0, 1.0);\n\n  float sizeInc = slider * 120.0;\n  float bezR = 1.0 - evaluateBezierPosition(1.0, 0.0, 1.0, 0.0, (slider));\n  float bez = evaluateBezierPosition(0.0, 1.0, 0.0, 1.0, (slider));\n  finalSize += sizeInc * bezR;\n\n  // float bez = evaluateBezierPosition(0.0, 1.0, 0.0, 1.0, (slider + 0.15));\n  highp float rand1 = abs(rand(vec2(vertIndex * 0.000001)));\n  highp float reducer = abs(slider) * bez * 200.0;\n  if ((rand1 * rand1 * rand1 * rand1 * rand1 * rand1 * rand1 * rand1 * rand1 * rand1 * rand1 * rand1 * rand1 * 200.0) < reducer)   {\n    finalDot.w = 0.0;\n  }\n\n  // vfinalSize = finalSize;\n  gl_PointSize = abs(finalSize);\n  gl_Position = finalDot;\n}"

/***/ }),
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.086d130.svg";

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/title.4d6daac.svg";

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/title.a5801ff.png";

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/title1.f5e2f91.png";

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/title2.d2a80a2.png";

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/button-area.a0c61a7.png";

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/enter-now.7476bfc.png";

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/watch-comics.ea2208f.png";

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/camp.b2c2c4e.png";

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nike-boxing.c344265.png";

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/box-btn-comics.5d968e7.png";

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/box-btn-game.96e02db.png";

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/box-txt-1.1c8263d.png";

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/box-txt-2.05dcb96.png";

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/boxing.57556c0.png";

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/camp.b2c2c4e.png";

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nike.0c2b1c8.png";

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/s-1.f0329ce.jpg";

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/s-2.7ac83de.jpg";

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/s-3.a91511e.jpg";

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/s-4.e423458.jpg";

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/share.3ef9ffb.png";

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hero.4cb2025.png";

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/title.9fc2729.png";

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/arrow-btn.a41dffc.png";

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/redeemed.6a5b7c1.png";

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/staff-only.9db9d10.png";

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/daily-task.103c37b.png";

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/title.79cc748.png";

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hold-tight.0962445.png";

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/30sec.30b998f.png";

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fb-share.cdb8833.png";

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nike-store.3d97c04.png";

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/terms-text.518cee3.png";

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/terms-title.3eebb50.png";

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/title.ac9b438.png";

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/btn-rule.0989077.png";

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/j5.120970d.png";

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/j7.0cd3892.png";

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/j9.09afcf5.png";

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/my-records.46e13cd.png";

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rules-text.000006f.png";

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/menu-open.ea459c1.png";

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nike.f043686.png";

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/red-btn.dc6928d.png";

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/red-gradient.aed6848.svg";

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/broken-glass.11912e8.jpg";

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/circle-red@2x.49618e0.png";

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/boxing_bell_sound_effect.05613a3.mp3";

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/medium.011d0e9.otf";

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/regular.b6d03e9.otf";

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/condensed-medium.a7dd3f4.ttf";

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(372)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(600),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6d15663f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(343)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(576),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-146d15d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(390)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(614),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-db1679dc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(384)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(611),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-99d45fb2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(352)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(584),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d2b0799",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(362)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(591),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(361)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(590),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-507fb882",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(376)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(604),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-779fb999",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(347)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(579),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e6525b3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(345)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(577),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1645c9bd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(358)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(587),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(389)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(613),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d9c35b5a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(367)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(596),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-616f4514",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(383)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(610),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-950b3302",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(359)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(588),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4cde905c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(338)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(573),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0209b3b0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(349)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(581),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-251e2cb2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(380)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(607),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(365)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(594),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-568974ef",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(374)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(602),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-743c8dff",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(357)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(586),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40c031f7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(392)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(615),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dfc93718",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(373)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(601),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-710dde74",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(371)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(599),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6ac471f0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(350)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(582),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-298e191a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(386)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(612),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d6ba9b96",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(368)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(597),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-618c78b8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(360)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(589),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e1ce219",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(369)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(269),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-62718fb0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(351)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(583),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2a0ae7cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(348)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(580),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2422dcfd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(340)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(574),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0ae8b59a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(364)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(593),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-55f4f0c3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(375)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(603),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7625df13",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(337)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(572),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0100f85d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(379)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(606),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d51ee2a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(382)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(609),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8ea1e6f0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(377)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(605),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-791db8d5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(341)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(575),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(391)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(281),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-db2268c0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(339)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(283),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03000e6c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(354)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(284),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b2bff1f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(378)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(285),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7a432800",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(355)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(288),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c78df7c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(342)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(289),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-13190242",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(394)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(293),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f1627c3c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Mesh', {
    attrs: {
      "vms": _vm.vms,
      "position": _vm.finalPosition,
      "scale": _vm.finalScale,
      "gclick": _vm.gclick
    },
    on: {
      "mesh": function (v) {
        _vm.mesh = v
      }
    }
  }, [(_vm.ready) ? _c('PlaneGeometry', {
    attrs: {
      "width": _vm.finalSize.x,
      "height": _vm.finalSize.y,
      "translate": _vm.finalTranslate,
      "scale": _vm.scale
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('MeshGrungeMaterial', {
    attrs: {
      "gOpacity": _vm.finalGrunge.gOpacity,
      "color": _vm.finalGrunge.gColor,
      "image": _vm.link
    },
    on: {
      "exec": function (v) {
        _vm.$emit('exec', v)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": _vm.onPageEnter,
      "leave": _vm.onPageLeave
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "sub-page-content"
  }, [_c('ImageMesh', {
    attrs: {
      "desc": "blackarea",
      "gclick": function () {},
      "vms": "@play@result@hider",
      "blending": _vm.THREE.NormalBlending,
      "opacity": 1,
      "depthTest": true,
      "transparent": true,
      "link": __webpack_require__(188)
    }
  }), _vm._v(" "), _c('NumberCounter', {
    ref: "number-counter",
    attrs: {
      "word": _vm.$route.query.punch,
      "vms": "@play@result@number-counter"
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@play@result@coupon-box-text",
      "link": __webpack_require__(186)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {
        _vm.$router.push({
          path: '/nike/game/rules'
        })
      },
      "vms": "@play@result@coupon-box-btn-rule",
      "link": __webpack_require__(185)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {
        _vm.go('https://nike.com')
      },
      "vms": "@play@result@coupon-box-btn-nike",
      "link": __webpack_require__(184)
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@play@result@grunge@coupon-box",
      "gclick": function () {}
    },
    on: {
      "exec": function (v) {
        _vm.execStack.grungeCouponBox = v
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "gclick": function () {
        _vm.$router.push({
          path: '/nike/game/play'
        })
      },
      "vms": "@play@result@try-again",
      "link": __webpack_require__(190)
    },
    on: {
      "exec": function (v) {
        _vm.execStack.tryAgain = v
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "gclick": function () {
        _vm.$router.push({
          path: '/nike/game/status'
        })
      },
      "vms": "@play@result@check-coupon",
      "link": __webpack_require__(183)
    },
    on: {
      "exec": function (v) {
        _vm.execStack.checkCoupon = v
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@play@result@grunge@share-box"
    },
    on: {
      "exec": function (v) {
        _vm.execStack.shareBox = v
      }
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@play@result@share-txt",
      "link": __webpack_require__(182)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {
        _vm.$router.push({
          path: '/nike/game/rules'
        });
      },
      "vms": "@play@result@share-rule-txt",
      "link": __webpack_require__(181)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {
        _vm.alert('This is demo only.')
      },
      "vms": "@play@result@share-btn",
      "link": __webpack_require__(180)
    },
    on: {
      "final-position": function (props) {
        _vm.tryMaximiseScroller(props);
        this$1.scrollerState.bound.yMax -= 30;
      }
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {
        _vm.$router.push({
          path: '/nike/game/daily-task'
        })
      },
      "vms": "@play@result@daily-task-box",
      "link": __webpack_require__(187)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@play@result@punch-number-desc",
      "link": __webpack_require__(189)
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "scene"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.aspect) + _vm._s(_vm.fov) + _vm._s(_vm.z))])
},staticRenderFns: []}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full"
  }, [_c('div', {
    class: {
      'full-v': _vm.appState.useCMS, 'full': !_vm.appState.useCMS
    }
  }, [(_vm.appState.useCMS) ? _c('Controllers', {
    on: {
      "api": function (v) {
        _vm.apis.controllers = v
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isBigEnough) ? _c('div', {
    staticClass: "full"
  }, [_c('img', {
    staticClass: "mocker-title",
    attrs: {
      "src": __webpack_require__(475)
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "mocker"
  }, [_c('div', {
    staticClass: "maxer"
  }, [_c('GLView', {
    on: {
      "refresh": function (v) {
        _vm.refresh.maxer1 = v
      },
      "glClick": _vm.passer
    }
  })], 1)])]), _vm._v(" "), _c('img', {
    staticClass: "mocker-logo",
    attrs: {
      "src": __webpack_require__(474)
    }
  })]) : _c('div', {
    staticClass: "mocker-mobile"
  }, [_c('div', {
    staticClass: "maxer"
  }, [_c('GLView', {
    on: {
      "refresh": function (v) {
        _vm.refresh.maxer1 = v
      },
      "glClick": _vm.passer
    }
  })], 1)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": _vm.pageFadeIn,
      "leave": _vm.pageFadeOut
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "page-content"
  }, [_c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@daily-task@top@title",
      "link": __webpack_require__(502)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@daily-task@task@daily-task",
      "link": __webpack_require__(501)
    }
  }), _vm._v(" "), _c('Slider', {
    on: {
      "exec": function (v) {
        _vm.execStack.slider = v
      },
      "setMouse": function (v) {
        _vm.mouseStack.slider = v
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "container full"
  }, [_c('keep-alive', [_c('router-view', {
    tag: "component",
    attrs: {
      "aspect": _vm.aspect,
      "rect": _vm.rect,
      "renderer": _vm.renderer
    },
    on: {
      "glClick": function (v) {
        _vm.$emit('glClick', v)
      },
      "setMouse": function (v) {
        _vm.setMouse = v
      },
      "exec": function (v) {
        _vm.exec = v
      },
      "scene": function (v) {
        _vm.scene = v
      },
      "camera": function (v) {
        _vm.camera = v
      }
    }
  })], 1), _vm._v(" "), (_vm.keepRenderer) ? _c('WebGLRenderer', {
    attrs: {
      "rect": _vm.rect,
      "camera": _vm.camera,
      "scene": _vm.scene
    },
    on: {
      "renderer": function (v) {
        _vm.renderer = v
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": _vm.pageFadeIn,
      "leave": _vm.pageFadeOut
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "page-content"
  }, [_c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@comic-list@header@hero",
      "link": __webpack_require__(496)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@comic-list@title@title",
      "link": __webpack_require__(497)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {
        _vm.$router.push({
          path: '/nike/game/comic-detail/1'
        })
      },
      "vms": "@comic-list@link@l-1",
      "link": __webpack_require__(92)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {
        _vm.$router.push({
          path: '/nike/game/comic-detail/2'
        })
      },
      "vms": "@comic-list@link@l-2",
      "link": __webpack_require__(93)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {
        _vm.$router.push({
          path: '/nike/game/comic-detail/3'
        })
      },
      "vms": "@comic-list@link@l-3",
      "link": __webpack_require__(94)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {
        _vm.$router.push({
          path: '/nike/game/comic-detail/4'
        })
      },
      "vms": "@comic-list@link@l-4",
      "link": __webpack_require__(95)
    },
    on: {
      "final-position": function (item) {
        _vm.tryMaximiseScroller(item);
        _vm.scrollerState.bound.yMax -= 35;
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "raycaster"
  })
},staticRenderFns: []}

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": function (el, done) {
        _vm.pageFadeIn(el, done);
        _vm.animateAll();
      },
      "leave": _vm.pageFadeOut
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "sub-page-content"
  }, [_c('ShakeMesh', {
    ref: "@play@start@hold-tight",
    attrs: {
      "gclick": function () {},
      "vms": "@play@start@hold-tight",
      "link": __webpack_require__(503)
    },
    on: {
      "shake": function (v) {
        _vm.shakeStack.s1 = v
      },
      "exec": function (v) {
        _vm.execStack.s1 = v
      }
    }
  }), _vm._v(" "), _c('ShakeMesh', {
    ref: "@play@start@start-icon",
    attrs: {
      "gclick": function () {},
      "vms": "@play@start@start-icon",
      "link": __webpack_require__(192)
    },
    on: {
      "shake": function (v) {
        _vm.shakeStack.s2 = v
      },
      "exec": function (v) {
        _vm.execStack.s2 = v
      }
    }
  }), _vm._v(" "), _c('ImageMesh', {
    ref: "@play@start@hider",
    attrs: {
      "gclick": function () {},
      "vms": "@play@start@hider",
      "blending": _vm.THREE.NormalBlending,
      "opacity": 1,
      "depthTest": true,
      "transparent": true,
      "position": {
        x: 0,
        y: -32.7,
        z: -1
      },
      "link": __webpack_require__(191)
    },
    on: {
      "ready": function () {}
    }
  }), _vm._v(" "), _c('ImageMesh', {
    ref: "@play@start@white-ball",
    attrs: {
      "gclick": function () {},
      "vms": "@play@start@white-ball",
      "blending": _vm.THREE.NormalBlending,
      "opacity": 0,
      "depthTest": true,
      "transparent": true,
      "link": __webpack_require__(194)
    },
    on: {
      "ready": function () {}
    }
  }), _vm._v(" "), _c('ImageMesh', {
    ref: "@play@start@white-ball-text",
    attrs: {
      "gclick": function () {
        _vm.$router.push({
          path: '/nike/game/play/countdown'
        })
      },
      "vms": "@play@start@white-ball-text",
      "blending": _vm.THREE.NormalBlending,
      "opacity": 0,
      "depthTest": true,
      "transparent": true,
      "link": __webpack_require__(193)
    },
    on: {
      "ready": function () {}
    }
  }), _vm._v(" "), _c('StartAnimation', {
    ref: "@play@canvas@start-canvas",
    attrs: {
      "vms": "@play@canvas@start-canvas"
    },
    on: {
      "exec": function (v) {
        this$1.execStack.startAnimation = v
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "scene-root"
  }, [_c('PerspectiveCamera', {
    attrs: {
      "fov": 75,
      "aspect": _vm.aspect,
      "near": 1,
      "far": 1000
    },
    on: {
      "camera": function (v) {
        _vm.camera = v;
      }
    }
  }), _vm._v(" "), _c('Scene', {
    on: {
      "scene": function (v) {
        _vm.scene = v;
      }
    }
  }, [_c('Mesh', {
    ref: "mesh-1"
  }, [_c('MeshPhongMaterial', {
    attrs: {
      "opacity": 0
    }
  }), _vm._v(" "), _c('SphereGeometry')], 1), _vm._v(" "), _c('PointLight')], 1), _vm._v(" "), (_vm.camera && _vm.scene) ? _c('Raycaster', {
    attrs: {
      "camera": _vm.camera,
      "scene": _vm.scene
    },
    on: {
      "setMouse": function (v) {
        _vm.$emit('setMouse', v);
        _vm.setMouse = v;
      },
      "hover": function (v) {
        _vm.hover = v
      },
      "glClick": _vm.handleHit
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "points"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": function (el, done) {
        _vm.pageFadeIn(el, done);
        _vm.animateAll();
      },
      "leave": _vm.pageFadeOut
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "page-content"
  }, [_c('ShakeMesh', {
    ref: "@agree@header@title",
    attrs: {
      "gclick": function () {},
      "vms": "@agree@header@title",
      "link": __webpack_require__(477)
    },
    on: {
      "shake": function (v) {
        _vm.shakeStack.title1 = v
      },
      "exec": function (v) {
        _vm.execStack.title1 = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@agree@header@title2",
    attrs: {
      "gclick": function () {},
      "vms": "@agree@header@title2",
      "link": __webpack_require__(478)
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.title2 = v
      },
      "exec": function (v) {
        _vm.execStack.titl2 = v
      }
    }
  }), _vm._v(" "), _c('ShakeMesh', {
    ref: "@agree@bg@rex",
    attrs: {
      "gclick": function () {},
      "vms": "@agree@bg@rex",
      "link": __webpack_require__(162)
    },
    on: {
      "shake": function (v) {
        _vm.shakeStack.rexBG = v
      },
      "exec": function (v) {
        _vm.execStack.rexBG = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@agree@tagline@title",
    attrs: {
      "gclick": function () {},
      "vms": "@agree@tagline@title",
      "link": __webpack_require__(166)
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.tagline = v
      },
      "exec": function (v) {
        _vm.execStack.tagline = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@agree@desc@punch-icon",
    attrs: {
      "gclick": function () {},
      "vms": "@agree@desc@punch-icon",
      "link": __webpack_require__(164)
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.punchIcon = v
      },
      "exec": function (v) {
        _vm.execStack.punchIcon = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@agree@desc@punch-about",
    attrs: {
      "gclick": function () {},
      "vms": "@agree@desc@punch-about",
      "link": __webpack_require__(163)
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.punchAbout = v
      },
      "exec": function (v) {
        _vm.execStack.punchAbout = v
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    ref: "@agree@grunge@bg",
    attrs: {
      "vms": "@agree@grunge@bg",
      "gOpacity": 0.53,
      "color": 0xefefef
    },
    on: {
      "exec": function (v) {
        _vm.execStack.grungeBg = v
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    ref: "@agree@grunge@punch-icon",
    attrs: {
      "vms": "@agree@grunge@punch-icon",
      "gOpacity": 0.9,
      "color": 0xefefef
    },
    on: {
      "exec": function (v) {
        _vm.execStack.grungePunchIcon = v
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    ref: "@agree@grunge@punch-about",
    attrs: {
      "vms": "@agree@grunge@punch-about",
      "gOpacity": 0.9,
      "color": 0xefefef
    },
    on: {
      "exec": function (v) {
        _vm.execStack.grungePunchAbout = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@agree@grunge@enter-now",
    attrs: {
      "vms": "@agree@grunge@enter-now",
      "link": __webpack_require__(165),
      "gclick": function () {
        _vm.$router.push('/nike/game/login')
      }
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.enterNow = v
      },
      "exec": function (v) {
        _vm.execStack.enterNow = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@agree@agree@box-unchecked",
    attrs: {
      "d-visible": !_vm.checkedBox,
      "gclick": function () {
        _vm.toggleBox()
      },
      "vms": "@agree@agree@box-unchecked",
      "link": __webpack_require__(161)
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.uncheckBox = v
      },
      "exec": function (v) {
        _vm.execStack.uncheckBox = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@agree@agree@box-checked",
    attrs: {
      "d-visible": _vm.checkedBox,
      "gclick": function () {
        _vm.toggleBox()
      },
      "vms": "@agree@agree@box-checked",
      "link": __webpack_require__(160)
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.checkedBox = v
      },
      "exec": function (v) {
        _vm.execStack.checkedBox = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@agree@agree@agree-rule",
    attrs: {
      "gclick": function () {
        _vm.$router.push('/nike/game/rules')
      },
      "vms": "@agree@agree@agree-rule",
      "link": __webpack_require__(159)
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.agreeRule = v
      },
      "exec": function (v) {
        _vm.execStack.agreeRule = v
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('CanvasMesh', {
    attrs: {
      "vms": _vm.vms,
      "canvas": _vm.api.canvas
    },
    on: {
      "texture": function (v) {
        _vm.texture = v
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hidden"
  }, [_c('ImageMesh', {
    ref: "menu-open",
    attrs: {
      "vms": "@menu@menu-trigger",
      "d-gclick": "() => { showFSMenu = !showFSMenu; }",
      "link": __webpack_require__(516)
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    ref: "menu-gradient",
    attrs: {
      "depthTest": false,
      "blending": _vm.THREE.AdditiveBlending,
      "vms": "@menu@red-gradient",
      "opacity": 0.5,
      "gclick": function () {},
      "link": __webpack_require__(519)
    },
    on: {
      "exec": function (v) {
        _vm.execStack.red = v
      }
    }
  }), _vm._v(" "), _c('Mesh', {
    ref: "red-box",
    attrs: {
      "gclick": function () {
        _vm.showFSMenu = !_vm.showFSMenu;
      },
      "position": {
        x: 32.5 * _vm.aspect,
        y: 35.2,
        z: 0.3
      }
    }
  }, [_c('PlaneGeometry', {
    attrs: {
      "width": 6,
      "height": 6
    }
  }), _vm._v(" "), _c('MeshBasicMaterial', {
    attrs: {
      "opacity": 0.0,
      "color": 0x000000
    }
  })], 1), _vm._v(" "), _c('transition', {
    on: {
      "enter": _vm.menuIn,
      "leave": _vm.menuOut
    }
  }, [_c('keep-alive', [(!_vm.showFSMenu) ? _c('Object3D', {
    ref: "nav-bar",
    attrs: {
      "position": {
        x: 0,
        y: 35.2,
        z: 0
      }
    }
  }, [_c('ImageMesh', {
    ref: "nike-logo",
    attrs: {
      "vms": "@menu@nike-logo",
      "aspect": _vm.aspect,
      "gclick": function (v) {
        _vm.$router.push('/nike/game')
      },
      "d-position": {
        x: -22.5 * _vm.aspect,
        y: 0,
        z: 0
      },
      "d-scale": {
        x: 1 / 3,
        y: 1 / 3,
        z: 1.0
      },
      "link": __webpack_require__(517)
    }
  }), _vm._v(" "), _c('Mesh', {
    ref: "nav-red-line",
    attrs: {
      "position": {
        x: 0,
        y: -3.3,
        z: 0.3
      }
    }
  }, [_c('PlaneGeometry', {
    attrs: {
      "width": 55,
      "height": 0.2
    }
  }), _vm._v(" "), _c('MeshBasicMaterial', {
    attrs: {
      "opacity": 1,
      "color": 0xee3932
    }
  })], 1), _vm._v(" "), _c('Mesh', {
    ref: "nav-grey-box",
    attrs: {
      "position": {
        x: 0,
        y: 0,
        z: 0.06
      }
    }
  }, [_c('PlaneGeometry', {
    attrs: {
      "width": 55,
      "height": 6.45
    }
  }), _vm._v(" "), _c('MeshBasicMaterial', {
    attrs: {
      "opacity": 0.7,
      "blending": _vm.THREE.NormalBlending,
      "color": 0x010101
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    on: {
      "enter": _vm.fsMenuIn,
      "leave": _vm.fsMenuOut
    }
  }, [_c('keep-alive', [(_vm.showFSMenu) ? _c('Object3D', {
    ref: "fs-menu",
    attrs: {
      "position": {
        x: 0,
        y: 0,
        z: 0.1
      }
    }
  }, [_c('Mesh', {
    ref: "nav-grey-box-2",
    attrs: {
      "position": {
        x: 0,
        y: 0,
        z: 0.05
      }
    }
  }, [_c('PlaneGeometry', {
    attrs: {
      "width": 55,
      "height": 155
    }
  }), _vm._v(" "), _c('MeshBasicMaterial', {
    attrs: {
      "opacity": 0.85,
      "blending": _vm.THREE.NormalBlending,
      "color": 0x010101
    }
  })], 1), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@menu@content@grunge@menu-bg",
      "gclick": function () {}
    },
    on: {
      "exec": function (v) {
        if (_vm.showFSMenu) {
          _vm.execStack.grungeCouponBox = v;
        }
      }
    }
  }), _vm._v(" "), _c('ImageMesh', {
    ref: "fs-menu-close",
    attrs: {
      "vms": "@menu@fs-menu-close",
      "gclick": function () {
        if (_vm.showFSMenu || !_vm.tweening) {
          _vm.showFSMenu = !_vm.showFSMenu;
        }
      },
      "link": __webpack_require__(518)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@menu@items@home",
      "gclick": function () {
        if (_vm.showFSMenu) {
          _vm.showFSMenu = !_vm.showFSMenu;
          _vm.$router.push('/nike/game');
        }
      },
      "link": __webpack_require__(198)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@menu@items@boxing-camp",
      "gclick": function () {
        if (_vm.showFSMenu) {
          _vm.showFSMenu = !_vm.showFSMenu;
          _vm.$router.push('/nike/game/agree');
        }
      },
      "scale": {
        x: 0.5,
        y: 0.5,
        z: 1.0
      },
      "link": __webpack_require__(196)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@menu@items@rules",
      "gclick": function () {
        if (_vm.showFSMenu) {
          _vm.showFSMenu = !_vm.showFSMenu;
          _vm.$router.push('/nike/game/rules');
        }
      },
      "link": __webpack_require__(200)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@menu@items@rewards",
      "gclick": function () {
        if (_vm.showFSMenu) {
          _vm.showFSMenu = !_vm.showFSMenu;
          _vm.$router.push('/nike/game/status');
        }
      },
      "aspect": _vm.aspect,
      "link": __webpack_require__(199)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@menu@items@comics",
      "gclick": function () {
        if (_vm.showFSMenu) {
          _vm.showFSMenu = !_vm.showFSMenu;
          _vm.$router.push('/nike/game/comic-list');
        }
      },
      "aspect": _vm.aspect,
      "link": __webpack_require__(197)
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('ImageMesh', {
    ref: "slider-handle",
    attrs: {
      "gTS": _vm.onGTS,
      "vms": "@daily-task@slider@arrow-btn",
      "link": __webpack_require__(498)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "visible": !_vm.slider.redeemed,
      "gclick": function () {},
      "vms": "@daily-task@slider@staff-only",
      "link": __webpack_require__(500)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "visible": _vm.slider.redeemed,
      "gclick": function () {},
      "vms": "@daily-task@slider@redeemed",
      "link": __webpack_require__(499)
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@daily-task@grunge@slider",
      "gclick": function () {}
    },
    on: {
      "exec": function (v) {
        _vm.execStack.slider = v
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": _vm.onPageEnter,
      "leave": _vm.pageFadeOut
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "sub-page-content"
  }, [_c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@play@record@punch-num-desc",
      "link": __webpack_require__(178)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@play@record@time-remain-desc",
      "link": __webpack_require__(179)
    }
  }), _vm._v(" "), _c('RingCounter', {
    ref: "ring",
    attrs: {
      "totalTime": 30000,
      "vms": "@play@record@ring-counter"
    },
    on: {
      "done": function () {
        if (_vm.isViewingPage) {
          // $router.push({ path: '/nike/game/play' })
        }
      }
    }
  }), _vm._v(" "), _c('NumberCounter', {
    ref: "number-counter",
    attrs: {
      "totalTime": 3000 * 10,
      "vms": "@play@record@number-counter"
    },
    on: {
      "done": function () {
        if (_vm.isViewingPage) {
          _vm.playSound();
          _vm.$router.push({
            path: ("/nike/game/play/result?punch=" + (_vm.state.count))
          });
        }
      }
    }
  }), _vm._v(" "), _c('NumberCounter', {
    ref: "punch-counter",
    attrs: {
      "word": _vm.state.count,
      "vms": "@play@record@punch-counter"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "object3d"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": function (el, done) {
        _vm.pageFadeIn(el, done);
        _vm.animateAll();
      },
      "leave": _vm.pageFadeOut
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "page-content"
  }, [_c('ShakeMesh', {
    ref: "@landing@shake@nike",
    attrs: {
      "vms": "@landing@shake@nike",
      "link": __webpack_require__(490)
    },
    on: {
      "shake": function (v) {
        _vm.shakeStack.s1 = v
      },
      "exec": function (v) {
        _vm.execStack.s1 = v
      }
    }
  }), _vm._v(" "), _c('ShakeMesh', {
    ref: "@landing@shake@boxing",
    attrs: {
      "vms": "@landing@shake@boxing",
      "link": __webpack_require__(488)
    },
    on: {
      "shake": function (v) {
        _vm.shakeStack.s2 = v
      },
      "exec": function (v) {
        _vm.execStack.s2 = v
      }
    }
  }), _vm._v(" "), _c('ShakeMesh', {
    ref: "@landing@shake@camp",
    attrs: {
      "vms": "@landing@shake@camp",
      "link": __webpack_require__(489)
    },
    on: {
      "shake": function (v) {
        _vm.shakeStack.s3 = v
      },
      "exec": function (v) {
        _vm.execStack.s3 = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@landing@reveal@box-txt-1",
    attrs: {
      "vms": "@landing@reveal@box-txt-1",
      "link": __webpack_require__(486)
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.r1 = v
      },
      "exec": function (v) {
        _vm.execStack.r1 = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@landing@reveal@box-txt-2",
    attrs: {
      "vms": "@landing@reveal@box-txt-2",
      "link": __webpack_require__(487)
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.r2 = v
      },
      "exec": function (v) {
        _vm.execStack.r2 = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@landing@reveal@box-btn-game",
    attrs: {
      "vms": "@landing@reveal@box-btn-game",
      "gclick": function (v) {
        _vm.$router.push('/nike/game/agree')
      },
      "link": __webpack_require__(485)
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.r3 = v
      },
      "exec": function (v) {
        _vm.execStack.r3 = v
      }
    }
  }), _vm._v(" "), _c('RevealMesh', {
    ref: "@landing@reveal@box-btn-comics",
    attrs: {
      "vms": "@landing@reveal@box-btn-comics",
      "gclick": function (v) {
        _vm.$router.push('/nike/game/comic-list')
      },
      "link": __webpack_require__(484)
    },
    on: {
      "reveal": function (v) {
        _vm.revealStack.r4 = v
      },
      "exec": function (v) {
        _vm.execStack.r4 = v
      }
    }
  }), _vm._v(" "), _c('BoxingArea', {
    ref: "boxing-area",
    attrs: {
      "vms": "@landing@shake@box-canvas"
    }
  }), _vm._v(" "), _c('ImageMesh', {
    ref: "@landing@bg@boxing",
    attrs: {
      "vms": "@landing@bg@boxing",
      "link": __webpack_require__(167)
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@landing@grunge@bg",
      "gOpacity": 0.53,
      "color": 0xbababa
    },
    on: {
      "exec": function (v) {
        _vm.execStack.grungeBg = v
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('CanvasMesh', {
    attrs: {
      "vms": _vm.vms,
      "canvas": _vm.api.canvas
    },
    on: {
      "texture": function (v) {
        _vm.texture = v
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "particle-sea"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "mounter",
    staticClass: "webgl-renderer"
  })
},staticRenderFns: []}

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": _vm.pageFadeIn,
      "leave": _vm.pageFadeOut
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "page-content"
  }, [_c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@rules@top@title",
      "link": __webpack_require__(509)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@rules@rules@30sec",
      "link": __webpack_require__(504)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@rules@rules@fb-share",
      "link": __webpack_require__(505)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@rules@rules@nike-store",
      "link": __webpack_require__(506)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@rules@rules@terms-title",
      "link": __webpack_require__(508)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@rules@rules@terms-text",
      "link": __webpack_require__(507)
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@rules@grunge@rule-box-r1",
      "gclick": function () {}
    },
    on: {
      "exec": function (v) {
        _vm.execStack.r1 = v
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@rules@grunge@rule-box-r2",
      "gclick": function () {}
    },
    on: {
      "exec": function (v) {
        _vm.execStack.r2 = v
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@rules@grunge@rule-box-r3",
      "gclick": function () {}
    },
    on: {
      "exec": function (v) {
        _vm.execStack.r3 = v
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@rules@grunge@terms-box",
      "gclick": function () {}
    },
    on: {
      "final-position": function (ref) {
        var pos = ref.pos;
        var params = ref.params;

        _vm.tryMaximiseScroller({
          pos: pos,
          params: params,
          extra: -15
        })
      },
      "exec": function (v) {
        _vm.execStack.terms = v
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "mesh"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": _vm.onPageEnter,
      "leave": _vm.pageFadeOut
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "sub-page-content"
  }, [_c('RingCounter', {
    ref: "ring-counter",
    attrs: {
      "totalTime": 3000,
      "vms": "@play@countdown@ring-counter"
    },
    on: {
      "done": function () {
        if (_vm.isViewingPage) {
          _vm.$router.push({
            path: '/nike/game/play/record'
          })
        }
      }
    }
  }), _vm._v(" "), _c('NumberCounter', {
    ref: "number-counter",
    attrs: {
      "totalTime": 3000,
      "vms": "@play@countdown@number-counter"
    },
    on: {
      "done": function () {
        if (_vm.isViewingPage) {
          // $router.push({ path: '/nike/game/play/record' })
        }
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "particle-sea"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "scene-root"
  }, [_c('PerspectiveCamera', {
    attrs: {
      "fov": 75,
      "aspect": _vm.aspect,
      "near": 1,
      "far": 1000,
      "position": {
        x: 0,
        y: 0,
        z: 165
      }
    },
    on: {
      "camera": function (v) {
        _vm.camera = v;
      }
    }
  }), _vm._v(" "), _c('Scene', {
    on: {
      "scene": function (v) {
        _vm.scene = v;
      }
    }
  }, [(_vm.renderer) ? _c('ParticleSea', {
    attrs: {
      "renderer": _vm.renderer
    },
    on: {
      "api": function (v) {
        _vm.particleSea = v
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "controllers"
  }, [(!_vm.appState.loggedIn) ? _c('div', [(_vm.appState.loading) ? _c('h1', [_vm._v("Loading....")]) : _vm._e(), _vm._v(" "), (!_vm.appState.loading) ? _c('button', {
    staticClass: "login-btn",
    on: {
      "click": function($event) {
        _vm.backend.loginToGoogle()
      }
    }
  }, [_vm._v("Login")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.appState.loggedIn) ? _c('div', [(!_vm.vmsObj) ? _c('h3', [_vm._v("Select style or click an object to start editing")]) : _vm._e(), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedStyle),
      expression: "selectedStyle"
    }],
    staticClass: "style-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedStyle = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.filteredStyles), function(style, key) {
    return _c('option', {
      key: key,
      domProps: {
        "selected": style.name === _vm.selectedStyle,
        "value": style.name
      }
    }, [_vm._v(_vm._s(style.name))])
  })), _vm._v("\n      Filter Styles\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.styleFilterQuery),
      expression: "styleFilterQuery"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.styleFilterQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.styleFilterQuery = $event.target.value
      }
    }
  }), _vm._v("\n      Use click action\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appState.useClick),
      expression: "appState.useClick"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.appState.useClick) ? _vm._i(_vm.appState.useClick, null) > -1 : (_vm.appState.useClick)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.appState.useClick,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.appState.useClick = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.appState.useClick = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.appState.useClick = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.vmsObj) ? _c('div', {
    staticClass: "rangers"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.position.x),
      expression: "vmsObj.position.x"
    }],
    staticClass: "slider",
    attrs: {
      "type": "range",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.position.x)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": _vm.refresher,
      "__r": function($event) {
        _vm.vmsObj.position.x = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.position.x),
      expression: "vmsObj.position.x"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.position.x)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.position.x = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.position.x_formula),
      expression: "vmsObj.position.x_formula"
    }],
    staticClass: "formula",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.position.x_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.position.x_formula = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v("\n        X Pos\n      ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.position.y),
      expression: "vmsObj.position.y"
    }],
    staticClass: "slider",
    attrs: {
      "type": "range",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.position.y)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": _vm.refresher,
      "__r": function($event) {
        _vm.vmsObj.position.y = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.position.y),
      expression: "vmsObj.position.y"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.position.y)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.position.y = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.position.y_formula),
      expression: "vmsObj.position.y_formula"
    }],
    staticClass: "formula",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.position.y_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.position.y_formula = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v("\n        Y Pos\n      ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.position.z),
      expression: "vmsObj.position.z"
    }],
    staticClass: "slider",
    attrs: {
      "type": "range",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.position.z)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": _vm.refresher,
      "__r": function($event) {
        _vm.vmsObj.position.z = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.position.z),
      expression: "vmsObj.position.z"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.position.z)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.position.z = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.position.z_formula),
      expression: "vmsObj.position.z_formula"
    }],
    staticClass: "formula",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.position.z_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.position.z_formula = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v("\n        Z Pos\n      ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.translate.x),
      expression: "vmsObj.translate.x"
    }],
    staticClass: "slider",
    attrs: {
      "type": "range",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.translate.x)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": _vm.refresher,
      "__r": function($event) {
        _vm.vmsObj.translate.x = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.translate.x),
      expression: "vmsObj.translate.x"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.translate.x)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.translate.x = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.translate.x_formula),
      expression: "vmsObj.translate.x_formula"
    }],
    staticClass: "formula",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.translate.x_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.translate.x_formula = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v("\n        X Translate\n      ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.translate.y),
      expression: "vmsObj.translate.y"
    }],
    staticClass: "slider",
    attrs: {
      "type": "range",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.translate.y)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": _vm.refresher,
      "__r": function($event) {
        _vm.vmsObj.translate.y = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.translate.y),
      expression: "vmsObj.translate.y"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text",
      "step": "0.1",
      "min": "-100",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.translate.y)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.translate.y = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.translate.y_formula),
      expression: "vmsObj.translate.y_formula"
    }],
    staticClass: "formula",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.translate.y_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.translate.y_formula = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v("\n        Y Translate\n      ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.grunge.gOpacity),
      expression: "vmsObj.grunge.gOpacity"
    }],
    staticClass: "slider",
    attrs: {
      "type": "range",
      "step": "0.1",
      "min": "0.1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.grunge.gOpacity)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": _vm.refresher,
      "__r": function($event) {
        _vm.vmsObj.grunge.gOpacity = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.grunge.gOpacity),
      expression: "vmsObj.grunge.gOpacity"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text",
      "step": "0.1",
      "min": "0.1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.vmsObj.grunge.gOpacity)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.grunge.gOpacity = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.grunge.gOpacity_formula),
      expression: "vmsObj.grunge.gOpacity_formula"
    }],
    staticClass: "formula",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.grunge.gOpacity_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.grunge.gOpacity_formula = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v("\n        Grunge Opacity\n      ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.grunge.gColor_formula),
      expression: "vmsObj.grunge.gColor_formula"
    }],
    staticClass: "formula",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.grunge.gColor_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.grunge.gColor_formula = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v("\n        Grunge Hex Color e.g.) 0xbababa\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.vmsObj && _vm.vmsObj.scale) ? _c('div', {
    staticClass: "rangers"
  }, [_c('div', [_vm._v("\n        Scale X:\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.scale.x_formula),
      expression: "vmsObj.scale.x_formula"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.scale.x_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.scale.x_formula = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v("\n        Scale Y:\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.scale.y_formula),
      expression: "vmsObj.scale.y_formula"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.scale.y_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.scale.y_formula = $event.target.value
      }, _vm.refresher]
    }
  })]), _vm._v(" "), _c('div', [_vm._v("\n        Size X:\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.size.x_formula),
      expression: "vmsObj.size.x_formula"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.size.x_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.size.x_formula = $event.target.value
      }, _vm.refresher]
    }
  }), _vm._v("\n        Size Y:\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vmsObj.size.y_formula),
      expression: "vmsObj.size.y_formula"
    }],
    staticClass: "slider",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vmsObj.size.y_formula)
    },
    on: {
      "change": function($event) {
        _vm.save(_vm.vmsObj)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vmsObj.size.y_formula = $event.target.value
      }, _vm.refresher]
    }
  })])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "scene-root"
  }, [_c('PerspectiveCamera', {
    attrs: {
      "fov": 75,
      "aspect": _vm.aspect,
      "near": 1,
      "far": 1000
    },
    on: {
      "camera": function (v) {
        _vm.camera = v;
      }
    }
  }), _vm._v(" "), _c('Scene', {
    on: {
      "scene": function (v) {
        _vm.scene = v;
      }
    }
  }, [_c('Points', {
    ref: "ball-p"
  }, [_c('SphereGeometry'), _vm._v(" "), _c('PointsMaterial', {
    attrs: {
      "color": 0x00ff00,
      "opacity": 0
    }
  })], 1), _vm._v(" "), _c('Points', {
    ref: "box-p"
  }, [_c('BoxGeometry'), _vm._v(" "), _c('PointsMaterial', {
    attrs: {
      "color": 0xff00ff,
      "opacity": 0
    }
  })], 1)], 1), _vm._v(" "), (_vm.camera && _vm.scene) ? _c('Raycaster', {
    attrs: {
      "camera": _vm.camera,
      "scene": _vm.scene
    },
    on: {
      "setMouse": function (v) {
        _vm.$emit('setMouse', v);
        _vm.setMouse = v
      },
      "hover": function (v) {
        _vm.hover = v
      },
      "glClick": _vm.handleHit
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": _vm.pageFadeIn,
      "leave": _vm.pageFadeOut
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "page-content"
  }, [_c('ImageMesh', {
    attrs: {
      "vms": "@status@checkstatus@my-records",
      "gclick": function () {},
      "link": __webpack_require__(514)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@status@checkstatus@j5",
      "gclick": function () {},
      "link": __webpack_require__(511)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@status@checkstatus@j7",
      "gclick": function () {},
      "link": __webpack_require__(512)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@status@checkstatus@j9",
      "gclick": function () {},
      "link": __webpack_require__(513)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@status@checkstatus@btn-rule",
      "gclick": function () {},
      "link": __webpack_require__(510)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@status@checkstatus@btn-nike",
      "gclick": function () {},
      "link": __webpack_require__(195)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@status@checkstatus@btn-nike",
      "gclick": function () {},
      "link": __webpack_require__(195)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "vms": "@status@checkstatus@rules-text",
      "gclick": function () {},
      "link": __webpack_require__(515)
    },
    on: {
      "final-position": function (ref) {
        var pos = ref.pos;
        var params = ref.params;

        _vm.tryMaximiseScroller({
          pos: pos,
          params: params,
          extra: 45
        })
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@status@grunge@coupon-box-j5",
      "gclick": function () {}
    },
    on: {
      "exec": function (v) {
        _vm.execStack.j5 = v
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@status@grunge@coupon-box-j7",
      "gclick": function () {}
    },
    on: {
      "exec": function (v) {
        _vm.execStack.j7 = v
      }
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@status@grunge@coupon-box-j9",
      "gclick": function () {}
    },
    on: {
      "exec": function (v) {
        _vm.execStack.j9 = v
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Mesh', {
    attrs: {
      "vms": _vm.vms,
      "position": _vm.finalPosition,
      "scale": _vm.finalScale,
      "gclick": _vm.gclick
    },
    on: {
      "mesh": function (v) {
        _vm.mesh = v
      }
    }
  }, [(_vm.ready) ? _c('PlaneGeometry', {
    attrs: {
      "width": _vm.finalSize.x,
      "height": _vm.finalSize.y,
      "translate": _vm.finalTranslate,
      "scale": _vm.scale
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('MeshCanvasMaterial', {
    attrs: {
      "canvas": _vm.canvas,
      "color": _vm.color,
      "image": _vm.link
    },
    on: {
      "exec": function (v) {
        _vm.$emit('exec', v)
      },
      "texture": function (v) {
        _vm.$emit('texture', v)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": _vm.pageFadeIn,
      "leave": _vm.pageFadeOut
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "page-content"
  }, [_c('Object3D', {
    ref: "comics-content"
  }, [_c('ImageMesh', {
    ref: "s-1",
    attrs: {
      "visible": _vm.isAtPage(1),
      "vms": "@comic-detail@comics@s-1",
      "link": __webpack_require__(491)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    ref: "s-2",
    attrs: {
      "visible": _vm.isAtPage(2),
      "vms": "@comic-detail@comics@s-2",
      "link": __webpack_require__(492)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    ref: "s-3",
    attrs: {
      "visible": _vm.isAtPage(3),
      "vms": "@comic-detail@comics@s-3",
      "link": __webpack_require__(493)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    ref: "s-4",
    attrs: {
      "visible": _vm.isAtPage(4),
      "vms": "@comic-detail@comics@s-4",
      "link": __webpack_require__(494)
    }
  })], 1), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "visible": !_vm.isAtPage(1),
      "gclick": function () {
        _vm.goComics('1')
      },
      "vms": "@comic-detail@link@l-1",
      "link": __webpack_require__(92)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "visible": !_vm.isAtPage(2),
      "gclick": function () {
        _vm.goComics('2')
      },
      "vms": "@comic-detail@link@l-2",
      "link": __webpack_require__(93)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "visible": !_vm.isAtPage(3),
      "gclick": function () {
        _vm.goComics('3')
      },
      "vms": "@comic-detail@link@l-3",
      "link": __webpack_require__(94)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "visible": !_vm.isAtPage(4),
      "gclick": function () {
        _vm.goComics('4')
      },
      "vms": "@comic-detail@link@l-4",
      "link": __webpack_require__(95)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "visible": _vm.isAtPage(1),
      "gclick": function () {
        _vm.goComics('1')
      },
      "vms": "@comic-detail@active-link@l-1",
      "link": __webpack_require__(168)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "visible": _vm.isAtPage(2),
      "gclick": function () {
        _vm.goComics('2')
      },
      "vms": "@comic-detail@active-link@l-2",
      "link": __webpack_require__(169)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "visible": _vm.isAtPage(3),
      "gclick": function () {
        _vm.goComics('3')
      },
      "vms": "@comic-detail@active-link@l-3",
      "link": __webpack_require__(170)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "visible": _vm.isAtPage(4),
      "gclick": function () {
        _vm.goComics('4')
      },
      "vms": "@comic-detail@active-link@l-4",
      "link": __webpack_require__(171)
    },
    on: {
      "final-position": function (props) {
        _vm.tryMaximiseScroller(props);
        _vm.scrollerState.bound.yMax -= 40;
      }
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@comic-detail@share@share",
      "link": __webpack_require__(495)
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@comic-detail@grunge@share-fb",
      "gOpacity": 0.9,
      "color": 0xefefef
    },
    on: {
      "exec": function (v) {
        _vm.execStack.grungeShareFB = v
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Mesh', {
    attrs: {
      "vms": _vm.vms,
      "position": _vm.finalPosition,
      "scale": _vm.finalScale,
      "gclick": _vm.gclick
    },
    on: {
      "mesh": function (v) {
        _vm.mesh = v
      }
    }
  }, [(_vm.ready) ? _c('PlaneGeometry', {
    attrs: {
      "width": _vm.finalSize.x,
      "height": _vm.finalSize.y,
      "translate": _vm.finalTranslate,
      "scale": _vm.scale
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('MeshShakeMaterial', {
    attrs: {
      "image": _vm.link
    },
    on: {
      "exec": function (v) {
        _vm.$emit('exec', v)
      },
      "shake": function (v) {
        _vm.$emit('shake', v)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Mesh', {
    attrs: {
      "visible": _vm.visible,
      "vms": _vm.vms,
      "position": _vm.finalPosition,
      "scale": _vm.finalScale,
      "gclick": _vm.gclick,
      "gTS": _vm.gTS
    },
    on: {
      "mesh": function (v) {
        _vm.mesh = v;
      }
    }
  }, [(_vm.ready) ? _c('PlaneGeometry', {
    attrs: {
      "width": _vm.sWidth,
      "height": _vm.sHeight,
      "translate": _vm.finalTranslate,
      "scale": _vm.scale
    }
  }) : _vm._e(), _vm._v(" "), _c('MeshPictureMaterial', {
    attrs: {
      "opacity": 1,
      "color": 0xffffff,
      "image": _vm.link,
      "blending": _vm.blending,
      "depthTest": _vm.depthTest,
      "transparent": _vm.transparent,
      "blendEquation": _vm.blendEquation,
      "blendSrc": _vm.blendSrc,
      "blendDst": _vm.blendDst
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('CanvasMesh', {
    attrs: {
      "vms": _vm.vms,
      "canvas": _vm.api.canvas
    },
    on: {
      "texture": function (v) {
        _vm.texture = v
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('CanvasMesh', {
    attrs: {
      "vms": _vm.vms,
      "canvas": _vm.api.canvas
    },
    on: {
      "texture": function (v) {
        _vm.texture = v
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Mesh', {
    attrs: {
      "vms": _vm.vms,
      "position": _vm.finalPosition,
      "scale": _vm.finalScale,
      "gclick": _vm.gclick
    },
    on: {
      "mesh": function (v) {
        _vm.mesh = v
      }
    }
  }, [(_vm.ready) ? _c('PlaneGeometry', {
    attrs: {
      "width": _vm.finalSize.x,
      "height": _vm.finalSize.y,
      "translate": _vm.finalTranslate,
      "scale": _vm.scale
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('MeshRevealMaterial', {
    attrs: {
      "image": _vm.link
    },
    on: {
      "exec": function (v) {
        _vm.$emit('exec', v)
      },
      "reveal": function (v) {
        _vm.$emit('reveal', v)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": _vm.pageFadeIn,
      "leave": _vm.pageFadeOut
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "page-content"
  }, [_c('Woody', {
    ref: "woody",
    attrs: {
      "position": {
        x: 0,
        y: 0,
        z: 0.0
      }
    },
    on: {
      "api": function (v) {
        _vm.execStack.woody = v.render; /*mouseStack.woody = v.setMouse*/
      }
    }
  }), _vm._v(" "), _c('router-view', {
    ref: "sub-page-content",
    tag: "component",
    attrs: {
      "aspect": _vm.aspect,
      "camera": _vm.camera
    },
    on: {
      "setMouse": function (v) {
        _vm.mouseStack.currentSubPage = v
      },
      "exec": function (v) {
        _vm.execStack.currentSubPage = v
      },
      "punched": _vm.tweenWoody
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "scene-root"
  }, [_c('PerspectiveCamera', {
    attrs: {
      "fov": 75,
      "aspect": _vm.aspect,
      "near": 1,
      "far": 1000,
      "position": {
        x: 0,
        y: 0,
        z: 50
      }
    },
    on: {
      "camera": function (v) {
        _vm.camera = v;
      }
    }
  }), _vm._v(" "), _c('Scene', {
    attrs: {
      "aspect": _vm.aspect
    },
    on: {
      "scene": function (v) {
        _vm.scene = v;
      }
    }
  }, [_c('GLMenu', {
    attrs: {
      "aspect": _vm.aspect
    },
    on: {
      "exec": function (v) {
        _vm.execStack.glmenu = v
      },
      "showPage": function (v) {
        _vm.showPage = v
      }
    }
  }), _vm._v(" "), _c('keep-alive', [_c('router-view', {
    ref: "page-content",
    tag: "component",
    attrs: {
      "d-v-if": "showPage",
      "aspect": _vm.aspect,
      "camera": _vm.camera,
      "raycaster": _vm.raycaster
    },
    on: {
      "setMouse": function (v) {
        _vm.mouseStack.currentPage = v;
      },
      "exec": function (v) {
        _vm.execStack.currentPage = v
      }
    }
  })], 1)], 1), _vm._v(" "), (_vm.camera && _vm.scene) ? _c('Raycaster', {
    attrs: {
      "camera": _vm.camera,
      "scene": _vm.scene
    },
    on: {
      "raycaster": function (v) {
        _vm.raycaster = v;
      },
      "raycast": function (v) {
        _vm.execStack.raycast = v;
      },
      "setMouse": function (v) {
        _vm.mouseStack.raycaster = v;
      },
      "hover": function (v) {
        _vm.hover = v
      },
      "glClick": _vm.handleHit,
      "glTouchStart": _vm.handleTouchStart
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "scene-root"
  }, [_c('PerspectiveCamera', {
    attrs: {
      "fov": 75,
      "aspect": _vm.aspect,
      "near": 1,
      "far": 1000,
      "position": {
        x: 0,
        y: 0,
        z: 165
      }
    },
    on: {
      "camera": function (v) {
        _vm.camera = v;
      }
    }
  }), _vm._v(" "), _c('Scene', {
    on: {
      "scene": function (v) {
        _vm.scene = v;
      }
    }
  }, [(_vm.renderer) ? _c('Woody', {
    attrs: {
      "renderer": _vm.renderer
    },
    on: {
      "api": function (v) {
        _vm.woodyBall = v
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.camera && _vm.scene) ? _c('Raycaster', {
    attrs: {
      "camera": _vm.camera,
      "scene": _vm.scene
    },
    on: {
      "setMouse": function (v) {
        _vm.setRMouse = v;
      },
      "hover": function (v) {
        _vm.hover = v
      },
      "glClick": _vm.handleHit
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": function (el, done) {
        _vm.pageFadeIn(el, done);
        _vm.fadeInCurtain();
      },
      "leave": _vm.pageFadeOut
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "page-content"
  }, [_c('ImageMesh', {
    ref: "@login@bg@hider",
    attrs: {
      "gclick": function () {},
      "vms": "@login@bg@hider",
      "blending": _vm.THREE.NormalBlending,
      "opacity": 1,
      "depthTest": true,
      "transparent": true,
      "position": {
        x: 0,
        y: 10,
        z: -1
      },
      "link": __webpack_require__(172)
    },
    on: {
      "ready": function () {}
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@login@form@login-start-game",
      "link": __webpack_require__(176)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {
        _vm.demo('This is a demo website. You can click the red sbumit button.')
      },
      "vms": "@login@form@login-facebook",
      "link": __webpack_require__(174)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@login@form@login-field-desc",
      "link": __webpack_require__(175)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@login@form@login-email-text",
      "link": __webpack_require__(173)
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {
        _vm.$router.push({
          path: '/nike/game/play'
        })
      },
      "vms": "@login@form@login-submit",
      "link": __webpack_require__(177)
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@login@grunge@email-field",
      "gclick": function () {
        _vm.demo('This is a demo website. You can click the red sbumit button.')
      },
      "gOpacity": 1.0,
      "color": 0xffffff
    },
    on: {
      "exec": function (v) {
        _vm.execStack.grungeEnterNow = v
      }
    }
  }), _vm._v(" "), _c('Woody', {
    ref: "woody",
    attrs: {
      "position": {
        x: 0,
        y: 0,
        z: 0.0
      }
    },
    on: {
      "api": function (v) {
        _vm.execStack.woody = v.render; /*mouseStack.woody = v.setMouse*/
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "proto"
  }, [_c('h1', [_vm._v("Prototypes")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$route.fullPath))]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/prototypes/scene/ball"
    }
  }, [_vm._v("Ball")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/prototypes/scene/red"
    }
  }, [_vm._v("Red")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/prototypes/scene/fun"
    }
  }, [_vm._v("Fun")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/prototypes/scene/woody"
    }
  }, [_vm._v("Woody")])], 1), _vm._v(" "), _c('div', {
    staticClass: "fixed-box"
  }, [_c('div', {
    staticClass: "full"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full"
  }, [_c('GLView', {
    on: {
      "refresh": function (v) {
        _vm.refresh = v
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ })
],[235]);


// WEBPACK FOOTER //
// static/js/app.ee9c26147d0727da5c64.js